"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1166],{

/***/ 32903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var GoogleApis__Sheets__Schema$SmartcutsMacros = __webpack_require__(11815);
var _map = {
    "Overwrite": "OVERWRITE",
    "InsertRows": "INSERT_ROWS"
};
var _revMap = {
    "OVERWRITE": "Overwrite",
    "INSERT_ROWS": "InsertRows"
};
function tToJs(param) {
    return _map[param];
}
function tFromJs(param) {
    return _revMap[param];
}
var InsertDataOption = {
    tToJs: tToJs,
    tFromJs: tFromJs
};
var Append = {
    InsertDataOption: InsertDataOption
};
function append(accessToken, alt, fields, key, oauthToken, prettyPrint, quotaUser, range, spreadsheetId, uploadProtocol, uploadType, valueInputOption, insertDataOption, includeValuesInResponse, responseValueRenderOption, responseDateTimeRenderOption, valueRange, client) {
    return client.spreadsheets.values.append({
        access_token: accessToken,
        alt: alt,
        fields: fields,
        key: key,
        oauth_token: oauthToken,
        prettyPrint: prettyPrint,
        quotaUser: quotaUser,
        range: range,
        spreadsheetId: spreadsheetId,
        upload_protocol: uploadProtocol,
        uploadType: uploadType,
        valueInputOption: OptionUtils$SmartcutsMacros.map(valueInputOption, GoogleApis__Sheets__Schema$SmartcutsMacros.ValueInputOption.tToJs),
        insertDataOption: _map[insertDataOption],
        includeValuesInResponse: includeValuesInResponse,
        responseValueRenderOption: OptionUtils$SmartcutsMacros.map(responseValueRenderOption, GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRenderOption.tToJs),
        responseDateTimeRenderOption: OptionUtils$SmartcutsMacros.map(responseDateTimeRenderOption, GoogleApis__Sheets__Schema$SmartcutsMacros.DateTimeRenderOption.tToJs),
        resource: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.toWithoutEnum(valueRange)
    }).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var Get = {};
function get(accessToken, alt, dateTimeRenderOption, fields, key, majorDimension, oauthToken, prettyPrint, quotaUser, range, spreadsheetId, uploadProtocol, uploadType, valueRenderOption, client) {
    return client.spreadsheets.values.get({
        access_token: accessToken,
        alt: alt,
        dateTimeRenderOption: dateTimeRenderOption,
        fields: fields,
        key: key,
        majorDimension: majorDimension,
        oauth_token: oauthToken,
        prettyPrint: prettyPrint,
        quotaUser: quotaUser,
        range: range,
        spreadsheetId: spreadsheetId,
        upload_protocol: uploadProtocol,
        uploadType: uploadType,
        valueRenderOption: valueRenderOption
    }).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var Update = {};
function update(accessToken, alt, callback, fields, includeValuesInResponse, key, oauth_token, prettyPrint, quotaUser, responseDateTimeRenderOption, responseValueRenderOption, spreadsheetId, upload_protocol, uploadType, valueInputOption, range, resource, client) {
    return client.spreadsheets.values.update({
        access_token: accessToken,
        alt: alt,
        callback: callback,
        fields: fields,
        includeValuesInResponse: includeValuesInResponse,
        key: key,
        oauth_token: oauth_token,
        prettyPrint: prettyPrint,
        quotaUser: quotaUser,
        range: range,
        responseDateTimeRenderOption: responseDateTimeRenderOption,
        responseValueRenderOption: responseValueRenderOption,
        spreadsheetId: spreadsheetId,
        upload_protocol: upload_protocol,
        uploadType: uploadType,
        valueInputOption: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueInputOption.tToJs(valueInputOption),
        resource: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.toWithoutEnum(resource)
    }).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var Schema;
exports.Schema = Schema;
exports.Append = Append;
exports.append = append;
exports.Get = Get;
exports.get = get;
exports.Update = Update;
exports.update = update; /* GoogleApis__Sheets__Schema-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var KeyCommand$SmartcutsMacros = __webpack_require__(74935);
var URLCommand$SmartcutsMacros = __webpack_require__(91028);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var TypeCommand$SmartcutsMacros = __webpack_require__(92095);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var RadioCommand$SmartcutsMacros = __webpack_require__(84259);
var NewTabCommand$SmartcutsMacros = __webpack_require__(5864);
var ScrollCommand$SmartcutsMacros = __webpack_require__(34650);
var SelectCommand$SmartcutsMacros = __webpack_require__(16997);
var SwitchCommand$SmartcutsMacros = __webpack_require__(469);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var CheckboxCommand$SmartcutsMacros = __webpack_require__(50108);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var FocusTabCommand$SmartcutsMacros = __webpack_require__(14632);
var KeyComboCommand$SmartcutsMacros = __webpack_require__(461);
var PasswordCommand$SmartcutsMacros = __webpack_require__(9448);
var NewWindowCommand$SmartcutsMacros = __webpack_require__(90834);
var ClickInputCommand$SmartcutsMacros = __webpack_require__(78612);
var OpenedLinkCommand$SmartcutsMacros = __webpack_require__(28769);
var SubmitFormCommand$SmartcutsMacros = __webpack_require__(58935);
var ContextMenuCommand$SmartcutsMacros = __webpack_require__(48662);
var ClickToOAuthCommand$SmartcutsMacros = __webpack_require__(57114);
var CopyImageSrcCommand$SmartcutsMacros = __webpack_require__(68875);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var PasteInInputCommand$SmartcutsMacros = __webpack_require__(15220);
var NewTabWithUrlCommand$SmartcutsMacros = __webpack_require__(83228);
var ClientRedirectCommand$SmartcutsMacros = __webpack_require__(7);
var ServerRedirectCommand$SmartcutsMacros = __webpack_require__(50783);
var CopyLinkAddressCommand$SmartcutsMacros = __webpack_require__(67606);
var MoveInputCursorCommand$SmartcutsMacros = __webpack_require__(10806);
var NewWindowWithUrlCommand$SmartcutsMacros = __webpack_require__(23374);
var SelectionRelatedCommands$SmartcutsMacros = __webpack_require__(92787);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var SubmitFormRedirectCommand$SmartcutsMacros = __webpack_require__(16614);
var DataExtraction__DataRecord$SmartcutsMacros = __webpack_require__(57870);
var ClickContentEditableCommand$SmartcutsMacros = __webpack_require__(76406);
var ScreenshotToClipboardCommand$SmartcutsMacros = __webpack_require__(96617);
var DataExtraction__ExportToTable$SmartcutsMacros = __webpack_require__(87148);
var PasteInContentEditableCommand$SmartcutsMacros = __webpack_require__(74512);
var GenericCommandWithContextGlobal$SmartcutsMacros = __webpack_require__(95551);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var MoveContentEditableCursorCommand$SmartcutsMacros = __webpack_require__(45156);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
var PasteImageInContentEditableCommand$SmartcutsMacros = __webpack_require__(93978);
var WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros = __webpack_require__(23985);
function t_encode(encoder_commandType, v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_commandType, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}
function t_decode(decoder_commandType, v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_commandType, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}
function stringify(param, stringifyCommand) {
    return "{ id: " + (String(param.id) + (", command: " + (Curry._1(stringifyCommand, param.command) + ", contextGlobal }")));
}
var CommandWithContextGlobal = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    if (typeof v === "number") {
        switch(v){
            case /* ReloadCommand */ 0:
                return [
                    "ReloadCommand"
                ];
            case /* ForwardCommand */ 1:
                return [
                    "ForwardCommand"
                ];
            case /* BackCommand */ 2:
                return [
                    "BackCommand"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* NewWindowCommand */ 0:
                return [
                    "NewWindowCommand",
                    NewWindowCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewWindowWithUrlCommand */ 1:
                return [
                    "NewWindowWithUrlCommand",
                    NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewTabCommand */ 2:
                return [
                    "NewTabCommand",
                    NewTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewTabWithUrlCommand */ 3:
                return [
                    "NewTabWithUrlCommand",
                    NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* CloseTabCommand */ 4:
                return [
                    "CloseTabCommand",
                    InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
                ];
            case /* FocusTabCommand */ 5:
                return [
                    "FocusTabCommand",
                    FocusTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* URLCommand */ 6:
                return [
                    "URLCommand",
                    URLCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* OpenedLinkCommand */ 7:
                return [
                    "OpenedLinkCommand",
                    OpenedLinkCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SubmitFormCommand */ 8:
                return [
                    "SubmitFormCommand",
                    SubmitFormCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SubmitFormRedirectCommand */ 9:
                return [
                    "SubmitFormRedirectCommand",
                    SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ClientRedirectCommand */ 10:
                return [
                    "ClientRedirectCommand",
                    ClientRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ServerRedirectCommand */ 11:
                return [
                    "ServerRedirectCommand",
                    ServerRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ClickCommand */ 12:
                return [
                    "ClickCommand",
                    Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* ClickInputCommand */ 13:
                return [
                    "ClickInputCommand",
                    Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* ClickContentEditableCommand */ 14:
                return [
                    "ClickContentEditableCommand",
                    Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* TypeCommand */ 15:
                return [
                    "TypeCommand",
                    Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* CheckboxCommand */ 16:
                return [
                    "CheckboxCommand",
                    Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* SelectCommand */ 17:
                return [
                    "SelectCommand",
                    Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* RadioCommand */ 18:
                return [
                    "RadioCommand",
                    Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* KeyCommand */ 19:
                return [
                    "KeyCommand",
                    KeyCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* KeyComboCommand */ 20:
                return [
                    "KeyComboCommand",
                    KeyComboCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SelectionCommand */ 21:
                return [
                    "SelectionCommand",
                    Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* MoveInputCursorCommand */ 22:
                return [
                    "MoveInputCursorCommand",
                    Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* MoveContentEditableCursorCommand */ 23:
                return [
                    "MoveContentEditableCursorCommand",
                    Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* CopyCommand */ 24:
                return [
                    "CopyCommand",
                    Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* CopyLinkAddressCommand */ 25:
                return [
                    "CopyLinkAddressCommand",
                    Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* CutCommand */ 26:
                return [
                    "CutCommand",
                    Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* PasteInInputCommand */ 27:
                return [
                    "PasteInInputCommand",
                    Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* PasteInContentEditableCommand */ 28:
                return [
                    "PasteInContentEditableCommand",
                    Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* DragCommand */ 29:
                return [
                    "DragCommand",
                    Selector$SmartcutsMacros.selector_encode(v._0)
                ];
            case /* DropCommand */ 30:
                return [
                    "DropCommand",
                    Selector$SmartcutsMacros.selector_encode(v._0)
                ];
            case /* ScrollCommand */ 31:
                return [
                    "ScrollCommand",
                    ScrollCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* DownloadCommand */ 32:
                return [
                    "DownloadCommand",
                    Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* GoogleSheetsCommand */ 33:
                return [
                    "GoogleSheetsCommand",
                    Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* ContextMenuCommand */ 34:
                return [
                    "ContextMenuCommand",
                    Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* LoopCommand */ 35:
                return [
                    "LoopCommand",
                    LoopCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SwitchCommand */ 36:
                return [
                    "SwitchCommand",
                    Curry._1(SwitchCommandPlaybackRuntime.t_encode, v._0)
                ];
            case /* ScreenshotToClipboardCommand */ 37:
                return [
                    "ScreenshotToClipboardCommand",
                    Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* PasteImageInContentEditableCommand */ 38:
                return [
                    "PasteImageInContentEditableCommand",
                    Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* PasswordCommand */ 39:
                return [
                    "PasswordCommand",
                    Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* ClickToOAuthCommand */ 40:
                return [
                    "ClickToOAuthCommand",
                    Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* UploadCommand */ 41:
                return [
                    "UploadCommand",
                    Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* CopyImageSrcCommand */ 42:
                return [
                    "CopyImageSrcCommand",
                    Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
            case /* WithElementGroupsCommand */ 43:
                return [
                    "WithElementGroupsCommand",
                    Curry._1(WithElementGroupsCommandPlaybackRuntime.t_encode, v._0)
                ];
        }
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BackCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BackCommand */ 2
                    };
                }
            case "CheckboxCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CheckboxCommand */ 16,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ClickCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickCommand */ 12,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ClickContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickContentEditableCommand */ 14,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ClickInputCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickInputCommand */ 13,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ClickToOAuthCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickToOAuthCommand */ 40,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "ClientRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = ClientRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClientRedirectCommand */ 10,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "CloseTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CloseTabCommand */ 4,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "ContextMenuCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContextMenuCommand */ 34,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "CopyCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyCommand */ 24,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "CopyImageSrcCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyImageSrcCommand */ 42,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "CopyLinkAddressCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyLinkAddressCommand */ 25,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "CutCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CutCommand */ 26,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "DownloadCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadCommand */ 32,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "DragCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DragCommand */ 29,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "DropCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DropCommand */ 30,
                            _0: v0$14._0
                        }
                    };
                }
                var e$14 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "FocusTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$15 = FocusTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$15.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FocusTabCommand */ 5,
                            _0: v0$15._0
                        }
                    };
                }
                var e$15 = v0$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "ForwardCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ForwardCommand */ 1
                    };
                }
            case "GoogleSheetsCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$16 = Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$16.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsCommand */ 33,
                            _0: v0$16._0
                        }
                    };
                }
                var e$16 = v0$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "KeyComboCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$17 = KeyComboCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$17.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KeyComboCommand */ 20,
                            _0: v0$17._0
                        }
                    };
                }
                var e$17 = v0$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "KeyCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$18 = KeyCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$18.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KeyCommand */ 19,
                            _0: v0$18._0
                        }
                    };
                }
                var e$18 = v0$18._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "LoopCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$19 = LoopCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$19.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoopCommand */ 35,
                            _0: v0$19._0
                        }
                    };
                }
                var e$19 = v0$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "MoveContentEditableCursorCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$20 = Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$20.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MoveContentEditableCursorCommand */ 23,
                            _0: v0$20._0
                        }
                    };
                }
                var e$20 = v0$20._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "MoveInputCursorCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$21 = Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$21.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MoveInputCursorCommand */ 22,
                            _0: v0$21._0
                        }
                    };
                }
                var e$21 = v0$21._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "NewTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$22 = NewTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$22.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewTabCommand */ 2,
                            _0: v0$22._0
                        }
                    };
                }
                var e$22 = v0$22._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "NewTabWithUrlCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$23 = NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$23.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewTabWithUrlCommand */ 3,
                            _0: v0$23._0
                        }
                    };
                }
                var e$23 = v0$23._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "NewWindowCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$24 = NewWindowCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$24.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewWindowCommand */ 0,
                            _0: v0$24._0
                        }
                    };
                }
                var e$24 = v0$24._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "NewWindowWithUrlCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$25 = NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$25.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewWindowWithUrlCommand */ 1,
                            _0: v0$25._0
                        }
                    };
                }
                var e$25 = v0$25._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            case "OpenedLinkCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$26 = OpenedLinkCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$26.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OpenedLinkCommand */ 7,
                            _0: v0$26._0
                        }
                    };
                }
                var e$26 = v0$26._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$26.path,
                        message: e$26.message,
                        value: e$26.value
                    }
                };
            case "PasswordCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$27 = Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$27.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCommand */ 39,
                            _0: v0$27._0
                        }
                    };
                }
                var e$27 = v0$27._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$27.path,
                        message: e$27.message,
                        value: e$27.value
                    }
                };
            case "PasteImageInContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$28 = Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$28.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteImageInContentEditableCommand */ 38,
                            _0: v0$28._0
                        }
                    };
                }
                var e$28 = v0$28._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                    }
                };
            case "PasteInContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$29 = Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$29.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteInContentEditableCommand */ 28,
                            _0: v0$29._0
                        }
                    };
                }
                var e$29 = v0$29._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$29.path,
                        message: e$29.message,
                        value: e$29.value
                    }
                };
            case "PasteInInputCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$30 = Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$30.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteInInputCommand */ 27,
                            _0: v0$30._0
                        }
                    };
                }
                var e$30 = v0$30._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$30.path,
                        message: e$30.message,
                        value: e$30.value
                    }
                };
            case "RadioCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$31 = Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$31.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RadioCommand */ 18,
                            _0: v0$31._0
                        }
                    };
                }
                var e$31 = v0$31._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$31.path,
                        message: e$31.message,
                        value: e$31.value
                    }
                };
            case "ReloadCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ReloadCommand */ 0
                    };
                }
            case "ScreenshotToClipboardCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$32 = Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$32.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScreenshotToClipboardCommand */ 37,
                            _0: v0$32._0
                        }
                    };
                }
                var e$32 = v0$32._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$32.path,
                        message: e$32.message,
                        value: e$32.value
                    }
                };
            case "ScrollCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$33 = ScrollCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$33.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScrollCommand */ 31,
                            _0: v0$33._0
                        }
                    };
                }
                var e$33 = v0$33._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$33.path,
                        message: e$33.message,
                        value: e$33.value
                    }
                };
            case "SelectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$34 = Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$34.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectCommand */ 17,
                            _0: v0$34._0
                        }
                    };
                }
                var e$34 = v0$34._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$34.path,
                        message: e$34.message,
                        value: e$34.value
                    }
                };
            case "SelectionCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$35 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$35.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectionCommand */ 21,
                            _0: v0$35._0
                        }
                    };
                }
                var e$35 = v0$35._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$35.path,
                        message: e$35.message,
                        value: e$35.value
                    }
                };
            case "ServerRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$36 = ServerRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$36.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ServerRedirectCommand */ 11,
                            _0: v0$36._0
                        }
                    };
                }
                var e$36 = v0$36._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$36.path,
                        message: e$36.message,
                        value: e$36.value
                    }
                };
            case "SubmitFormCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$37 = SubmitFormCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$37.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SubmitFormCommand */ 8,
                            _0: v0$37._0
                        }
                    };
                }
                var e$37 = v0$37._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$37.path,
                        message: e$37.message,
                        value: e$37.value
                    }
                };
            case "SubmitFormRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$38 = SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$38.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SubmitFormRedirectCommand */ 9,
                            _0: v0$38._0
                        }
                    };
                }
                var e$38 = v0$38._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$38.path,
                        message: e$38.message,
                        value: e$38.value
                    }
                };
            case "SwitchCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$39 = Curry._1(SwitchCommandPlaybackRuntime.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$39.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SwitchCommand */ 36,
                            _0: v0$39._0
                        }
                    };
                }
                var e$39 = v0$39._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$39.path,
                        message: e$39.message,
                        value: e$39.value
                    }
                };
            case "TypeCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$40 = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$40.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TypeCommand */ 15,
                            _0: v0$40._0
                        }
                    };
                }
                var e$40 = v0$40._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$40.path,
                        message: e$40.message,
                        value: e$40.value
                    }
                };
            case "URLCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$41 = URLCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$41.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* URLCommand */ 6,
                            _0: v0$41._0
                        }
                    };
                }
                var e$41 = v0$41._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$41.path,
                        message: e$41.message,
                        value: e$41.value
                    }
                };
            case "UploadCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$42 = Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$42.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UploadCommand */ 41,
                            _0: v0$42._0
                        }
                    };
                }
                var e$42 = v0$42._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$42.path,
                        message: e$42.message,
                        value: e$42.value
                    }
                };
            case "WithElementGroupsCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$43 = Curry._1(WithElementGroupsCommandPlaybackRuntime.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$43.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WithElementGroupsCommand */ 43,
                            _0: v0$43._0
                        }
                    };
                }
                var e$43 = v0$43._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$43.path,
                        message: e$43.message,
                        value: e$43.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(command) {
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
                return "ReloadCommand";
            case /* ForwardCommand */ 1:
                return "ForwardCommand";
            case /* BackCommand */ 2:
                return "BackCommand";
        }
    } else {
        switch(command.TAG | 0){
            case /* NewWindowCommand */ 0:
                return "NewWindowCommand(" + (NewWindowCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewWindowWithUrlCommand */ 1:
                return "NewWindowWithUrlCommand(" + (NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewTabCommand */ 2:
                return "NewTabCommand(" + (NewTabCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewTabWithUrlCommand */ 3:
                return "NewTabWithUrlCommand(" + (NewTabWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* CloseTabCommand */ 4:
                return "CloseTabCommand(tabRef=" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(command._0) + ")");
            case /* FocusTabCommand */ 5:
                var func = FocusTabCommand$SmartcutsMacros.CommandValue.stringify;
                return "FocusTabCommand(tabRef=" + (Curry._2(func, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, command._0) + ")");
            case /* URLCommand */ 6:
                return "URLCommand(" + (URLCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* OpenedLinkCommand */ 7:
                return "OpenedLinkCommand(" + (OpenedLinkCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SubmitFormCommand */ 8:
                return "SubmitFormCommand(" + (SubmitFormCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SubmitFormRedirectCommand */ 9:
                return "SubmitFormRedirectCommand(" + (SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ClientRedirectCommand */ 10:
                return "ClientRedirectCommand(" + (ClientRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ServerRedirectCommand */ 11:
                return "ServerRedirectCommand(" + (ServerRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ClickCommand */ 12:
                return "ClickCommand(" + (Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* ClickInputCommand */ 13:
                return "ClickInputCommand(" + (Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* ClickContentEditableCommand */ 14:
                return "ClickContentEditableCommand(" + (Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* TypeCommand */ 15:
                return "TypeCommand(" + (Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* CheckboxCommand */ 16:
                return "CheckboxCommand(" + (Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* SelectCommand */ 17:
                return "SelectCommand(" + (Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* RadioCommand */ 18:
                return "RadioCommand(" + (Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* KeyCommand */ 19:
                return "KeyCommand(" + (KeyCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* KeyComboCommand */ 20:
                return "KeyComboCommand(" + (KeyComboCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SelectionCommand */ 21:
                return "SelectionCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* MoveInputCursorCommand */ 22:
                return "MoveInputCursorCommand(" + (Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* MoveContentEditableCursorCommand */ 23:
                return "MoveContentEditableCursorCommand(" + (Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* CopyCommand */ 24:
                return "CopyCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* CopyLinkAddressCommand */ 25:
                return "CopyLinkAddressCommand(" + (Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* CutCommand */ 26:
                return "CutCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* PasteInInputCommand */ 27:
                return "PasteInInputCommand(" + (Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* PasteInContentEditableCommand */ 28:
                return "PasteInContentEditableCommand(" + (Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* DragCommand */ 29:
                return "DragCommand(domElement=" + (Selector$SmartcutsMacros.stringify(undefined, false, command._0) + ")");
            case /* DropCommand */ 30:
                return "DropCommand(domElement=" + (Selector$SmartcutsMacros.stringify(undefined, false, command._0) + ")");
            case /* ScrollCommand */ 31:
                return "ScrollCommand(delta(x, y))";
            case /* DownloadCommand */ 32:
                return "DownloadCommand(" + (Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* GoogleSheetsCommand */ 33:
                return "GoogleSheetsCommand(" + (Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* ContextMenuCommand */ 34:
                return "ContextMenuCommand(" + (Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* LoopCommand */ 35:
                return "LoopCommand(" + LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0);
            case /* SwitchCommand */ 36:
                return "SwitchCommand(" + (Curry._1(SwitchCommandPlaybackRuntime.stringify, command._0) + ")");
            case /* ScreenshotToClipboardCommand */ 37:
                return "ScreenshotToClipboardCommand(" + (Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* PasteImageInContentEditableCommand */ 38:
                return "PasteImageInContentEditableCommand(" + (Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* PasswordCommand */ 39:
                return "PasswordCommand(" + (Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* ClickToOAuthCommand */ 40:
                return "ClickToOAuthCommand(" + (Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* UploadCommand */ 41:
                return "UploadCommand(" + (Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* CopyImageSrcCommand */ 42:
                return "CopyImageSrcCommand(" + (Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
            case /* WithElementGroupsCommand */ 43:
                return "WithElementGroupsCommand(" + (Curry._1(WithElementGroupsCommandPlaybackRuntime.stringify, command._0) + ")");
        }
    }
}
var CommandType = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function caseThatEvaluatedToTrue_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Default":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Default */ 0
                    };
                }
            case "Predicate":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Predicate */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function caseThatEvaluatedToTrue_encode(v) {
    if (v) {
        return [
            "Predicate",
            Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.t_encode, v._0)
        ];
    } else {
        return [
            "Default"
        ];
    }
}
function resolvedToCommands_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var caseThatEvaluatedToTrue = caseThatEvaluatedToTrue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "caseThatEvaluatedToTrue"), null));
    if (caseThatEvaluatedToTrue.TAG === /* Ok */ 0) {
        var commandsWithContextGlobal = Decco.arrayFromJson(function(param) {
            return t_decode(t_decode$1, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandsWithContextGlobal"), null));
        if (commandsWithContextGlobal.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    caseThatEvaluatedToTrue: caseThatEvaluatedToTrue._0,
                    commandsWithContextGlobal: commandsWithContextGlobal._0
                }
            };
        }
        var e = commandsWithContextGlobal._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".commandsWithContextGlobal" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = caseThatEvaluatedToTrue._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".caseThatEvaluatedToTrue" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function resolvedToCommands_encode(v) {
    return Js_dict.fromArray([
        [
            "caseThatEvaluatedToTrue",
            caseThatEvaluatedToTrue_encode(v.caseThatEvaluatedToTrue)
        ],
        [
            "commandsWithContextGlobal",
            Decco.arrayToJson(function(param) {
                return t_encode(t_encode$1, param);
            }, v.commandsWithContextGlobal)
        ]
    ]);
}
function t_encode$2(v) {
    if (v.TAG === /* HasNotEvaluated */ 0) {
        return [
            "HasNotEvaluated",
            SwitchCommand$SmartcutsMacros.CommandValue.t_encode(t_encode$1, v._0)
        ];
    } else {
        return [
            "ResolvedToCommands",
            resolvedToCommands_encode(v._0)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "HasNotEvaluated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SwitchCommand$SmartcutsMacros.CommandValue.t_decode(t_decode$1, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* HasNotEvaluated */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ResolvedToCommands":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = resolvedToCommands_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ResolvedToCommands */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$2(switchCommand) {
    if (switchCommand.TAG === /* HasNotEvaluated */ 0) {
        var func = SwitchCommand$SmartcutsMacros.CommandValue.stringify;
        return "HasNotEvaluated(" + (Curry._2(func, stringify$1, switchCommand._0) + ")");
    }
    var match = switchCommand._0;
    var caseThatEvaluatedToTrue = match.caseThatEvaluatedToTrue;
    var arg1 = stringify$1;
    return "ResolvedToCommands({ caseThatEvaluatedToTrue: " + ((caseThatEvaluatedToTrue ? "Predicate(" + (Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.stringify, caseThatEvaluatedToTrue._0) + ")") : "Default") + (", commands: [" + (Belt_Array.map(match.commandsWithContextGlobal, function(param) {
        return stringify(param, arg1);
    }).join(", ") + "] })")));
}
function stringifyCaseThatEvaluatedToTrue(caseThatEvaluatedToTrue) {
    if (caseThatEvaluatedToTrue) {
        return "Predicate(" + (Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.stringify, caseThatEvaluatedToTrue._0) + ")");
    } else {
        return "Default";
    }
}
function stringifyResolvedToCommands(param) {
    return "{ caseThatEvaluatedToTrue: " + (stringifyCaseThatEvaluatedToTrue(param.caseThatEvaluatedToTrue) + ("commandsWithContextGlobal: [n=" + (String(param.commandsWithContextGlobal.length) + "] }")));
}
var SwitchCommandPlaybackRuntime = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    resolvedToCommands_encode: resolvedToCommands_encode,
    resolvedToCommands_decode: resolvedToCommands_decode,
    caseThatEvaluatedToTrue_encode: caseThatEvaluatedToTrue_encode,
    caseThatEvaluatedToTrue_decode: caseThatEvaluatedToTrue_decode,
    stringify: stringify$2,
    stringifyCaseThatEvaluatedToTrue: stringifyCaseThatEvaluatedToTrue,
    stringifyResolvedToCommands: stringifyResolvedToCommands
};
function currentlyIteratingThroughDomElements_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandValue = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandValue"), null));
    if (commandValue.TAG === /* Ok */ 0) {
        var queuedDataRecords = Decco.arrayFromJson(function(param) {
            return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "queuedDataRecords"), null));
        if (queuedDataRecords.TAG === /* Ok */ 0) {
            var completedDataRecords = Decco.arrayFromJson(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "completedDataRecords"), null));
            if (completedDataRecords.TAG === /* Ok */ 0) {
                var finalEffects = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalEffects"), null));
                if (finalEffects.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            commandValue: commandValue._0,
                            queuedDataRecords: queuedDataRecords._0,
                            completedDataRecords: completedDataRecords._0,
                            finalEffects: finalEffects._0
                        }
                    };
                }
                var e = finalEffects._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".finalEffects" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = completedDataRecords._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".completedDataRecords" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = queuedDataRecords._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".queuedDataRecords" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = commandValue._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandValue" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function currentlyIteratingThroughDomElements_encode(v) {
    return Js_dict.fromArray([
        [
            "commandValue",
            Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v.commandValue)
        ],
        [
            "queuedDataRecords",
            Decco.arrayToJson(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
            }, v.queuedDataRecords)
        ],
        [
            "completedDataRecords",
            Decco.arrayToJson(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
            }, v.completedDataRecords)
        ],
        [
            "finalEffects",
            Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v.finalEffects)
        ]
    ]);
}
function t_encode$3(v) {
    if (typeof v === "number") {
        return [
            "DoneIteratingThroughDomElements"
        ];
    } else if (v.TAG === /* HasNotCollectedElementsFromPageYet */ 0) {
        return [
            "HasNotCollectedElementsFromPageYet",
            Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
        ];
    } else {
        return [
            "CurrentlyIteratingThroughDomElements",
            currentlyIteratingThroughDomElements_encode(v._0)
        ];
    }
}
function t_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CurrentlyIteratingThroughDomElements":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = currentlyIteratingThroughDomElements_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DoneIteratingThroughDomElements":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoneIteratingThroughDomElements */ 0
                    };
                }
            case "HasNotCollectedElementsFromPageYet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* HasNotCollectedElementsFromPageYet */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$3(playbackRuntimeCmdVal) {
    if (typeof playbackRuntimeCmdVal === "number") {
        return "DoneIteratingThroughDomElements";
    }
    if (playbackRuntimeCmdVal.TAG === /* HasNotCollectedElementsFromPageYet */ 0) {
        return "HasNotCollectedElementsFromPageYet(" + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, playbackRuntimeCmdVal._0) + ")");
    }
    var match = playbackRuntimeCmdVal._0;
    return "CurrentlyIteratingThroughDomElements({ commandValue: " + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, match.commandValue) + (", queuedDataRecords: [n=" + (String(match.queuedDataRecords.length) + ("], completedDataRecords: [n=" + (String(match.completedDataRecords.length) + ("], finalEffects: [" + (Belt_Array.map(match.finalEffects, WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.stringify).join(", ") + "] })")))))));
}
var WithElementGroupsCommandPlaybackRuntime = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    currentlyIteratingThroughDomElements_encode: currentlyIteratingThroughDomElements_encode,
    currentlyIteratingThroughDomElements_decode: currentlyIteratingThroughDomElements_decode,
    stringify: stringify$3
};
function tabDidEvaluateSwitchCommand_encode(v) {
    if (typeof v === "number") {
        return [
            "FailWithNoPredicateSatisfied"
        ];
    } else if (v.TAG === /* ResolvedToCommands */ 0) {
        return [
            "ResolvedToCommands",
            Curry._1(resolvedToCommands_encode, v._0)
        ];
    } else {
        return [
            "ResolvedToDoNothing",
            Curry._1(caseThatEvaluatedToTrue_encode, v._0)
        ];
    }
}
function tabDidEvaluateSwitchCommand_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FailWithNoPredicateSatisfied":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithNoPredicateSatisfied */ 0
                    };
                }
            case "ResolvedToCommands":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(resolvedToCommands_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ResolvedToCommands */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ResolvedToDoNothing":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(caseThatEvaluatedToTrue_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ResolvedToDoNothing */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapSwitchCommand(cmdVal, mapNestedCommand) {
    if (cmdVal.TAG === /* HasNotEvaluated */ 0) {
        var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
        return {
            TAG: /* HasNotEvaluated */ 0,
            _0: Curry._2(func, mapNestedCommand, cmdVal._0)
        };
    }
    var resolvedToCommands = cmdVal._0;
    return {
        TAG: /* ResolvedToCommands */ 1,
        _0: {
            caseThatEvaluatedToTrue: resolvedToCommands.caseThatEvaluatedToTrue,
            commandsWithContextGlobal: Belt_Array.map(resolvedToCommands.commandsWithContextGlobal, mapNestedCommand)
        }
    };
}
function maybeFromPlaybackRuntimeCommand(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    if (playbackRuntimeCommand.TAG !== /* SwitchCommand */ 36) {
        return;
    }
    var cmdVal = playbackRuntimeCommand._0;
    if (cmdVal.TAG === /* HasNotEvaluated */ 0) {
        return /* SwitchCommand */ {
            _0: /* HasNotEvaluated */ {
                _0: cmdVal._0
            }
        };
    }
}
function maybeFromPlaybackRuntimeCommandWithContextGlobal(param) {
    var contextGlobal = param.contextGlobal;
    var id = param.id;
    return Belt_Option.map(maybeFromPlaybackRuntimeCommand(param.command), function(command) {
        return {
            id: id,
            command: command,
            contextGlobal: contextGlobal
        };
    });
}
var WithContextGlobal = {
    maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal
};
var CommandThatCanPushFrame = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand,
    WithContextGlobal: WithContextGlobal
};
function maybeFromPlaybackRuntimeCommandWithContextGlobal$1(playbackTabId, url, param) {
    var contextGlobal = param.contextGlobal;
    var command = param.command;
    return Belt_Option.flatMap(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(contextGlobal.tabRef), function(playbackTabIdFromContextGlobal) {
        if (typeof command === "number") {
            switch(command){
                case /* ReloadCommand */ 0:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return /* ReloadCommand */ 0;
                    } else {
                        return;
                    }
                case /* ForwardCommand */ 1:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return /* ForwardCommand */ 1;
                    } else {
                        return;
                    }
                case /* BackCommand */ 2:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return /* BackCommand */ 2;
                    } else {
                        return;
                    }
            }
        } else {
            switch(command.TAG | 0){
                case /* NewWindowWithUrlCommand */ 1:
                    var cmdVal = command._0;
                    if (cmdVal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* NewWindowWithUrlCommand */ 0,
                            _0: cmdVal
                        };
                    } else {
                        return;
                    }
                case /* NewTabWithUrlCommand */ 3:
                    var cmdVal$1 = command._0;
                    if (cmdVal$1.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* NewTabWithUrlCommand */ 1,
                            _0: cmdVal$1
                        };
                    } else {
                        return;
                    }
                case /* URLCommand */ 6:
                    var cmdVal$2 = command._0;
                    if (cmdVal$2.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* URLCommand */ 2,
                            _0: cmdVal$2
                        };
                    } else {
                        return;
                    }
                case /* OpenedLinkCommand */ 7:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* OpenedLinkCommand */ 4,
                            _0: command._0
                        };
                    } else {
                        return;
                    }
                case /* SubmitFormCommand */ 8:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* SubmitFormCommand */ 5,
                            _0: command._0
                        };
                    } else {
                        return;
                    }
                case /* SubmitFormRedirectCommand */ 9:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* SubmitFormRedirectCommand */ 6,
                            _0: command._0
                        };
                    } else {
                        return;
                    }
                case /* ClientRedirectCommand */ 10:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* ClientRedirectCommand */ 7,
                            _0: command._0
                        };
                    } else {
                        return;
                    }
                case /* ServerRedirectCommand */ 11:
                    if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                        return {
                            TAG: /* ServerRedirectCommand */ 8,
                            _0: command._0
                        };
                    } else {
                        return;
                    }
                case /* DownloadCommand */ 32:
                    var cmdVal$3 = command._0;
                    var tabOrigin = cmdVal$3.tabOrigin;
                    var playbackTabIdFromCommandValue;
                    playbackTabIdFromCommandValue = tabOrigin.TAG === /* DownloadInNewTab */ 0 ? tabOrigin._0.newTab.playbackId : tabOrigin._0.playbackId;
                    if (Caml_obj.caml_equal(playbackTabIdFromCommandValue, Caml_option.some(playbackTabId))) {
                        return {
                            TAG: /* DownloadCommand */ 3,
                            _0: cmdVal$3
                        };
                    } else {
                        return;
                    }
                default:
                    return;
            }
        }
    });
}
function isCausedByLastClickCommand(commandThatSignifyPageLoad) {
    if (typeof commandThatSignifyPageLoad === "number") {
        return false;
    }
    switch(commandThatSignifyPageLoad.TAG | 0){
        case /* OpenedLinkCommand */ 4:
            if (commandThatSignifyPageLoad._0.viaHistoryApi) {
                return false;
            } else {
                return true;
            }
        case /* DownloadCommand */ 3:
        case /* SubmitFormCommand */ 5:
        case /* SubmitFormRedirectCommand */ 6:
        case /* ClientRedirectCommand */ 7:
        case /* ServerRedirectCommand */ 8:
            return true;
        default:
            return false;
    }
}
function maybeFromPlaybackRuntimeCommandWithContextGlobal$2(commandWithContextGlobal, playbackTabId, url) {
    var contextGlobal = commandWithContextGlobal.contextGlobal;
    var id = commandWithContextGlobal.id;
    var func = function func(param, param$1) {
        return maybeFromPlaybackRuntimeCommandWithContextGlobal$1(playbackTabId, param, param$1);
    };
    return Belt_Option.map(Curry._2(func, url, commandWithContextGlobal), function(command) {
        return {
            id: id,
            command: command,
            contextGlobal: contextGlobal
        };
    });
}
var WithContextGlobal$1 = {
    maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal$2
};
var CommandThatSignifyPageLoad = {
    maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal$1,
    isCausedByLastClickCommand: isCausedByLastClickCommand,
    WithContextGlobal: WithContextGlobal$1
};
function maybeFromPlaybackRuntimeCommand$1(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    switch(playbackRuntimeCommand.TAG | 0){
        case /* NewTabCommand */ 2:
            return {
                TAG: /* NewTabCommand */ 0,
                _0: playbackRuntimeCommand._0
            };
        case /* NewTabWithUrlCommand */ 3:
            return {
                TAG: /* NewTabWithUrlCommand */ 1,
                _0: playbackRuntimeCommand._0
            };
        case /* CloseTabCommand */ 4:
            return {
                TAG: /* CloseTabCommand */ 2,
                _0: playbackRuntimeCommand._0
            };
        case /* FocusTabCommand */ 5:
            return {
                TAG: /* FocusTabCommand */ 3,
                _0: playbackRuntimeCommand._0
            };
        case /* URLCommand */ 6:
            return {
                TAG: /* URLCommand */ 4,
                _0: playbackRuntimeCommand._0
            };
        case /* OpenedLinkCommand */ 7:
            return {
                TAG: /* OpenedLinkCommand */ 5,
                _0: playbackRuntimeCommand._0
            };
        case /* DownloadCommand */ 32:
            return {
                TAG: /* DownloadCommand */ 6,
                _0: playbackRuntimeCommand._0
            };
        case /* SwitchCommand */ 36:
            return {
                TAG: /* SwitchCommand */ 7,
                _0: playbackRuntimeCommand._0
            };
        default:
            return;
    }
}
function toPlaybackRuntimeCommand(commandThatContainsTabRefInCommandValue) {
    switch(commandThatContainsTabRefInCommandValue.TAG | 0){
        case /* NewTabCommand */ 0:
            return {
                TAG: /* NewTabCommand */ 2,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* NewTabWithUrlCommand */ 1:
            return {
                TAG: /* NewTabWithUrlCommand */ 3,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* CloseTabCommand */ 2:
            return {
                TAG: /* CloseTabCommand */ 4,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* FocusTabCommand */ 3:
            return {
                TAG: /* FocusTabCommand */ 5,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* URLCommand */ 4:
            return {
                TAG: /* URLCommand */ 6,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* OpenedLinkCommand */ 5:
            return {
                TAG: /* OpenedLinkCommand */ 7,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* DownloadCommand */ 6:
            return {
                TAG: /* DownloadCommand */ 32,
                _0: commandThatContainsTabRefInCommandValue._0
            };
        case /* SwitchCommand */ 7:
            return {
                TAG: /* SwitchCommand */ 36,
                _0: commandThatContainsTabRefInCommandValue._0
            };
    }
}
function maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue1, recordingTabId, playbackTabId, substitutePlaybackTabIdInContextGlobal) {
    switch(commandThatContainsTabRefInCommandValue1.TAG | 0){
        case /* NewTabCommand */ 0:
            var match = commandThatContainsTabRefInCommandValue1._0;
            var tabRef = match.tabRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef)) {
                return {
                    TAG: /* NewTabCommand */ 0,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef),
                        windowRef: match.windowRef,
                        focusStatus: match.focusStatus
                    }
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* NewTabWithUrlCommand */ 1:
            var match$1 = commandThatContainsTabRefInCommandValue1._0;
            var tabRef$1 = match$1.tabRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$1)) {
                return {
                    TAG: /* NewTabWithUrlCommand */ 1,
                    _0: {
                        url: match$1.url,
                        title: match$1.title,
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$1),
                        windowRef: match$1.windowRef,
                        focusStatus: match$1.focusStatus
                    }
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* CloseTabCommand */ 2:
            var tabRef$2 = commandThatContainsTabRefInCommandValue1._0;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$2)) {
                return {
                    TAG: /* CloseTabCommand */ 2,
                    _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$2)
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* FocusTabCommand */ 3:
            var commandValue = commandThatContainsTabRefInCommandValue1._0;
            var tabRef$3 = commandValue.tabRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$3)) {
                return {
                    TAG: /* FocusTabCommand */ 3,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$3),
                        url: commandValue.url,
                        title: commandValue.title
                    }
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* URLCommand */ 4:
            var match$2 = commandThatContainsTabRefInCommandValue1._0;
            var tabRef$4 = match$2.tabRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$4)) {
                return {
                    TAG: /* URLCommand */ 4,
                    _0: {
                        url: match$2.url,
                        title: match$2.title,
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$4)
                    }
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* OpenedLinkCommand */ 5:
            var cmdVal = commandThatContainsTabRefInCommandValue1._0;
            var openerTabRef = cmdVal.maybeOpenerTab;
            var tabRef$5 = cmdVal.tabRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$5)) {
                return {
                    TAG: /* OpenedLinkCommand */ 5,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$5),
                        windowRef: cmdVal.windowRef,
                        url: cmdVal.url,
                        title: cmdVal.title,
                        maybeOpenerTab: cmdVal.maybeOpenerTab,
                        viaHistoryApi: cmdVal.viaHistoryApi
                    }
                };
            } else if (openerTabRef !== undefined && InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, openerTabRef)) {
                return {
                    TAG: /* OpenedLinkCommand */ 5,
                    _0: {
                        tabRef: cmdVal.tabRef,
                        windowRef: cmdVal.windowRef,
                        url: cmdVal.url,
                        title: cmdVal.title,
                        maybeOpenerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, openerTabRef),
                        viaHistoryApi: cmdVal.viaHistoryApi
                    }
                };
            } else {
                return commandThatContainsTabRefInCommandValue1;
            }
        case /* DownloadCommand */ 6:
            return {
                TAG: /* DownloadCommand */ 6,
                _0: Curry._3(DownloadCommand$SmartcutsMacros.CommandValue.Playback.maybeAssignPlaybackTabId, recordingTabId, playbackTabId, commandThatContainsTabRefInCommandValue1._0)
            };
        case /* SwitchCommand */ 7:
            return {
                TAG: /* SwitchCommand */ 7,
                _0: mapSwitchCommand(commandThatContainsTabRefInCommandValue1._0, function(commandWithContextGlobal) {
                    var command = commandWithContextGlobal.command;
                    var arg2 = Belt_Option.map(maybeFromPlaybackRuntimeCommand$1(command), function(commandThatContainsTabRefInCommandValue) {
                        return toPlaybackRuntimeCommand(maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue, recordingTabId, playbackTabId, substitutePlaybackTabIdInContextGlobal));
                    });
                    return {
                        id: commandWithContextGlobal.id,
                        command: function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg2);
                        }(command),
                        contextGlobal: Curry._3(substitutePlaybackTabIdInContextGlobal, commandWithContextGlobal.contextGlobal, recordingTabId, playbackTabId)
                    };
                })
            };
    }
}
var CommandThatContainsTabRefInCommandValue = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$1,
    toPlaybackRuntimeCommand: toPlaybackRuntimeCommand,
    maybeSubstitudePlaybackTabId: maybeSubstitudePlaybackTabId
};
function maybeFromPlaybackRuntimeCommand$2(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    switch(playbackRuntimeCommand.TAG | 0){
        case /* NewWindowCommand */ 0:
            return {
                TAG: /* NewWindowCommand */ 0,
                _0: playbackRuntimeCommand._0
            };
        case /* NewWindowWithUrlCommand */ 1:
            return {
                TAG: /* NewWindowWithUrlCommand */ 1,
                _0: playbackRuntimeCommand._0
            };
        case /* NewTabCommand */ 2:
            return {
                TAG: /* NewTabCommand */ 2,
                _0: playbackRuntimeCommand._0
            };
        case /* NewTabWithUrlCommand */ 3:
            return {
                TAG: /* NewTabWithUrlCommand */ 3,
                _0: playbackRuntimeCommand._0
            };
        case /* SwitchCommand */ 36:
            return {
                TAG: /* SwitchCommand */ 4,
                _0: playbackRuntimeCommand._0
            };
        default:
            return;
    }
}
function toPlaybackRuntimeCommand$1(commandThatContainsWindowRefInCommandValue) {
    switch(commandThatContainsWindowRefInCommandValue.TAG | 0){
        case /* NewWindowCommand */ 0:
            return {
                TAG: /* NewWindowCommand */ 0,
                _0: commandThatContainsWindowRefInCommandValue._0
            };
        case /* NewWindowWithUrlCommand */ 1:
            return {
                TAG: /* NewWindowWithUrlCommand */ 1,
                _0: commandThatContainsWindowRefInCommandValue._0
            };
        case /* NewTabCommand */ 2:
            return {
                TAG: /* NewTabCommand */ 2,
                _0: commandThatContainsWindowRefInCommandValue._0
            };
        case /* NewTabWithUrlCommand */ 3:
            return {
                TAG: /* NewTabWithUrlCommand */ 3,
                _0: commandThatContainsWindowRefInCommandValue._0
            };
        case /* SwitchCommand */ 4:
            return {
                TAG: /* SwitchCommand */ 36,
                _0: commandThatContainsWindowRefInCommandValue._0
            };
    }
}
function maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue1, recordingWindowId, playbackWindowId, substitutePlaybackWindowIdInContextGlobal) {
    switch(commandThatContainsWindowRefInCommandValue1.TAG | 0){
        case /* NewWindowCommand */ 0:
            var match = commandThatContainsWindowRefInCommandValue1._0;
            var windowRef = match.windowRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef)) {
                return {
                    TAG: /* NewWindowCommand */ 0,
                    _0: {
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef),
                        focusStatus: match.focusStatus
                    }
                };
            } else {
                return commandThatContainsWindowRefInCommandValue1;
            }
        case /* NewWindowWithUrlCommand */ 1:
            return commandThatContainsWindowRefInCommandValue1;
        case /* NewTabCommand */ 2:
            var match$1 = commandThatContainsWindowRefInCommandValue1._0;
            var windowRef$1 = match$1.windowRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef$1)) {
                return {
                    TAG: /* NewTabCommand */ 2,
                    _0: {
                        tabRef: match$1.tabRef,
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef$1),
                        focusStatus: match$1.focusStatus
                    }
                };
            } else {
                return commandThatContainsWindowRefInCommandValue1;
            }
        case /* NewTabWithUrlCommand */ 3:
            var match$2 = commandThatContainsWindowRefInCommandValue1._0;
            var windowRef$2 = match$2.windowRef;
            if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef$2)) {
                return {
                    TAG: /* NewTabWithUrlCommand */ 3,
                    _0: {
                        url: match$2.url,
                        title: match$2.title,
                        tabRef: match$2.tabRef,
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef$2),
                        focusStatus: match$2.focusStatus
                    }
                };
            } else {
                return commandThatContainsWindowRefInCommandValue1;
            }
        case /* SwitchCommand */ 4:
            return {
                TAG: /* SwitchCommand */ 4,
                _0: mapSwitchCommand(commandThatContainsWindowRefInCommandValue1._0, function(commandWithContextGlobal) {
                    var command = commandWithContextGlobal.command;
                    var arg3 = Belt_Option.map(maybeFromPlaybackRuntimeCommand$2(command), function(commandThatContainsWindowRefInCommandValue) {
                        return toPlaybackRuntimeCommand$1(maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue, recordingWindowId, playbackWindowId, substitutePlaybackWindowIdInContextGlobal));
                    });
                    return {
                        id: commandWithContextGlobal.id,
                        command: function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg3);
                        }(command),
                        contextGlobal: Curry._3(substitutePlaybackWindowIdInContextGlobal, commandWithContextGlobal.contextGlobal, recordingWindowId, playbackWindowId)
                    };
                })
            };
    }
}
var CommandThatContainsWindowRefInCommandValue = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$2,
    toPlaybackRuntimeCommand: toPlaybackRuntimeCommand$1,
    maybeSubstitudePlaybackWindowId: maybeSubstitudePlaybackWindowId
};
function maybeFromPlaybackRuntimeCommand$3(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    switch(playbackRuntimeCommand.TAG | 0){
        case /* NewWindowWithUrlCommand */ 1:
            return {
                TAG: /* NewWindowWithUrlCommand */ 0,
                _0: playbackRuntimeCommand._0
            };
        case /* NewTabWithUrlCommand */ 3:
            return {
                TAG: /* NewTabWithUrlCommand */ 1,
                _0: playbackRuntimeCommand._0
            };
        case /* URLCommand */ 6:
            return {
                TAG: /* URLCommand */ 2,
                _0: playbackRuntimeCommand._0
            };
        case /* OpenedLinkCommand */ 7:
            return {
                TAG: /* OpenedLinkCommand */ 3,
                _0: playbackRuntimeCommand._0
            };
        default:
            return;
    }
}
var CommandThatCanUpdateUrl = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$3
};
function t_encode$4(v) {
    return t_encode(t_encode$1, v);
}
function t_decode$4(v) {
    return t_decode(t_decode$1, v);
}
var arg = stringify$1;
function stringify$4(param) {
    return stringify(param, arg);
}
function fromCommandWithContextGlobal(param) {
    var command = param.command;
    var tmp;
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
                tmp = /* ReloadCommand */ 0;
                break;
            case /* ForwardCommand */ 1:
                tmp = /* ForwardCommand */ 1;
                break;
            case /* BackCommand */ 2:
                tmp = /* BackCommand */ 2;
                break;
        }
    } else {
        switch(command.TAG | 0){
            case /* NewWindowCommand */ 0:
                tmp = {
                    TAG: /* NewWindowCommand */ 0,
                    _0: command._0
                };
                break;
            case /* NewWindowWithUrlCommand */ 1:
                tmp = {
                    TAG: /* NewWindowWithUrlCommand */ 1,
                    _0: command._0
                };
                break;
            case /* NewTabCommand */ 2:
                tmp = {
                    TAG: /* NewTabCommand */ 2,
                    _0: command._0
                };
                break;
            case /* NewTabWithUrlCommand */ 3:
                tmp = {
                    TAG: /* NewTabWithUrlCommand */ 3,
                    _0: command._0
                };
                break;
            case /* CloseTabCommand */ 4:
                tmp = {
                    TAG: /* CloseTabCommand */ 4,
                    _0: command._0
                };
                break;
            case /* FocusTabCommand */ 5:
                tmp = {
                    TAG: /* FocusTabCommand */ 5,
                    _0: command._0
                };
                break;
            case /* URLCommand */ 6:
                tmp = {
                    TAG: /* URLCommand */ 6,
                    _0: command._0
                };
                break;
            case /* OpenedLinkCommand */ 7:
                tmp = {
                    TAG: /* OpenedLinkCommand */ 7,
                    _0: command._0
                };
                break;
            case /* SubmitFormCommand */ 8:
                tmp = {
                    TAG: /* SubmitFormCommand */ 8,
                    _0: command._0
                };
                break;
            case /* SubmitFormRedirectCommand */ 9:
                tmp = {
                    TAG: /* SubmitFormRedirectCommand */ 9,
                    _0: command._0
                };
                break;
            case /* ClientRedirectCommand */ 10:
                tmp = {
                    TAG: /* ClientRedirectCommand */ 10,
                    _0: command._0
                };
                break;
            case /* ServerRedirectCommand */ 11:
                tmp = {
                    TAG: /* ServerRedirectCommand */ 11,
                    _0: command._0
                };
                break;
            case /* ClickCommand */ 12:
                tmp = {
                    TAG: /* ClickCommand */ 12,
                    _0: command._0
                };
                break;
            case /* ClickInputCommand */ 13:
                tmp = {
                    TAG: /* ClickInputCommand */ 13,
                    _0: command._0
                };
                break;
            case /* ClickContentEditableCommand */ 14:
                tmp = {
                    TAG: /* ClickContentEditableCommand */ 14,
                    _0: command._0
                };
                break;
            case /* TypeCommand */ 15:
                tmp = {
                    TAG: /* TypeCommand */ 15,
                    _0: command._0
                };
                break;
            case /* CheckboxCommand */ 16:
                tmp = {
                    TAG: /* CheckboxCommand */ 16,
                    _0: command._0
                };
                break;
            case /* SelectCommand */ 17:
                tmp = {
                    TAG: /* SelectCommand */ 17,
                    _0: command._0
                };
                break;
            case /* RadioCommand */ 18:
                tmp = {
                    TAG: /* RadioCommand */ 18,
                    _0: command._0
                };
                break;
            case /* KeyCommand */ 19:
                tmp = {
                    TAG: /* KeyCommand */ 19,
                    _0: command._0
                };
                break;
            case /* KeyComboCommand */ 20:
                tmp = {
                    TAG: /* KeyComboCommand */ 20,
                    _0: command._0
                };
                break;
            case /* SelectionCommand */ 21:
                tmp = {
                    TAG: /* SelectionCommand */ 21,
                    _0: command._0
                };
                break;
            case /* MoveInputCursorCommand */ 22:
                tmp = {
                    TAG: /* MoveInputCursorCommand */ 22,
                    _0: command._0
                };
                break;
            case /* MoveContentEditableCursorCommand */ 23:
                tmp = {
                    TAG: /* MoveContentEditableCursorCommand */ 23,
                    _0: command._0
                };
                break;
            case /* CopyCommand */ 24:
                tmp = {
                    TAG: /* CopyCommand */ 24,
                    _0: command._0
                };
                break;
            case /* CopyLinkAddressCommand */ 25:
                tmp = {
                    TAG: /* CopyLinkAddressCommand */ 25,
                    _0: command._0
                };
                break;
            case /* CutCommand */ 26:
                tmp = {
                    TAG: /* CutCommand */ 26,
                    _0: command._0
                };
                break;
            case /* PasteInInputCommand */ 27:
                tmp = {
                    TAG: /* PasteInInputCommand */ 27,
                    _0: command._0
                };
                break;
            case /* PasteInContentEditableCommand */ 28:
                tmp = {
                    TAG: /* PasteInContentEditableCommand */ 28,
                    _0: command._0
                };
                break;
            case /* DragCommand */ 29:
                tmp = {
                    TAG: /* DragCommand */ 29,
                    _0: command._0
                };
                break;
            case /* DropCommand */ 30:
                tmp = {
                    TAG: /* DropCommand */ 30,
                    _0: command._0
                };
                break;
            case /* ScrollCommand */ 31:
                tmp = {
                    TAG: /* ScrollCommand */ 31,
                    _0: command._0
                };
                break;
            case /* DownloadCommand */ 32:
                tmp = {
                    TAG: /* DownloadCommand */ 32,
                    _0: command._0
                };
                break;
            case /* GoogleSheetsCommand */ 33:
                tmp = {
                    TAG: /* GoogleSheetsCommand */ 33,
                    _0: command._0
                };
                break;
            case /* ContextMenuCommand */ 34:
                tmp = {
                    TAG: /* ContextMenuCommand */ 34,
                    _0: command._0
                };
                break;
            case /* LoopCommand */ 35:
                tmp = {
                    TAG: /* LoopCommand */ 35,
                    _0: command._0
                };
                break;
            case /* SwitchCommand */ 36:
                var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
                tmp = {
                    TAG: /* SwitchCommand */ 36,
                    _0: {
                        TAG: /* HasNotEvaluated */ 0,
                        _0: Curry._2(func, fromCommandWithContextGlobal, command._0)
                    }
                };
                break;
            case /* ScreenshotToClipboardCommand */ 37:
                tmp = {
                    TAG: /* ScreenshotToClipboardCommand */ 37,
                    _0: command._0
                };
                break;
            case /* PasteImageInContentEditableCommand */ 38:
                tmp = {
                    TAG: /* PasteImageInContentEditableCommand */ 38,
                    _0: command._0
                };
                break;
            case /* PasswordCommand */ 39:
                tmp = {
                    TAG: /* PasswordCommand */ 39,
                    _0: command._0
                };
                break;
            case /* ClickToOAuthCommand */ 40:
                tmp = {
                    TAG: /* ClickToOAuthCommand */ 40,
                    _0: command._0
                };
                break;
            case /* UploadCommand */ 41:
                tmp = {
                    TAG: /* UploadCommand */ 41,
                    _0: command._0
                };
                break;
            case /* CopyImageSrcCommand */ 42:
                tmp = {
                    TAG: /* CopyImageSrcCommand */ 42,
                    _0: command._0
                };
                break;
            case /* WithElementGroupsCommand */ 43:
                tmp = {
                    TAG: /* WithElementGroupsCommand */ 43,
                    _0: {
                        TAG: /* HasNotCollectedElementsFromPageYet */ 0,
                        _0: command._0
                    }
                };
                break;
        }
    }
    return {
        id: param.id,
        command: tmp,
        contextGlobal: param.contextGlobal
    };
}
function maybeCreatedWindow(param) {
    var match = param.contextGlobal;
    var tabRef = match.tabRef;
    var windowRef = match.windowRef;
    var tmp = param.command;
    if (typeof tmp === "number") {
        return;
    }
    switch(tmp.TAG | 0){
        case /* NewWindowCommand */ 0:
        case /* NewWindowWithUrlCommand */ 1:
            return [
                windowRef,
                tabRef
            ];
        default:
            return;
    }
}
function maybeCreatedTab(param) {
    var contextGlobal = param.contextGlobal;
    var command = param.command;
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* NewTabCommand */ 2:
            return command._0.tabRef;
        case /* NewTabWithUrlCommand */ 3:
            return command._0.tabRef;
        case /* OpenedLinkCommand */ 7:
            var match = command._0;
            if (match.maybeOpenerTab !== undefined && !match.viaHistoryApi) {
                return match.tabRef;
            } else {
                return;
            }
        case /* NewWindowCommand */ 0:
        case /* NewWindowWithUrlCommand */ 1:
        case /* ServerRedirectCommand */ 11:
            return contextGlobal.tabRef;
        case /* DownloadCommand */ 32:
            var match$1 = command._0.tabOrigin;
            if (match$1.TAG === /* DownloadInNewTab */ 0) {
                return match$1._0.newTab;
            } else {
                return;
            }
        default:
            return;
    }
}
function substituteTabId(recordingTabId1, playbackTabId1, commandWithContextGlobal) {
    var command = commandWithContextGlobal.command;
    var substitutePlaybackTabIdInContextGlobal = function substitutePlaybackTabIdInContextGlobal(contextGlobal, recordingTabId, playbackTabId) {
        var tabRef = contextGlobal.tabRef;
        var tmp;
        var func = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId;
        if (Curry._2(func, recordingTabId, tabRef)) {
            var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId;
            tmp = Curry._2(func$1, playbackTabId, tabRef);
        } else {
            tmp = tabRef;
        }
        return {
            windowRef: contextGlobal.windowRef,
            tabRef: tmp,
            url: contextGlobal.url,
            focusStatus: contextGlobal.focusStatus,
            title: contextGlobal.title,
            frame: contextGlobal.frame,
            windowGeometry: contextGlobal.windowGeometry,
            targetBoundingRect: contextGlobal.targetBoundingRect,
            timestamp: contextGlobal.timestamp,
            htmlSnapshot: contextGlobal.htmlSnapshot,
            screenshot: contextGlobal.screenshot,
            croppedScreenshot: contextGlobal.croppedScreenshot,
            preconditions: contextGlobal.preconditions,
            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
        };
    };
    var arg4 = Belt_Option.map(maybeFromPlaybackRuntimeCommand$1(command), function(commandThatContainsTabRefInCommandValue) {
        return toPlaybackRuntimeCommand(maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue, recordingTabId1, playbackTabId1, substitutePlaybackTabIdInContextGlobal));
    });
    return {
        id: commandWithContextGlobal.id,
        command: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg4);
        }(command),
        contextGlobal: substitutePlaybackTabIdInContextGlobal(commandWithContextGlobal.contextGlobal, recordingTabId1, playbackTabId1)
    };
}
function substituteWindowId(recordingWindowId1, playbackWindowId1, commandWithContextGlobal) {
    var command = commandWithContextGlobal.command;
    var substitutePlaybackWindowIdInContextGlobal = function substitutePlaybackWindowIdInContextGlobal(contextGlobal, recordingWindowId, playbackWindowId) {
        var windowRef = contextGlobal.windowRef;
        var tmp;
        var func = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId;
        if (Curry._2(func, recordingWindowId, windowRef)) {
            var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId;
            tmp = Curry._2(func$1, playbackWindowId, windowRef);
        } else {
            tmp = windowRef;
        }
        return {
            windowRef: tmp,
            tabRef: contextGlobal.tabRef,
            url: contextGlobal.url,
            focusStatus: contextGlobal.focusStatus,
            title: contextGlobal.title,
            frame: contextGlobal.frame,
            windowGeometry: contextGlobal.windowGeometry,
            targetBoundingRect: contextGlobal.targetBoundingRect,
            timestamp: contextGlobal.timestamp,
            htmlSnapshot: contextGlobal.htmlSnapshot,
            screenshot: contextGlobal.screenshot,
            croppedScreenshot: contextGlobal.croppedScreenshot,
            preconditions: contextGlobal.preconditions,
            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
        };
    };
    var arg5 = Belt_Option.map(maybeFromPlaybackRuntimeCommand$2(command), function(commandThatContainsWindowRefInCommandValue) {
        return toPlaybackRuntimeCommand$1(maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue, recordingWindowId1, playbackWindowId1, substitutePlaybackWindowIdInContextGlobal));
    });
    return {
        id: commandWithContextGlobal.id,
        command: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg5);
        }(command),
        contextGlobal: substitutePlaybackWindowIdInContextGlobal(commandWithContextGlobal.contextGlobal, recordingWindowId1, playbackWindowId1)
    };
}
function tabRefThatBlocksCommand(param, playbackOptions) {
    var contextGlobal = param.contextGlobal;
    var command = param.command;
    if (typeof command === "number") {
        return contextGlobal.tabRef;
    }
    switch(command.TAG | 0){
        case /* CloseTabCommand */ 4:
            return command._0;
        case /* FocusTabCommand */ 5:
            var tabRef = command._0.tabRef;
            if (tabRef.playbackId === undefined) {
                return tabRef;
            } else {
                return;
            }
        case /* URLCommand */ 6:
            return command._0.tabRef;
        case /* NewWindowCommand */ 0:
        case /* NewWindowWithUrlCommand */ 1:
        case /* NewTabCommand */ 2:
        case /* NewTabWithUrlCommand */ 3:
        case /* OpenedLinkCommand */ 7:
        case /* SubmitFormCommand */ 8:
        case /* SubmitFormRedirectCommand */ 9:
        case /* ClientRedirectCommand */ 10:
        case /* ServerRedirectCommand */ 11:
            return;
        case /* DownloadCommand */ 32:
            if (command._0.tabOrigin.TAG === /* DownloadInNewTab */ 0) {
                return;
            } else {
                return contextGlobal.tabRef;
            }
        case /* GoogleSheetsCommand */ 33:
            if (playbackOptions.replaceUiCommandsWithApiCommands) {
                return;
            } else {
                return contextGlobal.tabRef;
            }
        default:
            return contextGlobal.tabRef;
    }
}
function maybeSubstituteUrlFromCompletedCommandWithContextGlobal(completedCommandWithContextGlobal, commandWithContextGlobal) {
    var contextGlobal = commandWithContextGlobal.contextGlobal;
    var maybeUpdateUrl = Belt_Option.flatMap(maybeFromPlaybackRuntimeCommand$3(completedCommandWithContextGlobal.command), function(commandThatCanUpdateUrl) {
        var match = completedCommandWithContextGlobal.contextGlobal;
        var match$1;
        switch(commandThatCanUpdateUrl.TAG | 0){
            case /* NewWindowWithUrlCommand */ 0:
            case /* NewTabWithUrlCommand */ 1:
                match$1 = [
                    match.tabRef,
                    commandThatCanUpdateUrl._0.url
                ];
                break;
            case /* URLCommand */ 2:
                var match$2 = commandThatCanUpdateUrl._0;
                match$1 = [
                    match$2.tabRef,
                    match$2.url
                ];
                break;
            case /* OpenedLinkCommand */ 3:
                var match$3 = commandThatCanUpdateUrl._0;
                match$1 = [
                    match$3.tabRef,
                    match$3.url
                ];
                break;
        }
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef(contextGlobal.tabRef, match$1[0])) {
            return match$1[1];
        }
    });
    var arg6 = Belt_Option.map(maybeUpdateUrl, function(url) {
        return {
            id: commandWithContextGlobal.id,
            command: commandWithContextGlobal.command,
            contextGlobal: {
                windowRef: contextGlobal.windowRef,
                tabRef: contextGlobal.tabRef,
                url: url,
                focusStatus: contextGlobal.focusStatus,
                title: contextGlobal.title,
                frame: contextGlobal.frame,
                windowGeometry: contextGlobal.windowGeometry,
                targetBoundingRect: contextGlobal.targetBoundingRect,
                timestamp: contextGlobal.timestamp,
                htmlSnapshot: contextGlobal.htmlSnapshot,
                screenshot: contextGlobal.screenshot,
                croppedScreenshot: contextGlobal.croppedScreenshot,
                preconditions: contextGlobal.preconditions,
                maybeLogoutLocator: contextGlobal.maybeLogoutLocator
            }
        };
    });
    return OptionUtils$SmartcutsMacros.withDefault(commandWithContextGlobal, arg6);
}
var WithContextGlobal$2 = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$4,
    fromCommandWithContextGlobal: fromCommandWithContextGlobal,
    maybeCreatedWindow: maybeCreatedWindow,
    maybeCreatedTab: maybeCreatedTab,
    substituteTabId: substituteTabId,
    substituteWindowId: substituteWindowId,
    tabRefThatBlocksCommand: tabRefThatBlocksCommand,
    maybeSubstituteUrlFromCompletedCommandWithContextGlobal: maybeSubstituteUrlFromCompletedCommandWithContextGlobal
};
function maybeFromPlaybackRuntimeCommand$4(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    if (playbackRuntimeCommand.TAG !== /* WithElementGroupsCommand */ 43) {
        return;
    }
    var cmdVal = playbackRuntimeCommand._0;
    if (typeof cmdVal === "number") {
        return;
    } else if (cmdVal.TAG === /* HasNotCollectedElementsFromPageYet */ 0) {
        return /* WithElementGroupsCommand */ {
            _0: {
                TAG: /* HasNotCollectedElementsFromPageYet */ 0,
                _0: cmdVal._0
            }
        };
    } else {
        return /* WithElementGroupsCommand */ {
            _0: {
                TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                _0: cmdVal._0
            }
        };
    }
}
function event_encode(v) {
    return [
        "DidCollectDataRecords",
        Decco.arrayToJson(function(param) {
            return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
        }, v._0)
    ];
}
function event_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DidCollectDataRecords") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.arrayFromJson(function(param) {
            return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
        }, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* DidCollectDataRecords */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyEvent($$event) {
    return "DidCollectDataRecords([n=" + (String($$event._0.length) + "])");
}
function sideEffect_encode(v) {
    if (v) {
        return [
            "ExecuteFinalEffectsAndDispatchCompletedCommand",
            Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v._0)
        ];
    } else {
        return [
            "DispatchIterateThroughDataRecords"
        ];
    }
}
function sideEffect_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DispatchIterateThroughDataRecords":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DispatchIterateThroughDataRecords */ 0
                    };
                }
            case "ExecuteFinalEffectsAndDispatchCompletedCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExecuteFinalEffectsAndDispatchCompletedCommand */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function handleEvent($$event, command) {
    var dataRecords1 = $$event._0;
    var maybeClipDataRecordsToRemainingLoadItems = function maybeClipDataRecordsToRemainingLoadItems(loadItems, nCompletedItems, dataRecords) {
        if (typeof loadItems === "number") {
            return dataRecords;
        }
        var nRemaining = loadItems._0 - nCompletedItems | 0;
        if (nRemaining < dataRecords.length) {
            return Belt_Array.slice(dataRecords, 0, nRemaining);
        } else {
            return dataRecords;
        }
    };
    var commandValue = command._0;
    if (commandValue.TAG === /* HasNotCollectedElementsFromPageYet */ 0) {
        var commandValue$1 = commandValue._0;
        var loadItems1 = commandValue$1.paginateOptions.loadItems;
        var func = function func(param, param$1) {
            return maybeClipDataRecordsToRemainingLoadItems(loadItems1, param, param$1);
        };
        return [
            {
                TAG: /* WithElementGroupsCommand */ 43,
                _0: {
                    TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                    _0: {
                        commandValue: commandValue$1,
                        queuedDataRecords: Curry._2(func, 0, dataRecords1),
                        completedDataRecords: [],
                        finalEffects: []
                    }
                }
            },
            [
                /* DispatchIterateThroughDataRecords */ 0
            ]
        ];
    }
    var currentlyIteratingThroughDomElements = commandValue._0;
    var loadItems$1 = currentlyIteratingThroughDomElements.commandValue.paginateOptions.loadItems;
    if (dataRecords1.length === 0) {
        return [
            {
                TAG: /* WithElementGroupsCommand */ 43,
                _0: {
                    TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                    _0: currentlyIteratingThroughDomElements
                }
            },
            [
                /* ExecuteFinalEffectsAndDispatchCompletedCommand */ {
                    _0: currentlyIteratingThroughDomElements.finalEffects
                }
            ]
        ];
    }
    var func$1 = function func$1(param, param$1) {
        return maybeClipDataRecordsToRemainingLoadItems(loadItems$1, param, param$1);
    };
    return [
        {
            TAG: /* WithElementGroupsCommand */ 43,
            _0: {
                TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                _0: {
                    commandValue: currentlyIteratingThroughDomElements.commandValue,
                    queuedDataRecords: Curry._2(func$1, currentlyIteratingThroughDomElements.completedDataRecords.length, dataRecords1),
                    completedDataRecords: currentlyIteratingThroughDomElements.completedDataRecords,
                    finalEffects: currentlyIteratingThroughDomElements.finalEffects
                }
            }
        },
        [
            /* DispatchIterateThroughDataRecords */ 0
        ]
    ];
}
var CommandThatCollectsDataRecords = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$4,
    event_encode: event_encode,
    event_decode: event_decode,
    stringifyEvent: stringifyEvent,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    handleEvent: handleEvent
};
function maybeFromPlaybackRuntimeCommand$5(playbackRuntimeCommand) {
    if (typeof playbackRuntimeCommand === "number") {
        return;
    }
    if (playbackRuntimeCommand.TAG !== /* WithElementGroupsCommand */ 43) {
        return;
    }
    var currentlyIteratingThroughDomElements = playbackRuntimeCommand._0;
    if (typeof currentlyIteratingThroughDomElements === "number" || currentlyIteratingThroughDomElements.TAG === /* HasNotCollectedElementsFromPageYet */ 0) {
        return;
    } else {
        return /* WithElementGroupsCommand */ {
            _0: /* CurrentlyIteratingThroughDomElements */ {
                _0: currentlyIteratingThroughDomElements._0
            }
        };
    }
}
function saveRowToDestination_encode(v) {
    return Js_dict.fromArray([
        [
            "destination",
            Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_encode, v.destination)
        ],
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
            }, v.columns)
        ],
        [
            "maybeExtraColumns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
            }, v.maybeExtraColumns)
        ],
        [
            "row",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
            }, v.row)
        ]
    ]);
}
function saveRowToDestination_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var destination = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
    if (destination.TAG === /* Ok */ 0) {
        var columns = Decco.arrayFromJson(function(param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
        if (columns.TAG === /* Ok */ 0) {
            var maybeExtraColumns = Decco.optionFromJson(function(param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
            if (maybeExtraColumns.TAG === /* Ok */ 0) {
                var row = Decco.arrayFromJson(function(param) {
                    return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "row"), null));
                if (row.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            destination: destination._0,
                            columns: columns._0,
                            maybeExtraColumns: maybeExtraColumns._0,
                            row: row._0
                        }
                    };
                }
                var e = row._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".row" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = maybeExtraColumns._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeExtraColumns" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = columns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".columns" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = destination._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".destination" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function newFinalEffect_encode(v) {
    return [
        "SaveRowToDestination",
        saveRowToDestination_encode(v._0)
    ];
}
function newFinalEffect_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SaveRowToDestination") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = saveRowToDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* SaveRowToDestination */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_encode$1(v) {
    if (typeof v === "number") {
        if (v === /* IterateThroughDataRecords */ 0) {
            return [
                "IterateThroughDataRecords"
            ];
        } else {
            return [
                "DidCompleteCurrentIteration"
            ];
        }
    } else if (v.TAG === /* NewFinalEffect */ 0) {
        return [
            "NewFinalEffect",
            newFinalEffect_encode(v._0)
        ];
    } else {
        return [
            "DidCompleteActionsOnDataRecord",
            DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, v._0)
        ];
    }
}
function event_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DidCompleteActionsOnDataRecord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidCompleteActionsOnDataRecord */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidCompleteCurrentIteration":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidCompleteCurrentIteration */ 1
                    };
                }
            case "IterateThroughDataRecords":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* IterateThroughDataRecords */ 0
                    };
                }
            case "NewFinalEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = newFinalEffect_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewFinalEffect */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sideEffect_encode$1(v) {
    if (typeof v === "number") {
        return [
            "DispatchDidCompleteCurrentIteration"
        ];
    } else if (v.TAG === /* ExecuteActionsWithDataRecord */ 0) {
        return [
            "ExecuteActionsWithDataRecord",
            Decco.arrayToJson(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.action_encode, v._0),
            DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, v._1)
        ];
    } else {
        return [
            "ExecuteFinalEffectsAndDispatchCompletedCommand",
            Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v._0)
        ];
    }
}
function sideEffect_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DispatchDidCompleteCurrentIteration":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DispatchDidCompleteCurrentIteration */ 0
                    };
                }
            case "ExecuteActionsWithDataRecord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.arrayFromJson(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.action_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ExecuteActionsWithDataRecord */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ExecuteFinalEffectsAndDispatchCompletedCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyEvent$1($$event) {
    if (typeof $$event === "number") {
        if ($$event === /* IterateThroughDataRecords */ 0) {
            return "IterateThroughDataRecords";
        } else {
            return "DidCompleteCurrentIteration";
        }
    } else if ($$event.TAG === /* NewFinalEffect */ 0) {
        return "NewFinalEffect(SaveRowToDestination({destination: " + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringifyDestination, $$event._0._0.destination) + ", columns, row}))");
    } else {
        return "DidCompleteActionsOnDataRecord(dataRecord)";
    }
}
function stringifySideEffect(sideEffect) {
    if (typeof sideEffect === "number") {
        return "DispatchDidCompleteCurrentIteration";
    } else if (sideEffect.TAG === /* ExecuteActionsWithDataRecord */ 0) {
        return "ExecuteActionsWithDataRecord(actions=[" + (Belt_Array.map(sideEffect._0, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringifyAction).join(",") + "], dataRecord)");
    } else {
        return "ExecuteFinalEffectsAndDispatchCompletedCommand([" + (Belt_Array.map(sideEffect._0, WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.stringify).join(",") + "])");
    }
}
function executeSideEffect(sideEffect, dispatchEvent, onCompletedFinalEffects, currentUrl) {
    if (typeof sideEffect === "number") {
        return Curry._1(dispatchEvent, /* DidCompleteCurrentIteration */ 1).then(function(param) {
            return {
                TAG: /* Ok */ 0,
                _0: undefined
            };
        });
    }
    if (sideEffect.TAG !== /* ExecuteActionsWithDataRecord */ 0) {
        return PromiseUtils$SmartcutsMacros.sequentiallyEvalResults(function(param) {
            return WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.execute(currentUrl, param);
        }, sideEffect._0).then(function(results) {
            if (results.TAG === /* Ok */ 0) {
                return Curry._1(onCompletedFinalEffects, results._0).then(function(param) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: undefined
                    };
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: results._0.error
                });
            }
        });
    }
    var dataRecord = sideEffect._1;
    return PromiseUtils$SmartcutsMacros.sequentially(function(action) {
        var match = action._0;
        var columns = match.columns;
        var row = DataExtraction__ExportToTable$SmartcutsMacros.rowFromDataNodeWithId(columns, dataRecord);
        return Curry._1(dispatchEvent, {
            TAG: /* NewFinalEffect */ 0,
            _0: /* SaveRowToDestination */ {
                _0: {
                    destination: match.destination,
                    columns: columns,
                    maybeExtraColumns: match.maybeExtraColumns,
                    row: row
                }
            }
        });
    }, sideEffect._0).then(function(_results) {
        return Curry._1(dispatchEvent, {
            TAG: /* DidCompleteActionsOnDataRecord */ 1,
            _0: dataRecord
        });
    }).then(function(param) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    });
}
function handleEvent$1($$event, command) {
    if (typeof $$event === "number") {
        if ($$event === /* IterateThroughDataRecords */ 0) {
            var currentlyIteratingThroughDomElements = command._0._0;
            var match = ArrayUtils$SmartcutsMacros.splitAtFirst(currentlyIteratingThroughDomElements.queuedDataRecords);
            var match$1 = match !== undefined ? [
                match[1],
                [
                    {
                        TAG: /* ExecuteActionsWithDataRecord */ 0,
                        _0: currentlyIteratingThroughDomElements.commandValue.actions,
                        _1: match[0]
                    }
                ]
            ] : [
                [],
                [
                    /* DispatchDidCompleteCurrentIteration */ 0
                ]
            ];
            return [
                {
                    TAG: /* WithElementGroupsCommand */ 43,
                    _0: {
                        TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                        _0: {
                            commandValue: currentlyIteratingThroughDomElements.commandValue,
                            queuedDataRecords: match$1[0],
                            completedDataRecords: currentlyIteratingThroughDomElements.completedDataRecords,
                            finalEffects: currentlyIteratingThroughDomElements.finalEffects
                        }
                    }
                },
                match$1[1]
            ];
        }
        var match$2 = command._0._0;
        var finalEffects = match$2.finalEffects;
        var loadItems = match$2.commandValue.paginateOptions.loadItems;
        if (typeof loadItems === "number") {
            if (loadItems !== 0) {
                return [
                    undefined,
                    [
                        /* PaginateAndCollectDataRecords */ 1
                    ]
                ];
            } else {
                return [
                    undefined,
                    [
                        {
                            TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */ 1,
                            _0: finalEffects
                        }
                    ]
                ];
            }
        }
        var nCompletedItems = match$2.completedDataRecords.length;
        if (nCompletedItems >= loadItems._0) {
            return [
                undefined,
                [
                    {
                        TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */ 1,
                        _0: finalEffects
                    }
                ]
            ];
        } else {
            return [
                undefined,
                [
                    /* PaginateAndCollectDataRecords */ 1
                ]
            ];
        }
    } else {
        if ($$event.TAG === /* NewFinalEffect */ 0) {
            var match$3 = $$event._0._0;
            var maybeExtraColumns = match$3.maybeExtraColumns;
            var columns = match$3.columns;
            var destination = match$3.destination;
            var newRows = [
                match$3.row
            ];
            var currentlyIteratingThroughDomElements$1 = command._0._0;
            var finalEffects$1 = currentlyIteratingThroughDomElements$1.finalEffects;
            var match$4 = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(finalEffect, index) {
                var saveRowsToDestination = finalEffect._0;
                if (Caml_obj.caml_equal(saveRowsToDestination.destination, destination)) {
                    return [
                        saveRowsToDestination.rows,
                        index
                    ];
                }
            }, finalEffects$1);
            var nextFinalEffects = match$4 !== undefined ? ArrayUtils$SmartcutsMacros.replaceAtIndex(finalEffects$1, match$4[1], /* SaveRowsToDestination */ {
                _0: {
                    destination: destination,
                    columns: columns,
                    maybeExtraColumns: maybeExtraColumns,
                    rows: Belt_Array.concat(match$4[0], newRows)
                }
            }) : [
                /* SaveRowsToDestination */ {
                    _0: {
                        destination: destination,
                        columns: columns,
                        maybeExtraColumns: maybeExtraColumns,
                        rows: newRows
                    }
                }
            ];
            return [
                {
                    TAG: /* WithElementGroupsCommand */ 43,
                    _0: {
                        TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                        _0: {
                            commandValue: currentlyIteratingThroughDomElements$1.commandValue,
                            queuedDataRecords: currentlyIteratingThroughDomElements$1.queuedDataRecords,
                            completedDataRecords: currentlyIteratingThroughDomElements$1.completedDataRecords,
                            finalEffects: nextFinalEffects
                        }
                    }
                },
                []
            ];
        }
        var currentlyIteratingThroughDomElements$2 = command._0._0;
        var match$5 = ArrayUtils$SmartcutsMacros.splitAtFirst(currentlyIteratingThroughDomElements$2.queuedDataRecords);
        var match$6 = match$5 !== undefined ? [
            match$5[1],
            [
                {
                    TAG: /* ExecuteActionsWithDataRecord */ 0,
                    _0: currentlyIteratingThroughDomElements$2.commandValue.actions,
                    _1: match$5[0]
                }
            ]
        ] : [
            [],
            [
                /* DispatchDidCompleteCurrentIteration */ 0
            ]
        ];
        return [
            {
                TAG: /* WithElementGroupsCommand */ 43,
                _0: {
                    TAG: /* CurrentlyIteratingThroughDomElements */ 1,
                    _0: {
                        commandValue: currentlyIteratingThroughDomElements$2.commandValue,
                        queuedDataRecords: match$6[0],
                        completedDataRecords: Belt_Array.concat(currentlyIteratingThroughDomElements$2.completedDataRecords, [
                            $$event._0
                        ]),
                        finalEffects: currentlyIteratingThroughDomElements$2.finalEffects
                    }
                }
            },
            match$6[1]
        ];
    }
}
var CommandThatIteratesOverDataRecords = {
    maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$5,
    saveRowToDestination_encode: saveRowToDestination_encode,
    saveRowToDestination_decode: saveRowToDestination_decode,
    newFinalEffect_encode: newFinalEffect_encode,
    newFinalEffect_decode: newFinalEffect_decode,
    event_encode: event_encode$1,
    event_decode: event_decode$1,
    sideEffect_encode: sideEffect_encode$1,
    sideEffect_decode: sideEffect_decode$1,
    stringifyEvent: stringifyEvent$1,
    stringifySideEffect: stringifySideEffect,
    executeSideEffect: executeSideEffect,
    handleEvent: handleEvent$1
};
function isFollowedBySubsequentNetworkLatency(command) {
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
            case /* ForwardCommand */ 1:
            case /* BackCommand */ 2:
                return true;
        }
    } else {
        switch(command.TAG | 0){
            case /* ClickCommand */ 12:
                var match = Selector$SmartcutsMacros.maybeGetLeafNode(command._0.selector);
                if (match === undefined) {
                    return false;
                }
                var s = match.innerText;
                if (typeof s === "number") {
                    return false;
                }
                if (s.TAG !== /* FullInnerText */ 0) {
                    return false;
                }
                var match$1 = $$String.lowercase_ascii(s._0);
                switch(match$1){
                    case "confirm":
                    case "create":
                    case "save":
                        return true;
                    default:
                        return false;
                }
            case /* NewWindowWithUrlCommand */ 1:
            case /* NewTabWithUrlCommand */ 3:
            case /* URLCommand */ 6:
            case /* OpenedLinkCommand */ 7:
            case /* SubmitFormCommand */ 8:
            case /* SubmitFormRedirectCommand */ 9:
            case /* ClientRedirectCommand */ 10:
            case /* ServerRedirectCommand */ 11:
            case /* ClickToOAuthCommand */ 40:
            case /* UploadCommand */ 41:
                return true;
            default:
                return false;
        }
    }
}
function selectorGet(command) {
    if (typeof command === "number") {
        return [];
    }
    switch(command.TAG | 0){
        case /* ClickCommand */ 12:
            return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickInputCommand */ 13:
            return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickContentEditableCommand */ 14:
            return Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* TypeCommand */ 15:
            return Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* CheckboxCommand */ 16:
            return Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.CheckboxPlaybackCommandValue.selectorGet, command._0);
        case /* SelectCommand */ 17:
            return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* RadioCommand */ 18:
            return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* MoveInputCursorCommand */ 22:
            return Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* MoveContentEditableCursorCommand */ 23:
            return Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* CopyLinkAddressCommand */ 25:
            return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* SelectionCommand */ 21:
        case /* CopyCommand */ 24:
        case /* CutCommand */ 26:
            break;
        case /* PasteInInputCommand */ 27:
            return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasteInContentEditableCommand */ 28:
            return Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* DragCommand */ 29:
        case /* DropCommand */ 30:
            return [
                command._0
            ];
        case /* ScrollCommand */ 31:
            return ScrollCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* ContextMenuCommand */ 34:
            return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* LoopCommand */ 35:
            return LoopCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* SwitchCommand */ 36:
            var commandValue = command._0;
            if (commandValue.TAG !== /* HasNotEvaluated */ 0) {
                return [];
            }
            var func = SwitchCommand$SmartcutsMacros.CommandValue.selectorGet;
            return Curry._2(func, selectorGet, commandValue._0);
        case /* ScreenshotToClipboardCommand */ 37:
            return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasteImageInContentEditableCommand */ 38:
            return Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasswordCommand */ 39:
            return Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickToOAuthCommand */ 40:
            return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* UploadCommand */ 41:
            return UploadCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* CopyImageSrcCommand */ 42:
            return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* WithElementGroupsCommand */ 43:
            return [];
        default:
            return [];
    }
    return Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
}
function updateNextOpenedLinkCommandWithPlaybackUrl(tabId, playbackUrl, commands) {
    var match = ArrayUtils$SmartcutsMacros.firstMatchi(function(param) {
        var command = param.command;
        if (typeof command === "number") {
            return false;
        }
        if (command.TAG !== /* OpenedLinkCommand */ 7) {
            return false;
        }
        var playbackTabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(command._0.tabRef);
        if (playbackTabId !== undefined) {
            return Caml_obj.caml_equal(Caml_option.valFromOption(playbackTabId), tabId);
        } else {
            return false;
        }
    }, commands);
    if (match === undefined) {
        return commands;
    }
    var commandWithContextGlobal = match[0];
    var cmdVal = commandWithContextGlobal.command;
    if (typeof cmdVal === "number") {
        return commands;
    }
    if (cmdVal.TAG !== /* OpenedLinkCommand */ 7) {
        return commands;
    }
    var contextGlobal = commandWithContextGlobal.contextGlobal;
    var cmdVal$1 = cmdVal._0;
    return ArrayUtils$SmartcutsMacros.replaceAtIndex(commands, match[1], {
        id: commandWithContextGlobal.id,
        command: {
            TAG: /* OpenedLinkCommand */ 7,
            _0: {
                tabRef: cmdVal$1.tabRef,
                windowRef: cmdVal$1.windowRef,
                url: playbackUrl,
                title: cmdVal$1.title,
                maybeOpenerTab: cmdVal$1.maybeOpenerTab,
                viaHistoryApi: cmdVal$1.viaHistoryApi
            }
        },
        contextGlobal: {
            windowRef: contextGlobal.windowRef,
            tabRef: contextGlobal.tabRef,
            url: playbackUrl,
            focusStatus: contextGlobal.focusStatus,
            title: contextGlobal.title,
            frame: contextGlobal.frame,
            windowGeometry: contextGlobal.windowGeometry,
            targetBoundingRect: contextGlobal.targetBoundingRect,
            timestamp: contextGlobal.timestamp,
            htmlSnapshot: contextGlobal.htmlSnapshot,
            screenshot: contextGlobal.screenshot,
            croppedScreenshot: contextGlobal.croppedScreenshot,
            preconditions: contextGlobal.preconditions,
            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
        }
    });
}
exports.CommandWithContextGlobal = CommandWithContextGlobal;
exports.CommandType = CommandType;
exports.SwitchCommandPlaybackRuntime = SwitchCommandPlaybackRuntime;
exports.WithElementGroupsCommandPlaybackRuntime = WithElementGroupsCommandPlaybackRuntime;
exports.tabDidEvaluateSwitchCommand_encode = tabDidEvaluateSwitchCommand_encode;
exports.tabDidEvaluateSwitchCommand_decode = tabDidEvaluateSwitchCommand_decode;
exports.mapSwitchCommand = mapSwitchCommand;
exports.CommandThatCanPushFrame = CommandThatCanPushFrame;
exports.CommandThatSignifyPageLoad = CommandThatSignifyPageLoad;
exports.CommandThatContainsTabRefInCommandValue = CommandThatContainsTabRefInCommandValue;
exports.CommandThatContainsWindowRefInCommandValue = CommandThatContainsWindowRefInCommandValue;
exports.CommandThatCanUpdateUrl = CommandThatCanUpdateUrl;
exports.WithContextGlobal = WithContextGlobal$2;
exports.CommandThatCollectsDataRecords = CommandThatCollectsDataRecords;
exports.CommandThatIteratesOverDataRecords = CommandThatIteratesOverDataRecords;
exports.isFollowedBySubsequentNetworkLatency = isFollowedBySubsequentNetworkLatency;
exports.selectorGet = selectorGet;
exports.updateNextOpenedLinkCommandWithPlaybackUrl = updateNextOpenedLinkCommandWithPlaybackUrl; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 31166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ExternalAccount$SmartcutsMacros = __webpack_require__(45543);
var ExtensionMessaging__FromTab$SmartcutsMacros = __webpack_require__(44409);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var basicEvent_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode;
var basicEvent_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode;
function extractRespondToBgFromEvent($$event) {
    if ($$event.TAG === /* MessageFromExtension */ 0) {
        return $$event._1;
    }
}
function askBgScriptToFetchAuthToken(maybeExtensionId, param) {
    var sendMessage_FindExternalAccountById = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.FindExternalAccountById.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.FindExternalAccountById.encodeAndSendMessage;
    return Curry._1(sendMessage_FindExternalAccountById, /* FindExternalAccountById */ {
        _0: ExternalAccount$SmartcutsMacros.stringifyProvider(/* Google */ 0)
    }).then(function(result1) {
        if (result1.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: /* ResponseErrorFromBg */ {
                    _0: result1._0
                }
            });
        }
        var _expired = result1._0;
        if (!_expired) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: /* UserNeverAuthed */ 0
            });
        }
        var _expired$1 = _expired._0;
        if (_expired$1.refreshedAt > Date.now() - 3600000) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: _expired$1.authToken
            });
        }
        var sendMessage_GetOAuthToken = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.GetOAuthToken.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.GetOAuthToken.encodeAndSendMessage;
        return Curry._1(sendMessage_GetOAuthToken, /* GetOAuthToken */ {
            _0: true
        }).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* ResponseErrorFromBg */ {
                        _0: result._0
                    }
                });
            }
            var authToken = result._0;
            if (!authToken) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* DidNotGetOAuthToken */ 1
                });
            }
            var authToken$1 = authToken._0;
            var sendMessage_SaveExternalAccount = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.SaveExternalAccount.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.SaveExternalAccount.encodeAndSendMessage;
            return Curry._1(sendMessage_SaveExternalAccount, /* SaveExternalAccount */ {
                _0: {
                    provider: /* Google */ 0,
                    authToken: authToken$1,
                    refreshedAt: Date.now()
                }
            }).then(function(_response) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: authToken$1
                });
            });
        });
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            return Promise.resolve(result._0);
        }
        var message = result._0;
        if (typeof message === "number") {
            if (message !== 0) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Did not get auth token");
            } else {
                return Promise.resolve(undefined);
            }
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError(message._0);
        }
    });
}
var Types;
exports.Types = Types;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.extractRespondToBgFromEvent = extractRespondToBgFromEvent;
exports.askBgScriptToFetchAuthToken = askBgScriptToFetchAuthToken; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 24738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var SelectorOverrides$SmartcutsMacros = __webpack_require__(51670);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var rejectToExtension_encode = ExtensionMessaging$SmartcutsMacros.rejectToBg_encode;
var rejectToExtension_decode = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode;
function basicEvent_encode(v) {
    if (v.TAG === /* MessageFromExtension */ 0) {
        return [
            "MessageFromExtension",
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v._0),
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1),
            ExtensionMessaging$SmartcutsMacros.rejectToBg_encode(v._2)
        ];
    } else {
        return [
            "DidGetNewAuthToken",
            Decco.stringToJson(v._0)
        ];
    }
}
function basicEvent_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DidGetNewAuthToken":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidGetNewAuthToken */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "MessageFromExtension":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* MessageFromExtension */ 0,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function otherFailureReason_encode(v) {
    if (typeof v === "number") {
        return [
            "UnhandledException"
        ];
    }
    switch(v.TAG | 0){
        case /* InvalidUrl */ 0:
            return [
                "InvalidUrl",
                Decco.stringToJson(v._0)
            ];
        case /* InvalidArgument */ 1:
            return [
                "InvalidArgument",
                Decco.stringToJson(v._0)
            ];
        case /* FailWithElementNotFound */ 2:
            return [
                "FailWithElementNotFound",
                Decco.stringToJson(v._0),
                Selector$SmartcutsMacros.selector_encode(v._1)
            ];
        case /* FailWithElementNotFound2 */ 3:
            return [
                "FailWithElementNotFound2",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
            ];
        case /* FailWithErrorWhileSearchForElement */ 4:
            return [
                "FailWithErrorWhileSearchForElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
            ];
    }
}
function otherFailureReason_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FailWithElementNotFound":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithElementNotFound */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "FailWithElementNotFound2":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithElementNotFound2 */ 3,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "FailWithErrorWhileSearchForElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithErrorWhileSearchForElement */ 4,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "InvalidArgument":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InvalidArgument */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e$6 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "InvalidUrl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InvalidUrl */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$7 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "UnhandledException":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UnhandledException */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyOtherFailureReason(reason) {
    if (typeof reason === "number") {
        return "UnhandledException";
    }
    switch(reason.TAG | 0){
        case /* InvalidUrl */ 0:
            return "InvalidUrl(" + (StringUtils$SmartcutsMacros.quote(reason._0) + ")");
        case /* InvalidArgument */ 1:
            return "InvalidArgument(" + (reason._0 + ")");
        case /* FailWithElementNotFound */ 2:
            return "FailWithElementNotFound(" + (reason._0 + ", selector)");
        case /* FailWithElementNotFound2 */ 3:
            return "FailWithElementNotFound2(" + (reason._0 + ", locator)");
        case /* FailWithErrorWhileSearchForElement */ 4:
            return "FailWithErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + (reason._1 + ")"));
    }
}
exports.rejectToExtension_encode = rejectToExtension_encode;
exports.rejectToExtension_decode = rejectToExtension_decode;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.otherFailureReason_encode = otherFailureReason_encode;
exports.otherFailureReason_decode = otherFailureReason_decode;
exports.stringifyOtherFailureReason = stringifyOtherFailureReason; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 36570:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var ExtErrors__OverlayBlocking$SmartcutsMacros = __webpack_require__(18962);
var SelectorOverrideWithoutScope$SmartcutsMacros = __webpack_require__(65443);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros = __webpack_require__(39658);
var SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros = __webpack_require__(14868);
var SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros = __webpack_require__(81588);
var SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros = __webpack_require__(69932);
var SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros = __webpack_require__(61569);
function searchElementTimedOut_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "ms",
            Decco.floatToJson(v.ms)
        ]
    ]);
}
function searchElementTimedOut_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var ms = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ms"), null));
        if (ms.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    ms: ms._0
                }
            };
        }
        var e = ms._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".ms" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function querySelectorTimedOut_encode(v) {
    return Js_dict.fromArray([
        [
            "querySelector",
            Decco.stringToJson(v.querySelector)
        ],
        [
            "ms",
            Decco.floatToJson(v.ms)
        ]
    ]);
}
function querySelectorTimedOut_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var querySelector = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "querySelector"), null));
    if (querySelector.TAG === /* Ok */ 0) {
        var ms = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ms"), null));
        if (ms.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    querySelector: querySelector._0,
                    ms: ms._0
                }
            };
        }
        var e = ms._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".ms" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = querySelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".querySelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode(v) {
    if (v) {
        return [
            "CouldNotCaptureScreenshot"
        ];
    } else {
        return [
            "CouldNotGetBoxModel"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotCaptureScreenshot":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CouldNotCaptureScreenshot */ 1
                    };
                }
            case "CouldNotGetBoxModel":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CouldNotGetBoxModel */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v) {
        return "CouldNotCaptureScreenshot";
    } else {
        return "CouldNotGetBoxModel";
    }
}
var PlaybackCaptureScreenshotError = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(encoder_constrain, encoder_domElement, v) {
    if (typeof v === "number") {
        switch(v){
            case /* CdpUnableToGetContentQuads */ 0:
                return [
                    "CdpUnableToGetContentQuads"
                ];
            case /* CdpUnableToGetDocument */ 1:
                return [
                    "CdpUnableToGetDocument"
                ];
            case /* TabOrWindowNotVisible */ 2:
                return [
                    "TabOrWindowNotVisible"
                ];
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 3:
                return [
                    "TabOrWindowVisibilityUnknownOrUnloaded"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* NonInputSelectionSemanticError */ 0:
                return [
                    "NonInputSelectionSemanticError",
                    SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
            case /* InputSelectionSemanticError */ 1:
                return [
                    "InputSelectionSemanticError",
                    SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
            case /* InputCursorSemanticError */ 2:
                return [
                    "InputCursorSemanticError",
                    SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
            case /* ContentEditableCursorSemanticError */ 3:
                return [
                    "ContentEditableCursorSemanticError",
                    SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.semanticError_encode(v._0)
                ];
            case /* ContentEditableSelectionSemanticError */ 4:
                return [
                    "ContentEditableSelectionSemanticError",
                    SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._0)
                ];
            case /* OverlayStillBlockingElementAfterMs */ 5:
                return [
                    "OverlayStillBlockingElementAfterMs",
                    ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(encoder_domElement, v._0)
                ];
            case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6:
                return [
                    "ErrorWhileWaitForPossibleOverlayToDisappear",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* SearchElementTimedOut */ 7:
                return [
                    "SearchElementTimedOut",
                    searchElementTimedOut_encode(v._0)
                ];
            case /* QuerySelectorOverridesTimedOut */ 8:
                return [
                    "QuerySelectorOverridesTimedOut",
                    Decco.arrayToJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_encode, v._0)
                ];
            case /* ErrorWhileSearchForElement */ 9:
                return [
                    "ErrorWhileSearchForElement",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* CdpQuerySelectorTimedOut */ 10:
                return [
                    "CdpQuerySelectorTimedOut",
                    querySelectorTimedOut_encode(v._0)
                ];
            case /* ErrorWhileCdpQuerySelector */ 11:
                return [
                    "ErrorWhileCdpQuerySelector",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* PlaybackCaptureScreenshotError */ 12:
                return [
                    "PlaybackCaptureScreenshotError",
                    t_encode(v._0)
                ];
            case /* ContentScriptResponseError */ 13:
                return [
                    "ContentScriptResponseError",
                    InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v._0)
                ];
            case /* UnhandledContentScriptPromiseError */ 14:
                return [
                    "UnhandledContentScriptPromiseError",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
        }
    }
}
function t_decode$1(decoder_constrain, decoder_domElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CdpQuerySelectorTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = querySelectorTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CdpQuerySelectorTimedOut */ 10,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CdpUnableToGetContentQuads":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CdpUnableToGetContentQuads */ 0
                    };
                }
            case "CdpUnableToGetDocument":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CdpUnableToGetDocument */ 1
                    };
                }
            case "ContentEditableCursorSemanticError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditableCursorSemanticError */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ContentEditableSelectionSemanticError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = SelectionSemantics__ContentEditableSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditableSelectionSemanticError */ 4,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ContentScriptResponseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentScriptResponseError */ 13,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ErrorWhileCdpQuerySelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorWhileCdpQuerySelector */ 11,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "ErrorWhileSearchForElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorWhileSearchForElement */ 9,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "ErrorWhileWaitForPossibleOverlayToDisappear":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "InputCursorSemanticError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = SelectionSemantics__InputCursorSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputCursorSemanticError */ 2,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "InputSelectionSemanticError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = SelectionSemantics__InputSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputSelectionSemanticError */ 1,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "NonInputSelectionSemanticError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "OverlayStillBlockingElementAfterMs":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(decoder_domElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OverlayStillBlockingElementAfterMs */ 5,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "PlaybackCaptureScreenshotError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlaybackCaptureScreenshotError */ 12,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "QuerySelectorOverridesTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = Decco.arrayFromJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* QuerySelectorOverridesTimedOut */ 8,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "SearchElementTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = searchElementTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SearchElementTimedOut */ 7,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "TabOrWindowNotVisible":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TabOrWindowNotVisible */ 2
                    };
                }
            case "TabOrWindowVisibilityUnknownOrUnloaded":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TabOrWindowVisibilityUnknownOrUnloaded */ 3
                    };
                }
            case "UnhandledContentScriptPromiseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UnhandledContentScriptPromiseError */ 14,
                            _0: v0$14._0
                        }
                    };
                }
                var e$14 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.searchElementTimedOut_encode = searchElementTimedOut_encode;
exports.searchElementTimedOut_decode = searchElementTimedOut_decode;
exports.querySelectorTimedOut_encode = querySelectorTimedOut_encode;
exports.querySelectorTimedOut_decode = querySelectorTimedOut_decode;
exports.PlaybackCaptureScreenshotError = PlaybackCaptureScreenshotError;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 18962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
function overlayStillBlockingElementAfterMs_encode(encoder_domElement, v) {
    return Js_dict.fromArray([
        [
            "element",
            Curry._1(encoder_domElement, v.element)
        ],
        [
            "maybeOverlayElement",
            Decco.optionToJson(encoder_domElement, v.maybeOverlayElement)
        ],
        [
            "ms",
            Decco.floatToJson(v.ms)
        ]
    ]);
}
function overlayStillBlockingElementAfterMs_decode(decoder_domElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var element = Curry._1(decoder_domElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "element"), null));
    if (element.TAG === /* Ok */ 0) {
        var maybeOverlayElement = Decco.optionFromJson(decoder_domElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeOverlayElement"), null));
        if (maybeOverlayElement.TAG === /* Ok */ 0) {
            var ms = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ms"), null));
            if (ms.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        element: element._0,
                        maybeOverlayElement: maybeOverlayElement._0,
                        ms: ms._0
                    }
                };
            }
            var e = ms._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".ms" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = maybeOverlayElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybeOverlayElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = element._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".element" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
exports.overlayStillBlockingElementAfterMs_encode = overlayStillBlockingElementAfterMs_encode;
exports.overlayStillBlockingElementAfterMs_decode = overlayStillBlockingElementAfterMs_decode; /* No side effect */ 


/***/ }),

/***/ 31052:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function rejectToSender_encode(_fn) {
    return "rejectToSender";
}
function rejectToSender_decode(encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
        if (str === "rejectToSender") {
            return {
                TAG: /* Ok */ 0,
                _0: function(_exn) {}
            };
        } else {
            return Decco.error(undefined, "Expected 'rejectToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
        }
    } else {
        return Decco.error(undefined, "Couldn't decode json into rejectToSender", encoded);
    }
}
function rejectToTab_encode(v) {
    return "rejectToSender";
}
var rejectToTab_decode = rejectToSender_decode;
function rejectToBg_encode(v) {
    return "rejectToSender";
}
var rejectToBg_decode = rejectToSender_decode;
var FromExtension;
var FromTab;
exports.rejectToSender_encode = rejectToSender_encode;
exports.rejectToSender_decode = rejectToSender_decode;
exports.rejectToTab_encode = rejectToTab_encode;
exports.rejectToTab_decode = rejectToTab_decode;
exports.rejectToBg_encode = rejectToBg_encode;
exports.rejectToBg_decode = rejectToBg_decode;
exports.FromExtension = FromExtension;
exports.FromTab = FromTab; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 15462:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Command$SmartcutsMacros = __webpack_require__(4290);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var RenderOnHost$SmartcutsMacros = __webpack_require__(95421);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var Browser__Runtime$SmartcutsMacros = __webpack_require__(59508);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var SelectorOverrides$SmartcutsMacros = __webpack_require__(51670);
var SelectionSemantics$SmartcutsMacros = __webpack_require__(8741);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var CommandPreconditions$SmartcutsMacros = __webpack_require__(89645);
var CommandPlaybackRuntime$SmartcutsMacros = __webpack_require__(500);
var RenderOnHost__Geometry$SmartcutsMacros = __webpack_require__(1763);
var HighlightElement__Shared$SmartcutsMacros = __webpack_require__(98226);
var MultiUrlTriggering__Types$SmartcutsMacros = __webpack_require__(12433);
var DataExtraction__DataRecord$SmartcutsMacros = __webpack_require__(57870);
var ExtErrors__OverlayBlocking$SmartcutsMacros = __webpack_require__(18962);
var ExtensionMessagingBuilders$SmartcutsMacros = __webpack_require__(23158);
var MultiUrlTriggering__Shared$SmartcutsMacros = __webpack_require__(8641);
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = __webpack_require__(28538);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
function message_encode(v) {
    return [
        "StartStreamingEventsToBackground"
    ];
}
function message_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "StartStreamingEventsToBackground") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* StartStreamingEventsToBackground */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode(v) {
    return [
        "TabDidSetupEventStreaming"
    ];
}
function response_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TabDidSetupEventStreaming") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* TabDidSetupEventStreaming */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_StartStreamingEventsToBackground = {
    message_encode: message_encode,
    message_decode: message_decode,
    response_encode: response_encode,
    response_decode: response_decode
};
function message_encode$1(v) {
    return [
        "StopStreamingEventsToBackground"
    ];
}
function message_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "StopStreamingEventsToBackground") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* StopStreamingEventsToBackground */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$1(v) {
    return [
        "TabDidStopStreamingEventsToBackground"
    ];
}
function response_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TabDidStopStreamingEventsToBackground") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* TabDidStopStreamingEventsToBackground */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_StopStreamingEventsToBackground = {
    message_encode: message_encode$1,
    message_decode: message_decode$1,
    response_encode: response_encode$1,
    response_decode: response_decode$1
};
function message_encode$2(v) {
    return [
        "Playback",
        Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
        PlaybackOptions$SmartcutsMacros.t_encode(v._1),
        Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v._2)
    ];
}
function message_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Playback") {
        if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var match$1 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
        var match$2 = PlaybackOptions$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
        var match$3 = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 3));
        if (match$1.TAG === /* Ok */ 0) {
            if (match$2.TAG === /* Ok */ 0) {
                if (match$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Playback */ {
                            _0: match$1._0,
                            _1: match$2._0,
                            _2: match$3._0
                        }
                    };
                }
                var e = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = match$1._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function tabDidCollectDataGroups_encode(v) {
    return Js_dict.fromArray([
        [
            "dataRecordsWithDataNodeId",
            Decco.arrayToJson(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
            }, v.dataRecordsWithDataNodeId)
        ]
    ]);
}
function tabDidCollectDataGroups_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dataRecordsWithDataNodeId = Decco.arrayFromJson(function(param) {
        return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict._0, "dataRecordsWithDataNodeId"), null));
    if (dataRecordsWithDataNodeId.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                dataRecordsWithDataNodeId: dataRecordsWithDataNodeId._0
            }
        };
    }
    var e = dataRecordsWithDataNodeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataRecordsWithDataNodeId" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function response_encode$2(v) {
    if (typeof v === "number") {
        return [
            "TabDidPlaybackCommand"
        ];
    }
    switch(v.TAG | 0){
        case /* TabDidClickLink */ 0:
            return [
                "TabDidClickLink",
                Decco.stringToJson(v._0)
            ];
        case /* TabDidCopyText */ 1:
            return [
                "TabDidCopyText",
                Decco.stringToJson(v._0)
            ];
        case /* TabDidTakeScreenshot */ 2:
            return [
                "TabDidTakeScreenshot",
                Decco.stringToJson(v._0),
                Image$SmartcutsMacros.Metadata.t_encode(v._1)
            ];
        case /* TabDidCollectDataGroups */ 3:
            return [
                "TabDidCollectDataGroups",
                tabDidCollectDataGroups_encode(v._0)
            ];
        case /* TabCouldNotFindElement */ 4:
            return [
                "TabCouldNotFindElement",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
            ];
        case /* TabOrWindowNotVisible */ 5:
            return [
                "TabOrWindowNotVisible",
                Decco.stringToJson(v._0)
            ];
        case /* TabOrWindowVisibilityUnknownOrUnloaded */ 6:
            return [
                "TabOrWindowVisibilityUnknownOrUnloaded",
                Decco.stringToJson(v._0)
            ];
        case /* TabCouldNotApplySemantic */ 7:
            return [
                "TabCouldNotApplySemantic",
                SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* TabCannotCopyMissingSrcOfImg */ 8:
            return [
                "TabCannotCopyMissingSrcOfImg",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
            ];
        case /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */ 9:
            return [
                "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement",
                ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(Decco.stringToJson, v._0),
                Decco.stringToJson(v._1)
            ];
        case /* ErrorWhileWaitForOverlayToStopBlockingElement */ 10:
            return [
                "ErrorWhileWaitForOverlayToStopBlockingElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
            ];
        case /* ErrorWhileSearchForElement */ 11:
            return [
                "ErrorWhileSearchForElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
            ];
        case /* TabDidEvaluateSwitchCommand */ 12:
            return [
                "TabDidEvaluateSwitchCommand",
                CommandPlaybackRuntime$SmartcutsMacros.tabDidEvaluateSwitchCommand_encode(v._0)
            ];
        case /* UnimplementedInTab */ 13:
            return [
                "UnimplementedInTab",
                Decco.stringToJson(v._0)
            ];
    }
}
function response_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ErrorWhileSearchForElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ErrorWhileSearchForElement */ 11,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ErrorWhileWaitForOverlayToStopBlockingElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ErrorWhileWaitForOverlayToStopBlockingElement */ 10,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "TabCannotCopyMissingSrcOfImg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TabCannotCopyMissingSrcOfImg */ 8,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "TabCouldNotApplySemantic":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TabCouldNotApplySemantic */ 7,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$6 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "TabCouldNotFindElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TabCouldNotFindElement */ 4,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$8 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */ 9,
                                _0: match$11._0,
                                _1: match$12._0
                            }
                        };
                    }
                    var e$10 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "TabDidClickLink":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabDidClickLink */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$12 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "TabDidCollectDataGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = tabDidCollectDataGroups_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabDidCollectDataGroups */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$13 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "TabDidCopyText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabDidCopyText */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$14 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "TabDidEvaluateSwitchCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = CommandPlaybackRuntime$SmartcutsMacros.tabDidEvaluateSwitchCommand_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabDidEvaluateSwitchCommand */ 12,
                            _0: v0$3._0
                        }
                    };
                }
                var e$15 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "TabDidPlaybackCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TabDidPlaybackCommand */ 0
                    };
                }
            case "TabDidTakeScreenshot":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$13 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$14 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$13.TAG === /* Ok */ 0) {
                    if (match$14.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TabDidTakeScreenshot */ 2,
                                _0: match$13._0,
                                _1: match$14._0
                            }
                        };
                    }
                    var e$16 = match$14._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "TabOrWindowNotVisible":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabOrWindowNotVisible */ 5,
                            _0: v0$4._0
                        }
                    };
                }
                var e$18 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "TabOrWindowVisibilityUnknownOrUnloaded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TabOrWindowVisibilityUnknownOrUnloaded */ 6,
                            _0: v0$5._0
                        }
                    };
                }
                var e$19 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "UnimplementedInTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UnimplementedInTab */ 13,
                            _0: v0$6._0
                        }
                    };
                }
                var e$20 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_Playback = {
    message_encode: message_encode$2,
    message_decode: message_decode$2,
    response_encode: response_encode$2,
    response_decode: response_decode$2,
    tabDidCollectDataGroups_encode: tabDidCollectDataGroups_encode,
    tabDidCollectDataGroups_decode: tabDidCollectDataGroups_decode
};
function message_encode$3(v) {
    return [
        "PlaybackExited"
    ];
}
function message_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "PlaybackExited") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* PlaybackExited */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$3(v) {
    return [
        "AckPlaybackExited"
    ];
}
function response_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckPlaybackExited") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckPlaybackExited */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_PlaybackExited = {
    message_encode: message_encode$3,
    message_decode: message_decode$3,
    response_encode: response_encode$3,
    response_decode: response_decode$3
};
function message_encode$4(v) {
    if (v) {
        return [
            "RenderInContentScript",
            RenderOnHost$SmartcutsMacros.t_encode(v._0)
        ];
    } else {
        return [
            "RemoveRenderedContent"
        ];
    }
}
function message_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "RemoveRenderedContent":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveRenderedContent */ 0
                    };
                }
            case "RenderInContentScript":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = RenderOnHost$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderInContentScript */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$4(v) {
    return [
        "AckRenderInContentScript"
    ];
}
function response_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckRenderInContentScript") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckRenderInContentScript */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_RenderInContentScript = {
    message_encode: message_encode$4,
    message_decode: message_decode$4,
    response_encode: response_encode$4,
    response_decode: response_decode$4
};
function message_encode$5(v) {
    return [
        "AskContentScriptToAdjustModalGeometry",
        RenderOnHost__Geometry$SmartcutsMacros.t_encode(v._0)
    ];
}
function message_decode$5(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskContentScriptToAdjustModalGeometry") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = RenderOnHost__Geometry$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskContentScriptToAdjustModalGeometry */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$5(v) {
    if (v) {
        return [
            "ContentScriptDidNotAdjustModalGeometry"
        ];
    } else {
        return [
            "ContentScriptDidAdjustModalGeometry"
        ];
    }
}
function response_decode$5(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentScriptDidAdjustModalGeometry":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentScriptDidAdjustModalGeometry */ 0
                    };
                }
            case "ContentScriptDidNotAdjustModalGeometry":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentScriptDidNotAdjustModalGeometry */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskContentScriptToAdjustModalGeometry = {
    message_encode: message_encode$5,
    message_decode: message_decode$5,
    response_encode: response_encode$5,
    response_decode: response_decode$5
};
function params_encode(v) {
    return Js_dict.fromArray([
        [
            "maybeTriggeringLinkUrlAndText",
            Decco.optionToJson(function(param) {
                return [
                    Decco.stringToJson(param[0]),
                    Decco.optionToJson(Decco.stringToJson, param[1])
                ];
            }, v.maybeTriggeringLinkUrlAndText)
        ],
        [
            "isPlaybackMode",
            Decco.boolToJson(v.isPlaybackMode)
        ]
    ]);
}
function params_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var maybeTriggeringLinkUrlAndText = Decco.optionFromJson(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.stringFromJson(v0);
        var match$3 = Decco.optionFromJson(Decco.stringFromJson, v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeTriggeringLinkUrlAndText"), null));
    if (maybeTriggeringLinkUrlAndText.TAG === /* Ok */ 0) {
        var isPlaybackMode = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isPlaybackMode"), null));
        if (isPlaybackMode.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    maybeTriggeringLinkUrlAndText: maybeTriggeringLinkUrlAndText._0,
                    isPlaybackMode: isPlaybackMode._0
                }
            };
        }
        var e1 = isPlaybackMode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".isPlaybackMode" + e1.path,
                message: e1.message,
                value: e1.value
            }
        };
    }
    var e$110 = maybeTriggeringLinkUrlAndText._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybeTriggeringLinkUrlAndText" + e$110.path,
            message: e$110.message,
            value: e$110.value
        }
    };
}
function message_encode$6(v) {
    return [
        "AskContentScriptToEnterUrlTriggeringMode",
        params_encode(v._0)
    ];
}
function message_decode$6(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskContentScriptToEnterUrlTriggeringMode") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = params_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskContentScriptToEnterUrlTriggeringMode */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$6(v) {
    if (v) {
        return [
            "RequiresUserToTryAgain"
        ];
    } else {
        return [
            "ContentScriptDidEnterUrlTriggeringMode"
        ];
    }
}
function response_decode$6(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentScriptDidEnterUrlTriggeringMode":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentScriptDidEnterUrlTriggeringMode */ 0
                    };
                }
            case "RequiresUserToTryAgain":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RequiresUserToTryAgain */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskContentScriptToEnterUrlTriggeringMode = {
    message_encode: message_encode$6,
    message_decode: message_decode$6,
    params_encode: params_encode,
    params_decode: params_decode,
    response_encode: response_encode$6,
    response_decode: response_decode$6
};
function message_encode$7(v) {
    return [
        "RefreshLinks",
        Decco.arrayToJson(function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
        }, v._0),
        MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1),
        Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v._2),
        MultiUrlTriggering__Shared$SmartcutsMacros.Step.t_encode(v._3),
        Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode, v._4)
    ];
}
function message_decode$7(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "RefreshLinks") {
        if (tagged.length !== 6) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var match$1 = Decco.arrayFromJson(function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
        }, Belt_Array.getExn(jsonArr$1, 1));
        var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
        var match$3 = Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Array.getExn(jsonArr$1, 3));
        var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.Step.t_decode(Belt_Array.getExn(jsonArr$1, 4));
        var match$5 = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode, Belt_Array.getExn(jsonArr$1, 5));
        if (match$1.TAG === /* Ok */ 0) {
            if (match$2.TAG === /* Ok */ 0) {
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        if (match$5.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: /* RefreshLinks */ {
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0,
                                    _3: match$4._0,
                                    _4: match$5._0
                                }
                            };
                        }
                        var e = match$5._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[4]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[3]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[2]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = match$1._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$7(v) {
    if (v) {
        return [
            "LinksUpdated",
            Decco.arrayToJson(function(param) {
                return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
            }, v._0)
        ];
    } else {
        return [
            "NoUpdate"
        ];
    }
}
function response_decode$7(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "LinksUpdated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* LinksUpdated */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NoUpdate":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoUpdate */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_RefreshLinks = {
    message_encode: message_encode$7,
    message_decode: message_decode$7,
    response_encode: response_encode$7,
    response_decode: response_decode$7
};
function message_encode$8(v) {
    return [
        "UpdateLinks",
        Decco.arrayToJson(function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
        }, v._0)
    ];
}
function message_decode$8(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "UpdateLinks") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.arrayFromJson(function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
        }, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* UpdateLinks */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$8(v) {
    return [
        "AckLinksUpdated"
    ];
}
function response_decode$8(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckLinksUpdated") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckLinksUpdated */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_UpdateLinks = {
    message_encode: message_encode$8,
    message_decode: message_decode$8,
    response_encode: response_encode$8,
    response_decode: response_decode$8
};
function message_encode$9(v) {
    return [
        "TellTabToUpdateLinkGroups",
        MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._0)
    ];
}
function message_decode$9(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TellTabToUpdateLinkGroups") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* TellTabToUpdateLinkGroups */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$9(v) {
    return [
        "AckUpdateLinkGroups"
    ];
}
function response_decode$9(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckUpdateLinkGroups") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckUpdateLinkGroups */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_TellTabToUpdateLinkGroups = {
    message_encode: message_encode$9,
    message_decode: message_decode$9,
    response_encode: response_encode$9,
    response_decode: response_decode$9
};
function message_encode$10(v) {
    return [
        "Exit"
    ];
}
function message_decode$10(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Exit") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* Exit */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$10(v) {
    return [
        "AckExit"
    ];
}
function response_decode$10(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckExit") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckExit */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_Exit = {
    message_encode: message_encode$10,
    message_decode: message_decode$10,
    response_encode: response_encode$10,
    response_decode: response_decode$10
};
function message_encode$11(v) {
    return [
        "AskContentScriptToRecordPageAction",
        MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_encode(v._0)
    ];
}
function message_decode$11(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskContentScriptToRecordPageAction") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskContentScriptToRecordPageAction */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$11(v) {
    return [
        "ContentScriptDidRecordPageAction"
    ];
}
function response_decode$11(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ContentScriptDidRecordPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* ContentScriptDidRecordPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_AskContentScriptToRecordPageAction = {
    message_encode: message_encode$11,
    message_decode: message_decode$11,
    response_encode: response_encode$11,
    response_decode: response_decode$11
};
function message_encode$12(v) {
    return [
        "StopRecordPageAction"
    ];
}
function message_decode$12(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "StopRecordPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* StopRecordPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$12(v) {
    return [
        "AckStopRecordPageAction"
    ];
}
function response_decode$12(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckStopRecordPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckStopRecordPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_StopRecordPageAction = {
    message_encode: message_encode$12,
    message_decode: message_decode$12,
    response_encode: response_encode$12,
    response_decode: response_decode$12
};
function message_encode$13(v) {
    return [
        "PlaybackPageActionUntil",
        MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode(v._0)
    ];
}
function message_decode$13(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "PlaybackPageActionUntil") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* PlaybackPageActionUntil */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$13(v) {
    return [
        "AckPlaybackPageAction"
    ];
}
function response_decode$13(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckPlaybackPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckPlaybackPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_PlaybackPageAction = {
    message_encode: message_encode$13,
    message_decode: message_decode$13,
    response_encode: response_encode$13,
    response_decode: response_decode$13
};
function message_encode$14(v) {
    return [
        "DidFinishPlaybackPageAction"
    ];
}
function message_decode$14(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DidFinishPlaybackPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* DidFinishPlaybackPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$14(v) {
    return [
        "AckDidFinishPlaybackPageAction"
    ];
}
function response_decode$14(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckDidFinishPlaybackPageAction") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckDidFinishPlaybackPageAction */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_DidFinishPlaybackPageAction = {
    message_encode: message_encode$14,
    message_decode: message_decode$14,
    response_encode: response_encode$14,
    response_decode: response_decode$14
};
function message_encode$15(v) {
    return [
        "ShowLinkWithId",
        Decco.stringToJson(v._0)
    ];
}
function message_decode$15(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ShowLinkWithId") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ShowLinkWithId */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$15(v) {
    return [
        "AckShowLinkWithId"
    ];
}
function response_decode$15(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckShowLinkWithId") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckShowLinkWithId */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_ShowLinkWithId = {
    message_encode: message_encode$15,
    message_decode: message_decode$15,
    response_encode: response_encode$15,
    response_decode: response_decode$15
};
function message_encode$16(v) {
    return [
        "SendContextLocalAndLinkGroups"
    ];
}
function message_decode$16(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SendContextLocalAndLinkGroups") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* SendContextLocalAndLinkGroups */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$16(v) {
    return [
        "GotContextLocalAndLinkGroups",
        CommandContext$SmartcutsMacros.commandContextLocal_encode(v._0),
        Decco.arrayToJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v._1)
    ];
}
function response_decode$16(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "GotContextLocalAndLinkGroups") {
        if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var match$1 = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Array.getExn(jsonArr$1, 1));
        var match$2 = Decco.arrayFromJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
        if (match$1.TAG === /* Ok */ 0) {
            if (match$2.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: /* GotContextLocalAndLinkGroups */ {
                        _0: match$1._0,
                        _1: match$2._0
                    }
                };
            }
            var e = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$1._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_SendContextLocalAndLinkGroups = {
    message_encode: message_encode$16,
    message_decode: message_decode$16,
    response_encode: response_encode$16,
    response_decode: response_decode$16
};
function message_encode$17(v) {
    return [
        "PrepareForScreenshot"
    ];
}
function message_decode$17(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "PrepareForScreenshot") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* PrepareForScreenshot */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$17(v) {
    return [
        "AckPrepareForScreenshot"
    ];
}
function response_decode$17(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckPrepareForScreenshot") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckPrepareForScreenshot */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_UrlTriggering_PrepareForScreenshot = {
    message_encode: message_encode$17,
    message_decode: message_decode$17,
    response_encode: response_encode$17,
    response_decode: response_decode$17
};
function message_encode$18(v) {
    return [
        "Ping"
    ];
}
function message_decode$18(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Ping") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* Ping */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$18(v) {
    return [
        "Ack"
    ];
}
function response_decode$18(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Ack") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* Ack */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_PingTab = {
    message_encode: message_encode$18,
    message_decode: message_decode$18,
    response_encode: response_encode$18,
    response_decode: response_decode$18
};
function message_encode$19(v) {
    return [
        "DoesElementExistOnPage",
        Selector$SmartcutsMacros.elementSelector_encode(v._0),
        Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1)
    ];
}
function message_decode$19(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DoesElementExistOnPage") {
        if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var match$1 = Selector$SmartcutsMacros.elementSelector_decode(Belt_Array.getExn(jsonArr$1, 1));
        var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
        if (match$1.TAG === /* Ok */ 0) {
            if (match$2.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: /* DoesElementExistOnPage */ {
                        _0: match$1._0,
                        _1: match$2._0
                    }
                };
            }
            var e = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$1._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$19(v) {
    if (v) {
        return [
            "DidNotFindElement"
        ];
    } else {
        return [
            "DidFindElement"
        ];
    }
}
function response_decode$19(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DidFindElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidFindElement */ 0
                    };
                }
            case "DidNotFindElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidNotFindElement */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_DoesElementExistOnPage = {
    message_encode: message_encode$19,
    message_decode: message_decode$19,
    response_encode: response_encode$19,
    response_decode: response_decode$19
};
function message_encode$20(v) {
    return [
        "AskTabToRenderModalToExplainHighlightElement"
    ];
}
function message_decode$20(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToRenderModalToExplainHighlightElement") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToRenderModalToExplainHighlightElement */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$20(v) {
    return [
        "AckRenderModalToExplainHighlightElement"
    ];
}
function response_decode$20(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AckRenderModalToExplainHighlightElement") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AckRenderModalToExplainHighlightElement */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToRenderModalToExplainHighlightElement = {
    message_encode: message_encode$20,
    message_decode: message_decode$20,
    response_encode: response_encode$20,
    response_decode: response_decode$20
};
function message_encode$21(v) {
    return [
        "AskTabToSetupHighlightElementControl",
        HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._0)
    ];
}
function message_decode$21(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToSetupHighlightElementControl") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToSetupHighlightElementControl */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$21(v) {
    return [
        "DidSetupHighlightElementControl"
    ];
}
function response_decode$21(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DidSetupHighlightElementControl") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* DidSetupHighlightElementControl */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToSetupHighlightElementControl = {
    message_encode: message_encode$21,
    message_decode: message_decode$21,
    response_encode: response_encode$21,
    response_decode: response_decode$21
};
function message_encode$22(v) {
    return [
        "AskTabToTeardownHighlightElementControl"
    ];
}
function message_decode$22(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToTeardownHighlightElementControl") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToTeardownHighlightElementControl */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$22(v) {
    return [
        "DidTeardownHighlightElementControl"
    ];
}
function response_decode$22(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DidTeardownHighlightElementControl") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* DidTeardownHighlightElementControl */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToTeardownHighlightElementControl = {
    message_encode: message_encode$22,
    message_decode: message_decode$22,
    response_encode: response_encode$22,
    response_decode: response_decode$22
};
function message_encode$23(v) {
    return [
        "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
    ];
}
function message_decode$23(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$23(v) {
    return [
        "DidHideSmartcutsPlaybackModalUntilCompletedCommand"
    ];
}
function response_decode$23(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DidHideSmartcutsPlaybackModalUntilCompletedCommand") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* DidHideSmartcutsPlaybackModalUntilCompletedCommand */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
    message_encode: message_encode$23,
    message_decode: message_decode$23,
    response_encode: response_encode$23,
    response_decode: response_decode$23
};
function message_encode$24(v) {
    return [
        "AskTabToEnterDataExtractionMode"
    ];
}
function message_decode$24(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToEnterDataExtractionMode") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToEnterDataExtractionMode */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function tabDidEnterDataExtractionMode_encode(v) {
    return Js_dict.fromArray([
        [
            "newWindowCommandWithContextLocal",
            Command$SmartcutsMacros.CommandWithContextLocal.t_encode(v.newWindowCommandWithContextLocal)
        ]
    ]);
}
function tabDidEnterDataExtractionMode_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var newWindowCommandWithContextLocal = Command$SmartcutsMacros.CommandWithContextLocal.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "newWindowCommandWithContextLocal"), null));
    if (newWindowCommandWithContextLocal.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                newWindowCommandWithContextLocal: newWindowCommandWithContextLocal._0
            }
        };
    }
    var e = newWindowCommandWithContextLocal._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".newWindowCommandWithContextLocal" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function response_encode$24(v) {
    return [
        "TabDidEnterDataExtractionMode",
        tabDidEnterDataExtractionMode_encode(v._0)
    ];
}
function response_decode$24(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TabDidEnterDataExtractionMode") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = tabDidEnterDataExtractionMode_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* TabDidEnterDataExtractionMode */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToEnterDataExtractionMode = {
    message_encode: message_encode$24,
    message_decode: message_decode$24,
    response_encode: response_encode$24,
    response_decode: response_decode$24,
    tabDidEnterDataExtractionMode_encode: tabDidEnterDataExtractionMode_encode,
    tabDidEnterDataExtractionMode_decode: tabDidEnterDataExtractionMode_decode
};
function message_encode$25(v) {
    return [
        "AskTabToExitDataExtractionMode"
    ];
}
function message_decode$25(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "AskTabToExitDataExtractionMode") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* AskTabToExitDataExtractionMode */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$25(v) {
    return [
        "TabDidExitDataExtractionMode"
    ];
}
function response_decode$25(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TabDidExitDataExtractionMode") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* TabDidExitDataExtractionMode */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_AskTabToExitDataExtractionMode = {
    message_encode: message_encode$25,
    message_decode: message_decode$25,
    response_encode: response_encode$25,
    response_decode: response_decode$25
};
function message_encode$26(v) {
    switch(v.TAG | 0){
        case /* Message_StartStreamingEventsToBackground */ 0:
            return [
                "Message_StartStreamingEventsToBackground",
                [
                    "StartStreamingEventsToBackground"
                ]
            ];
        case /* Message_StopStreamingEventsToBackground */ 1:
            return [
                "Message_StopStreamingEventsToBackground",
                [
                    "StopStreamingEventsToBackground"
                ]
            ];
        case /* Message_Playback */ 2:
            return [
                "Message_Playback",
                message_encode$2(v._0)
            ];
        case /* Message_PlaybackExited */ 3:
            return [
                "Message_PlaybackExited",
                [
                    "PlaybackExited"
                ]
            ];
        case /* Message_RenderInContentScript */ 4:
            return [
                "Message_RenderInContentScript",
                message_encode$4(v._0)
            ];
        case /* Message_AskContentScriptToAdjustModalGeometry */ 5:
            return [
                "Message_AskContentScriptToAdjustModalGeometry",
                message_encode$5(v._0)
            ];
        case /* Message_AskContentScriptToEnterUrlTriggeringMode */ 6:
            return [
                "Message_AskContentScriptToEnterUrlTriggeringMode",
                message_encode$6(v._0)
            ];
        case /* Message_UrlTriggering_RefreshLinks */ 7:
            return [
                "Message_UrlTriggering_RefreshLinks",
                message_encode$7(v._0)
            ];
        case /* Message_UrlTriggering_UpdateLinks */ 8:
            return [
                "Message_UrlTriggering_UpdateLinks",
                message_encode$8(v._0)
            ];
        case /* Message_UrlTriggering_TellTabToUpdateLinkGroups */ 9:
            return [
                "Message_UrlTriggering_TellTabToUpdateLinkGroups",
                message_encode$9(v._0)
            ];
        case /* Message_UrlTriggering_Exit */ 10:
            return [
                "Message_UrlTriggering_Exit",
                [
                    "Exit"
                ]
            ];
        case /* Message_UrlTriggering_AskContentScriptToRecordPageAction */ 11:
            return [
                "Message_UrlTriggering_AskContentScriptToRecordPageAction",
                message_encode$11(v._0)
            ];
        case /* Message_UrlTriggering_StopRecordPageAction */ 12:
            return [
                "Message_UrlTriggering_StopRecordPageAction",
                [
                    "StopRecordPageAction"
                ]
            ];
        case /* Message_UrlTriggering_PlaybackPageAction */ 13:
            return [
                "Message_UrlTriggering_PlaybackPageAction",
                message_encode$13(v._0)
            ];
        case /* Message_UrlTriggering_DidFinishPlaybackPageAction */ 14:
            return [
                "Message_UrlTriggering_DidFinishPlaybackPageAction",
                [
                    "DidFinishPlaybackPageAction"
                ]
            ];
        case /* Message_UrlTriggering_ShowLinkWithId */ 15:
            return [
                "Message_UrlTriggering_ShowLinkWithId",
                message_encode$15(v._0)
            ];
        case /* Message_UrlTriggering_SendContextLocalAndLinkGroups */ 16:
            return [
                "Message_UrlTriggering_SendContextLocalAndLinkGroups",
                [
                    "SendContextLocalAndLinkGroups"
                ]
            ];
        case /* Message_UrlTriggering_PrepareForScreenshot */ 17:
            return [
                "Message_UrlTriggering_PrepareForScreenshot",
                [
                    "PrepareForScreenshot"
                ]
            ];
        case /* Message_PingTab */ 18:
            return [
                "Message_PingTab",
                [
                    "Ping"
                ]
            ];
        case /* Message_DoesElementExistOnPage */ 19:
            return [
                "Message_DoesElementExistOnPage",
                message_encode$19(v._0)
            ];
        case /* Message_AskTabToRenderModalToExplainHighlightElement */ 20:
            return [
                "Message_AskTabToRenderModalToExplainHighlightElement",
                [
                    "AskTabToRenderModalToExplainHighlightElement"
                ]
            ];
        case /* Message_AskTabToSetupHighlightElementControl */ 21:
            return [
                "Message_AskTabToSetupHighlightElementControl",
                message_encode$21(v._0)
            ];
        case /* Message_AskTabToTeardownHighlightElementControl */ 22:
            return [
                "Message_AskTabToTeardownHighlightElementControl",
                [
                    "AskTabToTeardownHighlightElementControl"
                ]
            ];
        case /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23:
            return [
                "Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand",
                [
                    "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
                ]
            ];
        case /* Message_AskTabToEnterDataExtractionMode */ 24:
            return [
                "Message_AskTabToEnterDataExtractionMode",
                [
                    "AskTabToEnterDataExtractionMode"
                ]
            ];
        case /* Message_AskTabToExitDataExtractionMode */ 25:
            return [
                "Message_AskTabToExitDataExtractionMode",
                [
                    "AskTabToExitDataExtractionMode"
                ]
            ];
    }
}
function message_decode$26(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Message_AskContentScriptToAdjustModalGeometry":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = message_decode$5(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskContentScriptToAdjustModalGeometry */ 5,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Message_AskContentScriptToEnterUrlTriggeringMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = message_decode$6(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskContentScriptToEnterUrlTriggeringMode */ 6,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Message_AskTabToEnterDataExtractionMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = message_decode$24(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToEnterDataExtractionMode */ 24,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Message_AskTabToExitDataExtractionMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = message_decode$25(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToExitDataExtractionMode */ 25,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = message_decode$23(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Message_AskTabToRenderModalToExplainHighlightElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = message_decode$20(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToRenderModalToExplainHighlightElement */ 20,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Message_AskTabToSetupHighlightElementControl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = message_decode$21(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToSetupHighlightElementControl */ 21,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "Message_AskTabToTeardownHighlightElementControl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = message_decode$22(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_AskTabToTeardownHighlightElementControl */ 22,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Message_DoesElementExistOnPage":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = message_decode$19(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_DoesElementExistOnPage */ 19,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "Message_PingTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = message_decode$18(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_PingTab */ 18,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "Message_Playback":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = message_decode$2(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_Playback */ 2,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "Message_PlaybackExited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = message_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_PlaybackExited */ 3,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "Message_RenderInContentScript":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = message_decode$4(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_RenderInContentScript */ 4,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "Message_StartStreamingEventsToBackground":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = message_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_StartStreamingEventsToBackground */ 0,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "Message_StopStreamingEventsToBackground":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = message_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_StopStreamingEventsToBackground */ 1,
                            _0: v0$14._0
                        }
                    };
                }
                var e$14 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "Message_UrlTriggering_AskContentScriptToRecordPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$15 = message_decode$11(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$15.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_AskContentScriptToRecordPageAction */ 11,
                            _0: v0$15._0
                        }
                    };
                }
                var e$15 = v0$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "Message_UrlTriggering_DidFinishPlaybackPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$16 = message_decode$14(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$16.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */ 14,
                            _0: v0$16._0
                        }
                    };
                }
                var e$16 = v0$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "Message_UrlTriggering_Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$17 = message_decode$10(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$17.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_Exit */ 10,
                            _0: v0$17._0
                        }
                    };
                }
                var e$17 = v0$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "Message_UrlTriggering_PlaybackPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$18 = message_decode$13(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$18.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_PlaybackPageAction */ 13,
                            _0: v0$18._0
                        }
                    };
                }
                var e$18 = v0$18._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "Message_UrlTriggering_PrepareForScreenshot":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$19 = message_decode$17(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$19.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_PrepareForScreenshot */ 17,
                            _0: v0$19._0
                        }
                    };
                }
                var e$19 = v0$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "Message_UrlTriggering_RefreshLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$20 = message_decode$7(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$20.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_RefreshLinks */ 7,
                            _0: v0$20._0
                        }
                    };
                }
                var e$20 = v0$20._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "Message_UrlTriggering_SendContextLocalAndLinkGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$21 = message_decode$16(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$21.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_SendContextLocalAndLinkGroups */ 16,
                            _0: v0$21._0
                        }
                    };
                }
                var e$21 = v0$21._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "Message_UrlTriggering_ShowLinkWithId":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$22 = message_decode$15(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$22.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_ShowLinkWithId */ 15,
                            _0: v0$22._0
                        }
                    };
                }
                var e$22 = v0$22._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "Message_UrlTriggering_StopRecordPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$23 = message_decode$12(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$23.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_StopRecordPageAction */ 12,
                            _0: v0$23._0
                        }
                    };
                }
                var e$23 = v0$23._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "Message_UrlTriggering_TellTabToUpdateLinkGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$24 = message_decode$9(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$24.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_TellTabToUpdateLinkGroups */ 9,
                            _0: v0$24._0
                        }
                    };
                }
                var e$24 = v0$24._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "Message_UrlTriggering_UpdateLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$25 = message_decode$8(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$25.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_UrlTriggering_UpdateLinks */ 8,
                            _0: v0$25._0
                        }
                    };
                }
                var e$25 = v0$25._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode$26(v) {
    switch(v.TAG | 0){
        case /* Response_StartStreamingEventsToBackground */ 0:
            return [
                "Response_StartStreamingEventsToBackground",
                [
                    "TabDidSetupEventStreaming"
                ]
            ];
        case /* Response_StopStreamingEventsToBackground */ 1:
            return [
                "Response_StopStreamingEventsToBackground",
                [
                    "TabDidStopStreamingEventsToBackground"
                ]
            ];
        case /* Response_Playback */ 2:
            return [
                "Response_Playback",
                response_encode$2(v._0)
            ];
        case /* Response_PlaybackExited */ 3:
            return [
                "Response_PlaybackExited",
                [
                    "AckPlaybackExited"
                ]
            ];
        case /* Response_RenderInContentScript */ 4:
            return [
                "Response_RenderInContentScript",
                [
                    "AckRenderInContentScript"
                ]
            ];
        case /* Response_AskContentScriptToAdjustModalGeometry */ 5:
            return [
                "Response_AskContentScriptToAdjustModalGeometry",
                response_encode$5(v._0)
            ];
        case /* Response_AskContentScriptToEnterUrlTriggeringMode */ 6:
            return [
                "Response_AskContentScriptToEnterUrlTriggeringMode",
                response_encode$6(v._0)
            ];
        case /* Response_UrlTriggering_RefreshLinks */ 7:
            return [
                "Response_UrlTriggering_RefreshLinks",
                response_encode$7(v._0)
            ];
        case /* Response_UrlTriggering_UpdateLinks */ 8:
            return [
                "Response_UrlTriggering_UpdateLinks",
                [
                    "AckLinksUpdated"
                ]
            ];
        case /* Response_UrlTriggering_TellTabToUpdateLinkGroups */ 9:
            return [
                "Response_UrlTriggering_TellTabToUpdateLinkGroups",
                [
                    "AckUpdateLinkGroups"
                ]
            ];
        case /* Response_UrlTriggering_Exit */ 10:
            return [
                "Response_UrlTriggering_Exit",
                [
                    "AckExit"
                ]
            ];
        case /* Response_UrlTriggering_AskContentScriptToRecordPageAction */ 11:
            return [
                "Response_UrlTriggering_AskContentScriptToRecordPageAction",
                [
                    "ContentScriptDidRecordPageAction"
                ]
            ];
        case /* Response_UrlTriggering_StopRecordPageAction */ 12:
            return [
                "Response_UrlTriggering_StopRecordPageAction",
                [
                    "AckStopRecordPageAction"
                ]
            ];
        case /* Response_UrlTriggering_PlaybackPageAction */ 13:
            return [
                "Response_UrlTriggering_PlaybackPageAction",
                [
                    "AckPlaybackPageAction"
                ]
            ];
        case /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 14:
            return [
                "Response_UrlTriggering_DidFinishPlaybackPageAction",
                [
                    "AckDidFinishPlaybackPageAction"
                ]
            ];
        case /* Response_UrlTriggering_ShowLinkWithId */ 15:
            return [
                "Response_UrlTriggering_ShowLinkWithId",
                [
                    "AckShowLinkWithId"
                ]
            ];
        case /* Response_UrlTriggering_SendContextLocalAndLinkGroups */ 16:
            return [
                "Response_UrlTriggering_SendContextLocalAndLinkGroups",
                response_encode$16(v._0)
            ];
        case /* Response_UrlTriggering_PrepareForScreenshot */ 17:
            return [
                "Response_UrlTriggering_PrepareForScreenshot",
                [
                    "AckPrepareForScreenshot"
                ]
            ];
        case /* Response_PingTab */ 18:
            return [
                "Response_PingTab",
                [
                    "Ack"
                ]
            ];
        case /* Response_DoesElementExistOnPage */ 19:
            return [
                "Response_DoesElementExistOnPage",
                response_encode$19(v._0)
            ];
        case /* Response_AskTabToRenderModalToExplainHighlightElement */ 20:
            return [
                "Response_AskTabToRenderModalToExplainHighlightElement",
                [
                    "AckRenderModalToExplainHighlightElement"
                ]
            ];
        case /* Response_AskTabToSetupHighlightElementControl */ 21:
            return [
                "Response_AskTabToSetupHighlightElementControl",
                [
                    "DidSetupHighlightElementControl"
                ]
            ];
        case /* Response_AskTabToTeardownHighlightElementControl */ 22:
            return [
                "Response_AskTabToTeardownHighlightElementControl",
                [
                    "DidTeardownHighlightElementControl"
                ]
            ];
        case /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23:
            return [
                "Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand",
                [
                    "DidHideSmartcutsPlaybackModalUntilCompletedCommand"
                ]
            ];
        case /* Response_AskTabToEnterDataExtractionMode */ 24:
            return [
                "Response_AskTabToEnterDataExtractionMode",
                response_encode$24(v._0)
            ];
        case /* Response_AskTabToExitDataExtractionMode */ 25:
            return [
                "Response_AskTabToExitDataExtractionMode",
                [
                    "TabDidExitDataExtractionMode"
                ]
            ];
    }
}
function response_decode$26(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Response_AskContentScriptToAdjustModalGeometry":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = response_decode$5(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskContentScriptToAdjustModalGeometry */ 5,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Response_AskContentScriptToEnterUrlTriggeringMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = response_decode$6(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskContentScriptToEnterUrlTriggeringMode */ 6,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Response_AskTabToEnterDataExtractionMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = response_decode$24(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToEnterDataExtractionMode */ 24,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Response_AskTabToExitDataExtractionMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = response_decode$25(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToExitDataExtractionMode */ 25,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = response_decode$23(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Response_AskTabToRenderModalToExplainHighlightElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = response_decode$20(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToRenderModalToExplainHighlightElement */ 20,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Response_AskTabToSetupHighlightElementControl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = response_decode$21(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToSetupHighlightElementControl */ 21,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "Response_AskTabToTeardownHighlightElementControl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = response_decode$22(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_AskTabToTeardownHighlightElementControl */ 22,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Response_DoesElementExistOnPage":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = response_decode$19(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_DoesElementExistOnPage */ 19,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "Response_PingTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = response_decode$18(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_PingTab */ 18,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "Response_Playback":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = response_decode$2(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_Playback */ 2,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "Response_PlaybackExited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = response_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_PlaybackExited */ 3,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "Response_RenderInContentScript":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = response_decode$4(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_RenderInContentScript */ 4,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "Response_StartStreamingEventsToBackground":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = response_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_StartStreamingEventsToBackground */ 0,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "Response_StopStreamingEventsToBackground":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = response_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_StopStreamingEventsToBackground */ 1,
                            _0: v0$14._0
                        }
                    };
                }
                var e$14 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "Response_UrlTriggering_AskContentScriptToRecordPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$15 = response_decode$11(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$15.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_AskContentScriptToRecordPageAction */ 11,
                            _0: v0$15._0
                        }
                    };
                }
                var e$15 = v0$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "Response_UrlTriggering_DidFinishPlaybackPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$16 = response_decode$14(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$16.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 14,
                            _0: v0$16._0
                        }
                    };
                }
                var e$16 = v0$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "Response_UrlTriggering_Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$17 = response_decode$10(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$17.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_Exit */ 10,
                            _0: v0$17._0
                        }
                    };
                }
                var e$17 = v0$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "Response_UrlTriggering_PlaybackPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$18 = response_decode$13(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$18.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_PlaybackPageAction */ 13,
                            _0: v0$18._0
                        }
                    };
                }
                var e$18 = v0$18._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "Response_UrlTriggering_PrepareForScreenshot":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$19 = response_decode$17(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$19.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_PrepareForScreenshot */ 17,
                            _0: v0$19._0
                        }
                    };
                }
                var e$19 = v0$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "Response_UrlTriggering_RefreshLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$20 = response_decode$7(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$20.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_RefreshLinks */ 7,
                            _0: v0$20._0
                        }
                    };
                }
                var e$20 = v0$20._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "Response_UrlTriggering_SendContextLocalAndLinkGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$21 = response_decode$16(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$21.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_SendContextLocalAndLinkGroups */ 16,
                            _0: v0$21._0
                        }
                    };
                }
                var e$21 = v0$21._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "Response_UrlTriggering_ShowLinkWithId":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$22 = response_decode$15(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$22.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_ShowLinkWithId */ 15,
                            _0: v0$22._0
                        }
                    };
                }
                var e$22 = v0$22._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "Response_UrlTriggering_StopRecordPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$23 = response_decode$12(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$23.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_StopRecordPageAction */ 12,
                            _0: v0$23._0
                        }
                    };
                }
                var e$23 = v0$23._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "Response_UrlTriggering_TellTabToUpdateLinkGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$24 = response_decode$9(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$24.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_TellTabToUpdateLinkGroups */ 9,
                            _0: v0$24._0
                        }
                    };
                }
                var e$24 = v0$24._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "Response_UrlTriggering_UpdateLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$25 = response_decode$8(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$25.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_UrlTriggering_UpdateLinks */ 8,
                            _0: v0$25._0
                        }
                    };
                }
                var e$25 = v0$25._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var MR_All = {
    message_encode: message_encode$26,
    message_decode: message_decode$26,
    response_encode: response_encode$26,
    response_decode: response_decode$26
};
function message_encode$27(v) {
    return [
        "StartStreamingEventsToBackground"
    ];
}
var message_decode$27 = message_decode;
function response_encode$27(v) {
    return [
        "TabDidSetupEventStreaming"
    ];
}
var response_decode$27 = response_decode;
var allMessage_encode = message_encode$26;
var allMessage_decode = message_decode$26;
var allResponse_encode = response_encode$26;
var allResponse_decode = response_decode$26;
function responseError_encode(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage(message) {
    return {
        TAG: /* Message_StartStreamingEventsToBackground */ 0,
        _0: message
    };
}
function unwrapAllResponseAsResponse(allResponse) {
    if (allResponse.TAG === /* Response_StartStreamingEventsToBackground */ 0) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse(response) {
    return {
        TAG: /* Response_StartStreamingEventsToBackground */ 0,
        _0: response
    };
}
var MRTransform_StartStreamingEventsToBackground = {
    message_encode: message_encode$27,
    message_decode: message_decode$27,
    response_encode: response_encode$27,
    response_decode: response_decode$27,
    allMessage_encode: allMessage_encode,
    allMessage_decode: allMessage_decode,
    allResponse_encode: allResponse_encode,
    allResponse_decode: allResponse_decode,
    responseError_encode: responseError_encode,
    responseError_decode: responseError_decode,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse
};
var StartStreamingEventsToBackground = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_StartStreamingEventsToBackground);
function message_encode$28(v) {
    return [
        "StopStreamingEventsToBackground"
    ];
}
var message_decode$28 = message_decode$1;
function response_encode$28(v) {
    return [
        "TabDidStopStreamingEventsToBackground"
    ];
}
var response_decode$28 = response_decode$1;
var allMessage_encode$1 = message_encode$26;
var allMessage_decode$1 = message_decode$26;
var allResponse_encode$1 = response_encode$26;
var allResponse_decode$1 = response_decode$26;
function responseError_encode$1(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$1(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$1(message) {
    return {
        TAG: /* Message_StopStreamingEventsToBackground */ 1,
        _0: message
    };
}
function unwrapAllResponseAsResponse$1(allResponse) {
    if (allResponse.TAG === /* Response_StopStreamingEventsToBackground */ 1) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$1(response) {
    return {
        TAG: /* Response_StopStreamingEventsToBackground */ 1,
        _0: response
    };
}
var MRTransform_StopStreamingEventsToBackground = {
    message_encode: message_encode$28,
    message_decode: message_decode$28,
    response_encode: response_encode$28,
    response_decode: response_decode$28,
    allMessage_encode: allMessage_encode$1,
    allMessage_decode: allMessage_decode$1,
    allResponse_encode: allResponse_encode$1,
    allResponse_decode: allResponse_decode$1,
    responseError_encode: responseError_encode$1,
    responseError_decode: responseError_decode$1,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$1,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$1,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$1
};
var StopStreamingEventsToBackground = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_StopStreamingEventsToBackground);
var message_encode$29 = message_encode$2;
var message_decode$29 = message_decode$2;
var response_encode$29 = response_encode$2;
var response_decode$29 = response_decode$2;
var allMessage_encode$2 = message_encode$26;
var allMessage_decode$2 = message_decode$26;
var allResponse_encode$2 = response_encode$26;
var allResponse_decode$2 = response_decode$26;
function responseError_encode$2(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$2(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$2(message) {
    return {
        TAG: /* Message_Playback */ 2,
        _0: message
    };
}
function unwrapAllResponseAsResponse$2(allResponse) {
    if (allResponse.TAG === /* Response_Playback */ 2) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$2(response) {
    return {
        TAG: /* Response_Playback */ 2,
        _0: response
    };
}
var MRTransform_Playback = {
    message_encode: message_encode$29,
    message_decode: message_decode$29,
    response_encode: response_encode$29,
    response_decode: response_decode$29,
    allMessage_encode: allMessage_encode$2,
    allMessage_decode: allMessage_decode$2,
    allResponse_encode: allResponse_encode$2,
    allResponse_decode: allResponse_decode$2,
    responseError_encode: responseError_encode$2,
    responseError_decode: responseError_decode$2,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$2,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$2,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$2
};
var Playback = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_Playback);
function message_encode$30(v) {
    return [
        "PlaybackExited"
    ];
}
var message_decode$30 = message_decode$3;
function response_encode$30(v) {
    return [
        "AckPlaybackExited"
    ];
}
var response_decode$30 = response_decode$3;
var allMessage_encode$3 = message_encode$26;
var allMessage_decode$3 = message_decode$26;
var allResponse_encode$3 = response_encode$26;
var allResponse_decode$3 = response_decode$26;
function responseError_encode$3(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$3(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$3(message) {
    return {
        TAG: /* Message_PlaybackExited */ 3,
        _0: message
    };
}
function unwrapAllResponseAsResponse$3(allResponse) {
    if (allResponse.TAG === /* Response_PlaybackExited */ 3) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$3(response) {
    return {
        TAG: /* Response_PlaybackExited */ 3,
        _0: response
    };
}
var MRTransform_PlaybackExited = {
    message_encode: message_encode$30,
    message_decode: message_decode$30,
    response_encode: response_encode$30,
    response_decode: response_decode$30,
    allMessage_encode: allMessage_encode$3,
    allMessage_decode: allMessage_decode$3,
    allResponse_encode: allResponse_encode$3,
    allResponse_decode: allResponse_decode$3,
    responseError_encode: responseError_encode$3,
    responseError_decode: responseError_decode$3,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$3,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$3,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$3
};
var PlaybackExited = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_PlaybackExited);
var message_encode$31 = message_encode$4;
var message_decode$31 = message_decode$4;
function response_encode$31(v) {
    return [
        "AckRenderInContentScript"
    ];
}
var response_decode$31 = response_decode$4;
var allMessage_encode$4 = message_encode$26;
var allMessage_decode$4 = message_decode$26;
var allResponse_encode$4 = response_encode$26;
var allResponse_decode$4 = response_decode$26;
function responseError_encode$4(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$4(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$4(message) {
    return {
        TAG: /* Message_RenderInContentScript */ 4,
        _0: message
    };
}
function unwrapAllResponseAsResponse$4(allResponse) {
    if (allResponse.TAG === /* Response_RenderInContentScript */ 4) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$4(response) {
    return {
        TAG: /* Response_RenderInContentScript */ 4,
        _0: response
    };
}
var MRTransform_RenderInContentScript = {
    message_encode: message_encode$31,
    message_decode: message_decode$31,
    response_encode: response_encode$31,
    response_decode: response_decode$31,
    allMessage_encode: allMessage_encode$4,
    allMessage_decode: allMessage_decode$4,
    allResponse_encode: allResponse_encode$4,
    allResponse_decode: allResponse_decode$4,
    responseError_encode: responseError_encode$4,
    responseError_decode: responseError_decode$4,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$4,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$4,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$4
};
var RenderInContentScript = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_RenderInContentScript);
var message_encode$32 = message_encode$5;
var message_decode$32 = message_decode$5;
var response_encode$32 = response_encode$5;
var response_decode$32 = response_decode$5;
var allMessage_encode$5 = message_encode$26;
var allMessage_decode$5 = message_decode$26;
var allResponse_encode$5 = response_encode$26;
var allResponse_decode$5 = response_decode$26;
function responseError_encode$5(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$5(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$5(message) {
    return {
        TAG: /* Message_AskContentScriptToAdjustModalGeometry */ 5,
        _0: message
    };
}
function unwrapAllResponseAsResponse$5(allResponse) {
    if (allResponse.TAG === /* Response_AskContentScriptToAdjustModalGeometry */ 5) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$5(response) {
    return {
        TAG: /* Response_AskContentScriptToAdjustModalGeometry */ 5,
        _0: response
    };
}
var MRTransform_AskContentScriptToAdjustModalGeometry = {
    message_encode: message_encode$32,
    message_decode: message_decode$32,
    response_encode: response_encode$32,
    response_decode: response_decode$32,
    allMessage_encode: allMessage_encode$5,
    allMessage_decode: allMessage_decode$5,
    allResponse_encode: allResponse_encode$5,
    allResponse_decode: allResponse_decode$5,
    responseError_encode: responseError_encode$5,
    responseError_decode: responseError_decode$5,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$5,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$5,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$5
};
var AskContentScriptToAdjustModalGeometry = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskContentScriptToAdjustModalGeometry);
var message_encode$33 = message_encode$6;
var message_decode$33 = message_decode$6;
var response_encode$33 = response_encode$6;
var response_decode$33 = response_decode$6;
var allMessage_encode$6 = message_encode$26;
var allMessage_decode$6 = message_decode$26;
var allResponse_encode$6 = response_encode$26;
var allResponse_decode$6 = response_decode$26;
function responseError_encode$6(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$6(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$6(message) {
    return {
        TAG: /* Message_AskContentScriptToEnterUrlTriggeringMode */ 6,
        _0: message
    };
}
function unwrapAllResponseAsResponse$6(allResponse) {
    if (allResponse.TAG === /* Response_AskContentScriptToEnterUrlTriggeringMode */ 6) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$6(response) {
    return {
        TAG: /* Response_AskContentScriptToEnterUrlTriggeringMode */ 6,
        _0: response
    };
}
var MRTransform_AskContentScriptToEnterUrlTriggeringMode = {
    message_encode: message_encode$33,
    message_decode: message_decode$33,
    response_encode: response_encode$33,
    response_decode: response_decode$33,
    allMessage_encode: allMessage_encode$6,
    allMessage_decode: allMessage_decode$6,
    allResponse_encode: allResponse_encode$6,
    allResponse_decode: allResponse_decode$6,
    responseError_encode: responseError_encode$6,
    responseError_decode: responseError_decode$6,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$6,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$6,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$6
};
var AskContentScriptToEnterUrlTriggeringMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskContentScriptToEnterUrlTriggeringMode);
var message_encode$34 = message_encode$7;
var message_decode$34 = message_decode$7;
var response_encode$34 = response_encode$7;
var response_decode$34 = response_decode$7;
var allMessage_encode$7 = message_encode$26;
var allMessage_decode$7 = message_decode$26;
var allResponse_encode$7 = response_encode$26;
var allResponse_decode$7 = response_decode$26;
function responseError_encode$7(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$7(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$7(message) {
    return {
        TAG: /* Message_UrlTriggering_RefreshLinks */ 7,
        _0: message
    };
}
function unwrapAllResponseAsResponse$7(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_RefreshLinks */ 7) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$7(response) {
    return {
        TAG: /* Response_UrlTriggering_RefreshLinks */ 7,
        _0: response
    };
}
var MRTransform_UrlTriggering_RefreshLinks = {
    message_encode: message_encode$34,
    message_decode: message_decode$34,
    response_encode: response_encode$34,
    response_decode: response_decode$34,
    allMessage_encode: allMessage_encode$7,
    allMessage_decode: allMessage_decode$7,
    allResponse_encode: allResponse_encode$7,
    allResponse_decode: allResponse_decode$7,
    responseError_encode: responseError_encode$7,
    responseError_decode: responseError_decode$7,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$7,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$7,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$7
};
var UrlTriggering_RefreshLinks = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_RefreshLinks);
var message_encode$35 = message_encode$8;
var message_decode$35 = message_decode$8;
function response_encode$35(v) {
    return [
        "AckLinksUpdated"
    ];
}
var response_decode$35 = response_decode$8;
var allMessage_encode$8 = message_encode$26;
var allMessage_decode$8 = message_decode$26;
var allResponse_encode$8 = response_encode$26;
var allResponse_decode$8 = response_decode$26;
function responseError_encode$8(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$8(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$8(message) {
    return {
        TAG: /* Message_UrlTriggering_UpdateLinks */ 8,
        _0: message
    };
}
function unwrapAllResponseAsResponse$8(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_UpdateLinks */ 8) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$8(response) {
    return {
        TAG: /* Response_UrlTriggering_UpdateLinks */ 8,
        _0: response
    };
}
var MRTransform_UrlTriggering_UpdateLinks = {
    message_encode: message_encode$35,
    message_decode: message_decode$35,
    response_encode: response_encode$35,
    response_decode: response_decode$35,
    allMessage_encode: allMessage_encode$8,
    allMessage_decode: allMessage_decode$8,
    allResponse_encode: allResponse_encode$8,
    allResponse_decode: allResponse_decode$8,
    responseError_encode: responseError_encode$8,
    responseError_decode: responseError_decode$8,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$8,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$8,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$8
};
var UrlTriggering_UpdateLinks = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_UpdateLinks);
var message_encode$36 = message_encode$9;
var message_decode$36 = message_decode$9;
function response_encode$36(v) {
    return [
        "AckUpdateLinkGroups"
    ];
}
var response_decode$36 = response_decode$9;
var allMessage_encode$9 = message_encode$26;
var allMessage_decode$9 = message_decode$26;
var allResponse_encode$9 = response_encode$26;
var allResponse_decode$9 = response_decode$26;
function responseError_encode$9(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$9(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$9(message) {
    return {
        TAG: /* Message_UrlTriggering_TellTabToUpdateLinkGroups */ 9,
        _0: message
    };
}
function unwrapAllResponseAsResponse$9(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_TellTabToUpdateLinkGroups */ 9) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$9(response) {
    return {
        TAG: /* Response_UrlTriggering_TellTabToUpdateLinkGroups */ 9,
        _0: response
    };
}
var MRTransform_UrlTriggering_TellTabToUpdateLinkGroups = {
    message_encode: message_encode$36,
    message_decode: message_decode$36,
    response_encode: response_encode$36,
    response_decode: response_decode$36,
    allMessage_encode: allMessage_encode$9,
    allMessage_decode: allMessage_decode$9,
    allResponse_encode: allResponse_encode$9,
    allResponse_decode: allResponse_decode$9,
    responseError_encode: responseError_encode$9,
    responseError_decode: responseError_decode$9,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$9,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$9,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$9
};
var UrlTriggering_TellTabToUpdateLinkGroups = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_TellTabToUpdateLinkGroups);
function message_encode$37(v) {
    return [
        "Exit"
    ];
}
var message_decode$37 = message_decode$10;
function response_encode$37(v) {
    return [
        "AckExit"
    ];
}
var response_decode$37 = response_decode$10;
var allMessage_encode$10 = message_encode$26;
var allMessage_decode$10 = message_decode$26;
var allResponse_encode$10 = response_encode$26;
var allResponse_decode$10 = response_decode$26;
function responseError_encode$10(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$10(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$10(message) {
    return {
        TAG: /* Message_UrlTriggering_Exit */ 10,
        _0: message
    };
}
function unwrapAllResponseAsResponse$10(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_Exit */ 10) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$10(response) {
    return {
        TAG: /* Response_UrlTriggering_Exit */ 10,
        _0: response
    };
}
var MRTransform_UrlTriggering_Exit = {
    message_encode: message_encode$37,
    message_decode: message_decode$37,
    response_encode: response_encode$37,
    response_decode: response_decode$37,
    allMessage_encode: allMessage_encode$10,
    allMessage_decode: allMessage_decode$10,
    allResponse_encode: allResponse_encode$10,
    allResponse_decode: allResponse_decode$10,
    responseError_encode: responseError_encode$10,
    responseError_decode: responseError_decode$10,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$10,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$10,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$10
};
var UrlTriggering_Exit = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_Exit);
var message_encode$38 = message_encode$11;
var message_decode$38 = message_decode$11;
function response_encode$38(v) {
    return [
        "ContentScriptDidRecordPageAction"
    ];
}
var response_decode$38 = response_decode$11;
var allMessage_encode$11 = message_encode$26;
var allMessage_decode$11 = message_decode$26;
var allResponse_encode$11 = response_encode$26;
var allResponse_decode$11 = response_decode$26;
function responseError_encode$11(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$11(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$11(message) {
    return {
        TAG: /* Message_UrlTriggering_AskContentScriptToRecordPageAction */ 11,
        _0: message
    };
}
function unwrapAllResponseAsResponse$11(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_AskContentScriptToRecordPageAction */ 11) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$11(response) {
    return {
        TAG: /* Response_UrlTriggering_AskContentScriptToRecordPageAction */ 11,
        _0: response
    };
}
var MRTransform_UrlTriggering_AskContentScriptToRecordPageAction = {
    message_encode: message_encode$38,
    message_decode: message_decode$38,
    response_encode: response_encode$38,
    response_decode: response_decode$38,
    allMessage_encode: allMessage_encode$11,
    allMessage_decode: allMessage_decode$11,
    allResponse_encode: allResponse_encode$11,
    allResponse_decode: allResponse_decode$11,
    responseError_encode: responseError_encode$11,
    responseError_decode: responseError_decode$11,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$11,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$11,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$11
};
var UrlTriggering_AskContentScriptToRecordPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_AskContentScriptToRecordPageAction);
function message_encode$39(v) {
    return [
        "StopRecordPageAction"
    ];
}
var message_decode$39 = message_decode$12;
function response_encode$39(v) {
    return [
        "AckStopRecordPageAction"
    ];
}
var response_decode$39 = response_decode$12;
var allMessage_encode$12 = message_encode$26;
var allMessage_decode$12 = message_decode$26;
var allResponse_encode$12 = response_encode$26;
var allResponse_decode$12 = response_decode$26;
function responseError_encode$12(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$12(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$12(message) {
    return {
        TAG: /* Message_UrlTriggering_StopRecordPageAction */ 12,
        _0: message
    };
}
function unwrapAllResponseAsResponse$12(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_StopRecordPageAction */ 12) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$12(response) {
    return {
        TAG: /* Response_UrlTriggering_StopRecordPageAction */ 12,
        _0: response
    };
}
var MRTransform_UrlTriggering_StopRecordPageAction = {
    message_encode: message_encode$39,
    message_decode: message_decode$39,
    response_encode: response_encode$39,
    response_decode: response_decode$39,
    allMessage_encode: allMessage_encode$12,
    allMessage_decode: allMessage_decode$12,
    allResponse_encode: allResponse_encode$12,
    allResponse_decode: allResponse_decode$12,
    responseError_encode: responseError_encode$12,
    responseError_decode: responseError_decode$12,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$12,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$12,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$12
};
var UrlTriggering_StopRecordPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_StopRecordPageAction);
var message_encode$40 = message_encode$13;
var message_decode$40 = message_decode$13;
function response_encode$40(v) {
    return [
        "AckPlaybackPageAction"
    ];
}
var response_decode$40 = response_decode$13;
var allMessage_encode$13 = message_encode$26;
var allMessage_decode$13 = message_decode$26;
var allResponse_encode$13 = response_encode$26;
var allResponse_decode$13 = response_decode$26;
function responseError_encode$13(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$13(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$13(message) {
    return {
        TAG: /* Message_UrlTriggering_PlaybackPageAction */ 13,
        _0: message
    };
}
function unwrapAllResponseAsResponse$13(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_PlaybackPageAction */ 13) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$13(response) {
    return {
        TAG: /* Response_UrlTriggering_PlaybackPageAction */ 13,
        _0: response
    };
}
var MRTransform_UrlTriggering_PlaybackPageAction = {
    message_encode: message_encode$40,
    message_decode: message_decode$40,
    response_encode: response_encode$40,
    response_decode: response_decode$40,
    allMessage_encode: allMessage_encode$13,
    allMessage_decode: allMessage_decode$13,
    allResponse_encode: allResponse_encode$13,
    allResponse_decode: allResponse_decode$13,
    responseError_encode: responseError_encode$13,
    responseError_decode: responseError_decode$13,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$13,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$13,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$13
};
var UrlTriggering_PlaybackPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_PlaybackPageAction);
function message_encode$41(v) {
    return [
        "DidFinishPlaybackPageAction"
    ];
}
var message_decode$41 = message_decode$14;
function response_encode$41(v) {
    return [
        "AckDidFinishPlaybackPageAction"
    ];
}
var response_decode$41 = response_decode$14;
var allMessage_encode$14 = message_encode$26;
var allMessage_decode$14 = message_decode$26;
var allResponse_encode$14 = response_encode$26;
var allResponse_decode$14 = response_decode$26;
function responseError_encode$14(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$14(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$14(message) {
    return {
        TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */ 14,
        _0: message
    };
}
function unwrapAllResponseAsResponse$14(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 14) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$14(response) {
    return {
        TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 14,
        _0: response
    };
}
var MRTransform_UrlTriggering_DidFinishPlaybackPageAction = {
    message_encode: message_encode$41,
    message_decode: message_decode$41,
    response_encode: response_encode$41,
    response_decode: response_decode$41,
    allMessage_encode: allMessage_encode$14,
    allMessage_decode: allMessage_decode$14,
    allResponse_encode: allResponse_encode$14,
    allResponse_decode: allResponse_decode$14,
    responseError_encode: responseError_encode$14,
    responseError_decode: responseError_decode$14,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$14,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$14,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$14
};
var UrlTriggering_DidFinishPlaybackPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_DidFinishPlaybackPageAction);
var message_encode$42 = message_encode$15;
var message_decode$42 = message_decode$15;
function response_encode$42(v) {
    return [
        "AckShowLinkWithId"
    ];
}
var response_decode$42 = response_decode$15;
var allMessage_encode$15 = message_encode$26;
var allMessage_decode$15 = message_decode$26;
var allResponse_encode$15 = response_encode$26;
var allResponse_decode$15 = response_decode$26;
function responseError_encode$15(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$15(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$15(message) {
    return {
        TAG: /* Message_UrlTriggering_ShowLinkWithId */ 15,
        _0: message
    };
}
function unwrapAllResponseAsResponse$15(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_ShowLinkWithId */ 15) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$15(response) {
    return {
        TAG: /* Response_UrlTriggering_ShowLinkWithId */ 15,
        _0: response
    };
}
var MRTransform_UrlTriggering_ShowLinkWithId = {
    message_encode: message_encode$42,
    message_decode: message_decode$42,
    response_encode: response_encode$42,
    response_decode: response_decode$42,
    allMessage_encode: allMessage_encode$15,
    allMessage_decode: allMessage_decode$15,
    allResponse_encode: allResponse_encode$15,
    allResponse_decode: allResponse_decode$15,
    responseError_encode: responseError_encode$15,
    responseError_decode: responseError_decode$15,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$15,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$15,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$15
};
var UrlTriggering_ShowLinkWithId = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_ShowLinkWithId);
function message_encode$43(v) {
    return [
        "SendContextLocalAndLinkGroups"
    ];
}
var message_decode$43 = message_decode$16;
var response_encode$43 = response_encode$16;
var response_decode$43 = response_decode$16;
var allMessage_encode$16 = message_encode$26;
var allMessage_decode$16 = message_decode$26;
var allResponse_encode$16 = response_encode$26;
var allResponse_decode$16 = response_decode$26;
function responseError_encode$16(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$16(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$16(message) {
    return {
        TAG: /* Message_UrlTriggering_SendContextLocalAndLinkGroups */ 16,
        _0: message
    };
}
function unwrapAllResponseAsResponse$16(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_SendContextLocalAndLinkGroups */ 16) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$16(response) {
    return {
        TAG: /* Response_UrlTriggering_SendContextLocalAndLinkGroups */ 16,
        _0: response
    };
}
var MRTransform_UrlTriggering_SendContextLocalAndLinkGroups = {
    message_encode: message_encode$43,
    message_decode: message_decode$43,
    response_encode: response_encode$43,
    response_decode: response_decode$43,
    allMessage_encode: allMessage_encode$16,
    allMessage_decode: allMessage_decode$16,
    allResponse_encode: allResponse_encode$16,
    allResponse_decode: allResponse_decode$16,
    responseError_encode: responseError_encode$16,
    responseError_decode: responseError_decode$16,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$16,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$16,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$16
};
var UrlTriggering_SendContextLocalAndLinkGroups = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_SendContextLocalAndLinkGroups);
function message_encode$44(v) {
    return [
        "PrepareForScreenshot"
    ];
}
var message_decode$44 = message_decode$17;
function response_encode$44(v) {
    return [
        "AckPrepareForScreenshot"
    ];
}
var response_decode$44 = response_decode$17;
var allMessage_encode$17 = message_encode$26;
var allMessage_decode$17 = message_decode$26;
var allResponse_encode$17 = response_encode$26;
var allResponse_decode$17 = response_decode$26;
function responseError_encode$17(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$17(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$17(message) {
    return {
        TAG: /* Message_UrlTriggering_PrepareForScreenshot */ 17,
        _0: message
    };
}
function unwrapAllResponseAsResponse$17(allResponse) {
    if (allResponse.TAG === /* Response_UrlTriggering_PrepareForScreenshot */ 17) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$17(response) {
    return {
        TAG: /* Response_UrlTriggering_PrepareForScreenshot */ 17,
        _0: response
    };
}
var MRTransform_UrlTriggering_PrepareForScreenshot = {
    message_encode: message_encode$44,
    message_decode: message_decode$44,
    response_encode: response_encode$44,
    response_decode: response_decode$44,
    allMessage_encode: allMessage_encode$17,
    allMessage_decode: allMessage_decode$17,
    allResponse_encode: allResponse_encode$17,
    allResponse_decode: allResponse_decode$17,
    responseError_encode: responseError_encode$17,
    responseError_decode: responseError_decode$17,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$17,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$17,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$17
};
var UrlTriggering_PrepareForScreenshot = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_PrepareForScreenshot);
function message_encode$45(v) {
    return [
        "Ping"
    ];
}
var message_decode$45 = message_decode$18;
function response_encode$45(v) {
    return [
        "Ack"
    ];
}
var response_decode$45 = response_decode$18;
var allMessage_encode$18 = message_encode$26;
var allMessage_decode$18 = message_decode$26;
var allResponse_encode$18 = response_encode$26;
var allResponse_decode$18 = response_decode$26;
function responseError_encode$18(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$18(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$18(message) {
    return {
        TAG: /* Message_PingTab */ 18,
        _0: message
    };
}
function unwrapAllResponseAsResponse$18(allResponse) {
    if (allResponse.TAG === /* Response_PingTab */ 18) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$18(response) {
    return {
        TAG: /* Response_PingTab */ 18,
        _0: response
    };
}
var MRTransform_PingTab = {
    message_encode: message_encode$45,
    message_decode: message_decode$45,
    response_encode: response_encode$45,
    response_decode: response_decode$45,
    allMessage_encode: allMessage_encode$18,
    allMessage_decode: allMessage_decode$18,
    allResponse_encode: allResponse_encode$18,
    allResponse_decode: allResponse_decode$18,
    responseError_encode: responseError_encode$18,
    responseError_decode: responseError_decode$18,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$18,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$18,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$18
};
var PingTab = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_PingTab);
var message_encode$46 = message_encode$19;
var message_decode$46 = message_decode$19;
var response_encode$46 = response_encode$19;
var response_decode$46 = response_decode$19;
var allMessage_encode$19 = message_encode$26;
var allMessage_decode$19 = message_decode$26;
var allResponse_encode$19 = response_encode$26;
var allResponse_decode$19 = response_decode$26;
function responseError_encode$19(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$19(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$19(message) {
    return {
        TAG: /* Message_DoesElementExistOnPage */ 19,
        _0: message
    };
}
function unwrapAllResponseAsResponse$19(allResponse) {
    if (allResponse.TAG === /* Response_DoesElementExistOnPage */ 19) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$19(response) {
    return {
        TAG: /* Response_DoesElementExistOnPage */ 19,
        _0: response
    };
}
var MRTransform_DoesElementExistOnPage = {
    message_encode: message_encode$46,
    message_decode: message_decode$46,
    response_encode: response_encode$46,
    response_decode: response_decode$46,
    allMessage_encode: allMessage_encode$19,
    allMessage_decode: allMessage_decode$19,
    allResponse_encode: allResponse_encode$19,
    allResponse_decode: allResponse_decode$19,
    responseError_encode: responseError_encode$19,
    responseError_decode: responseError_decode$19,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$19,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$19,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$19
};
var DoesElementExistOnPage = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_DoesElementExistOnPage);
function message_encode$47(v) {
    return [
        "AskTabToRenderModalToExplainHighlightElement"
    ];
}
var message_decode$47 = message_decode$20;
function response_encode$47(v) {
    return [
        "AckRenderModalToExplainHighlightElement"
    ];
}
var response_decode$47 = response_decode$20;
var allMessage_encode$20 = message_encode$26;
var allMessage_decode$20 = message_decode$26;
var allResponse_encode$20 = response_encode$26;
var allResponse_decode$20 = response_decode$26;
function responseError_encode$20(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$20(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$20(message) {
    return {
        TAG: /* Message_AskTabToRenderModalToExplainHighlightElement */ 20,
        _0: message
    };
}
function unwrapAllResponseAsResponse$20(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToRenderModalToExplainHighlightElement */ 20) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$20(response) {
    return {
        TAG: /* Response_AskTabToRenderModalToExplainHighlightElement */ 20,
        _0: response
    };
}
var MRTransform_AskTabToRenderModalToExplainHighlightElement = {
    message_encode: message_encode$47,
    message_decode: message_decode$47,
    response_encode: response_encode$47,
    response_decode: response_decode$47,
    allMessage_encode: allMessage_encode$20,
    allMessage_decode: allMessage_decode$20,
    allResponse_encode: allResponse_encode$20,
    allResponse_decode: allResponse_decode$20,
    responseError_encode: responseError_encode$20,
    responseError_decode: responseError_decode$20,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$20,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$20,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$20
};
var AskTabToRenderModalToExplainHighlightElement = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToRenderModalToExplainHighlightElement);
var message_encode$48 = message_encode$21;
var message_decode$48 = message_decode$21;
function response_encode$48(v) {
    return [
        "DidSetupHighlightElementControl"
    ];
}
var response_decode$48 = response_decode$21;
var allMessage_encode$21 = message_encode$26;
var allMessage_decode$21 = message_decode$26;
var allResponse_encode$21 = response_encode$26;
var allResponse_decode$21 = response_decode$26;
function responseError_encode$21(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$21(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$21(message) {
    return {
        TAG: /* Message_AskTabToSetupHighlightElementControl */ 21,
        _0: message
    };
}
function unwrapAllResponseAsResponse$21(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToSetupHighlightElementControl */ 21) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$21(response) {
    return {
        TAG: /* Response_AskTabToSetupHighlightElementControl */ 21,
        _0: response
    };
}
var MRTransform_AskTabToSetupHighlightElementControl = {
    message_encode: message_encode$48,
    message_decode: message_decode$48,
    response_encode: response_encode$48,
    response_decode: response_decode$48,
    allMessage_encode: allMessage_encode$21,
    allMessage_decode: allMessage_decode$21,
    allResponse_encode: allResponse_encode$21,
    allResponse_decode: allResponse_decode$21,
    responseError_encode: responseError_encode$21,
    responseError_decode: responseError_decode$21,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$21,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$21,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$21
};
var AskTabToSetupHighlightElementControl = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToSetupHighlightElementControl);
function message_encode$49(v) {
    return [
        "AskTabToTeardownHighlightElementControl"
    ];
}
var message_decode$49 = message_decode$22;
function response_encode$49(v) {
    return [
        "DidTeardownHighlightElementControl"
    ];
}
var response_decode$49 = response_decode$22;
var allMessage_encode$22 = message_encode$26;
var allMessage_decode$22 = message_decode$26;
var allResponse_encode$22 = response_encode$26;
var allResponse_decode$22 = response_decode$26;
function responseError_encode$22(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$22(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$22(message) {
    return {
        TAG: /* Message_AskTabToTeardownHighlightElementControl */ 22,
        _0: message
    };
}
function unwrapAllResponseAsResponse$22(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToTeardownHighlightElementControl */ 22) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$22(response) {
    return {
        TAG: /* Response_AskTabToTeardownHighlightElementControl */ 22,
        _0: response
    };
}
var MRTransform_AskTabToTeardownHighlightElementControl = {
    message_encode: message_encode$49,
    message_decode: message_decode$49,
    response_encode: response_encode$49,
    response_decode: response_decode$49,
    allMessage_encode: allMessage_encode$22,
    allMessage_decode: allMessage_decode$22,
    allResponse_encode: allResponse_encode$22,
    allResponse_decode: allResponse_decode$22,
    responseError_encode: responseError_encode$22,
    responseError_decode: responseError_decode$22,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$22,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$22,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$22
};
var AskTabToTeardownHighlightElementControl = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToTeardownHighlightElementControl);
function message_encode$50(v) {
    return [
        "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
    ];
}
var message_decode$50 = message_decode$23;
function response_encode$50(v) {
    return [
        "DidHideSmartcutsPlaybackModalUntilCompletedCommand"
    ];
}
var response_decode$50 = response_decode$23;
var allMessage_encode$23 = message_encode$26;
var allMessage_decode$23 = message_decode$26;
var allResponse_encode$23 = response_encode$26;
var allResponse_decode$23 = response_decode$26;
function responseError_encode$23(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$23(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$23(message) {
    return {
        TAG: /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23,
        _0: message
    };
}
function unwrapAllResponseAsResponse$23(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$23(response) {
    return {
        TAG: /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23,
        _0: response
    };
}
var MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
    message_encode: message_encode$50,
    message_decode: message_decode$50,
    response_encode: response_encode$50,
    response_decode: response_decode$50,
    allMessage_encode: allMessage_encode$23,
    allMessage_decode: allMessage_decode$23,
    allResponse_encode: allResponse_encode$23,
    allResponse_decode: allResponse_decode$23,
    responseError_encode: responseError_encode$23,
    responseError_decode: responseError_decode$23,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$23,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$23,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$23
};
var AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand);
function message_encode$51(v) {
    return [
        "AskTabToEnterDataExtractionMode"
    ];
}
var message_decode$51 = message_decode$24;
var response_encode$51 = response_encode$24;
var response_decode$51 = response_decode$24;
var allMessage_encode$24 = message_encode$26;
var allMessage_decode$24 = message_decode$26;
var allResponse_encode$24 = response_encode$26;
var allResponse_decode$24 = response_decode$26;
function responseError_encode$24(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$24(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$24(message) {
    return {
        TAG: /* Message_AskTabToEnterDataExtractionMode */ 24,
        _0: message
    };
}
function unwrapAllResponseAsResponse$24(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToEnterDataExtractionMode */ 24) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$24(response) {
    return {
        TAG: /* Response_AskTabToEnterDataExtractionMode */ 24,
        _0: response
    };
}
var MRTransform_AskTabToEnterDataExtractionMode = {
    message_encode: message_encode$51,
    message_decode: message_decode$51,
    response_encode: response_encode$51,
    response_decode: response_decode$51,
    allMessage_encode: allMessage_encode$24,
    allMessage_decode: allMessage_decode$24,
    allResponse_encode: allResponse_encode$24,
    allResponse_decode: allResponse_decode$24,
    responseError_encode: responseError_encode$24,
    responseError_decode: responseError_decode$24,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$24,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$24,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$24
};
var AskTabToEnterDataExtractionMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToEnterDataExtractionMode);
function message_encode$52(v) {
    return [
        "AskTabToExitDataExtractionMode"
    ];
}
var message_decode$52 = message_decode$25;
function response_encode$52(v) {
    return [
        "TabDidExitDataExtractionMode"
    ];
}
var response_decode$52 = response_decode$25;
var allMessage_encode$25 = message_encode$26;
var allMessage_decode$25 = message_decode$26;
var allResponse_encode$25 = response_encode$26;
var allResponse_decode$25 = response_decode$26;
function responseError_encode$25(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$25(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function wrapMessageAsAllMessage$25(message) {
    return {
        TAG: /* Message_AskTabToExitDataExtractionMode */ 25,
        _0: message
    };
}
function unwrapAllResponseAsResponse$25(allResponse) {
    if (allResponse.TAG === /* Response_AskTabToExitDataExtractionMode */ 25) {
        return allResponse._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
}
function wrapResponseAsAllResponse$25(response) {
    return {
        TAG: /* Response_AskTabToExitDataExtractionMode */ 25,
        _0: response
    };
}
var MRTransform_AskTabToExitDataExtractionMode = {
    message_encode: message_encode$52,
    message_decode: message_decode$52,
    response_encode: response_encode$52,
    response_decode: response_decode$52,
    allMessage_encode: allMessage_encode$25,
    allMessage_decode: allMessage_decode$25,
    allResponse_encode: allResponse_encode$25,
    allResponse_decode: allResponse_decode$25,
    responseError_encode: responseError_encode$25,
    responseError_decode: responseError_decode$25,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$25,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$25,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$25
};
var AskTabToExitDataExtractionMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToExitDataExtractionMode);
var message_encode$53 = message_encode$26;
var message_decode$53 = message_decode$26;
var response_encode$53 = response_encode$26;
var response_decode$53 = response_decode$26;
function responseError_encode$26(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}
function responseError_decode$26(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}
function result_encode(v) {
    return Decco.resultToJson(response_encode$53, responseError_encode$26, v);
}
function result_decode(v) {
    return Decco.resultFromJson(response_decode$53, responseError_decode$26, v);
}
function respondToSender_encode(_fn) {
    return "respondToSender";
}
function respondToSender_decode(encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
        if (str === "respondToSender") {
            return {
                TAG: /* Ok */ 0,
                _0: function(_result) {}
            };
        } else {
            return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
        }
    } else {
        return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
}
function onMessageFromExtension(listener) {
    return Browser__Runtime$SmartcutsMacros.OnMessageFromExtension.addListener(function(json) {
        return Curry._1(listener, Belt_Result.getExn(message_decode$26(json))).then(function(result) {
            return Promise.resolve(Decco.resultToJson(response_encode$53, responseError_encode$26, result));
        });
    });
}
var All = {
    message_encode: message_encode$53,
    message_decode: message_decode$53,
    response_encode: response_encode$53,
    response_decode: response_decode$53,
    responseError_encode: responseError_encode$26,
    responseError_decode: responseError_decode$26,
    result_encode: result_encode,
    result_decode: result_decode,
    respondToSender_encode: respondToSender_encode,
    respondToSender_decode: respondToSender_decode,
    onMessageFromExtension: onMessageFromExtension
};
exports.MR_StartStreamingEventsToBackground = MR_StartStreamingEventsToBackground;
exports.MR_StopStreamingEventsToBackground = MR_StopStreamingEventsToBackground;
exports.MR_Playback = MR_Playback;
exports.MR_PlaybackExited = MR_PlaybackExited;
exports.MR_RenderInContentScript = MR_RenderInContentScript;
exports.MR_AskContentScriptToAdjustModalGeometry = MR_AskContentScriptToAdjustModalGeometry;
exports.MR_AskContentScriptToEnterUrlTriggeringMode = MR_AskContentScriptToEnterUrlTriggeringMode;
exports.MR_UrlTriggering_RefreshLinks = MR_UrlTriggering_RefreshLinks;
exports.MR_UrlTriggering_UpdateLinks = MR_UrlTriggering_UpdateLinks;
exports.MR_UrlTriggering_TellTabToUpdateLinkGroups = MR_UrlTriggering_TellTabToUpdateLinkGroups;
exports.MR_UrlTriggering_Exit = MR_UrlTriggering_Exit;
exports.MR_UrlTriggering_AskContentScriptToRecordPageAction = MR_UrlTriggering_AskContentScriptToRecordPageAction;
exports.MR_UrlTriggering_StopRecordPageAction = MR_UrlTriggering_StopRecordPageAction;
exports.MR_UrlTriggering_PlaybackPageAction = MR_UrlTriggering_PlaybackPageAction;
exports.MR_UrlTriggering_DidFinishPlaybackPageAction = MR_UrlTriggering_DidFinishPlaybackPageAction;
exports.MR_UrlTriggering_ShowLinkWithId = MR_UrlTriggering_ShowLinkWithId;
exports.MR_UrlTriggering_SendContextLocalAndLinkGroups = MR_UrlTriggering_SendContextLocalAndLinkGroups;
exports.MR_UrlTriggering_PrepareForScreenshot = MR_UrlTriggering_PrepareForScreenshot;
exports.MR_PingTab = MR_PingTab;
exports.MR_DoesElementExistOnPage = MR_DoesElementExistOnPage;
exports.MR_AskTabToRenderModalToExplainHighlightElement = MR_AskTabToRenderModalToExplainHighlightElement;
exports.MR_AskTabToSetupHighlightElementControl = MR_AskTabToSetupHighlightElementControl;
exports.MR_AskTabToTeardownHighlightElementControl = MR_AskTabToTeardownHighlightElementControl;
exports.MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.MR_AskTabToEnterDataExtractionMode = MR_AskTabToEnterDataExtractionMode;
exports.MR_AskTabToExitDataExtractionMode = MR_AskTabToExitDataExtractionMode;
exports.MR_All = MR_All;
exports.MRTransform_StartStreamingEventsToBackground = MRTransform_StartStreamingEventsToBackground;
exports.StartStreamingEventsToBackground = StartStreamingEventsToBackground;
exports.MRTransform_StopStreamingEventsToBackground = MRTransform_StopStreamingEventsToBackground;
exports.StopStreamingEventsToBackground = StopStreamingEventsToBackground;
exports.MRTransform_Playback = MRTransform_Playback;
exports.Playback = Playback;
exports.MRTransform_PlaybackExited = MRTransform_PlaybackExited;
exports.PlaybackExited = PlaybackExited;
exports.MRTransform_RenderInContentScript = MRTransform_RenderInContentScript;
exports.RenderInContentScript = RenderInContentScript;
exports.MRTransform_AskContentScriptToAdjustModalGeometry = MRTransform_AskContentScriptToAdjustModalGeometry;
exports.AskContentScriptToAdjustModalGeometry = AskContentScriptToAdjustModalGeometry;
exports.MRTransform_AskContentScriptToEnterUrlTriggeringMode = MRTransform_AskContentScriptToEnterUrlTriggeringMode;
exports.AskContentScriptToEnterUrlTriggeringMode = AskContentScriptToEnterUrlTriggeringMode;
exports.MRTransform_UrlTriggering_RefreshLinks = MRTransform_UrlTriggering_RefreshLinks;
exports.UrlTriggering_RefreshLinks = UrlTriggering_RefreshLinks;
exports.MRTransform_UrlTriggering_UpdateLinks = MRTransform_UrlTriggering_UpdateLinks;
exports.UrlTriggering_UpdateLinks = UrlTriggering_UpdateLinks;
exports.MRTransform_UrlTriggering_TellTabToUpdateLinkGroups = MRTransform_UrlTriggering_TellTabToUpdateLinkGroups;
exports.UrlTriggering_TellTabToUpdateLinkGroups = UrlTriggering_TellTabToUpdateLinkGroups;
exports.MRTransform_UrlTriggering_Exit = MRTransform_UrlTriggering_Exit;
exports.UrlTriggering_Exit = UrlTriggering_Exit;
exports.MRTransform_UrlTriggering_AskContentScriptToRecordPageAction = MRTransform_UrlTriggering_AskContentScriptToRecordPageAction;
exports.UrlTriggering_AskContentScriptToRecordPageAction = UrlTriggering_AskContentScriptToRecordPageAction;
exports.MRTransform_UrlTriggering_StopRecordPageAction = MRTransform_UrlTriggering_StopRecordPageAction;
exports.UrlTriggering_StopRecordPageAction = UrlTriggering_StopRecordPageAction;
exports.MRTransform_UrlTriggering_PlaybackPageAction = MRTransform_UrlTriggering_PlaybackPageAction;
exports.UrlTriggering_PlaybackPageAction = UrlTriggering_PlaybackPageAction;
exports.MRTransform_UrlTriggering_DidFinishPlaybackPageAction = MRTransform_UrlTriggering_DidFinishPlaybackPageAction;
exports.UrlTriggering_DidFinishPlaybackPageAction = UrlTriggering_DidFinishPlaybackPageAction;
exports.MRTransform_UrlTriggering_ShowLinkWithId = MRTransform_UrlTriggering_ShowLinkWithId;
exports.UrlTriggering_ShowLinkWithId = UrlTriggering_ShowLinkWithId;
exports.MRTransform_UrlTriggering_SendContextLocalAndLinkGroups = MRTransform_UrlTriggering_SendContextLocalAndLinkGroups;
exports.UrlTriggering_SendContextLocalAndLinkGroups = UrlTriggering_SendContextLocalAndLinkGroups;
exports.MRTransform_UrlTriggering_PrepareForScreenshot = MRTransform_UrlTriggering_PrepareForScreenshot;
exports.UrlTriggering_PrepareForScreenshot = UrlTriggering_PrepareForScreenshot;
exports.MRTransform_PingTab = MRTransform_PingTab;
exports.PingTab = PingTab;
exports.MRTransform_DoesElementExistOnPage = MRTransform_DoesElementExistOnPage;
exports.DoesElementExistOnPage = DoesElementExistOnPage;
exports.MRTransform_AskTabToRenderModalToExplainHighlightElement = MRTransform_AskTabToRenderModalToExplainHighlightElement;
exports.AskTabToRenderModalToExplainHighlightElement = AskTabToRenderModalToExplainHighlightElement;
exports.MRTransform_AskTabToSetupHighlightElementControl = MRTransform_AskTabToSetupHighlightElementControl;
exports.AskTabToSetupHighlightElementControl = AskTabToSetupHighlightElementControl;
exports.MRTransform_AskTabToTeardownHighlightElementControl = MRTransform_AskTabToTeardownHighlightElementControl;
exports.AskTabToTeardownHighlightElementControl = AskTabToTeardownHighlightElementControl;
exports.MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.MRTransform_AskTabToEnterDataExtractionMode = MRTransform_AskTabToEnterDataExtractionMode;
exports.AskTabToEnterDataExtractionMode = AskTabToEnterDataExtractionMode;
exports.MRTransform_AskTabToExitDataExtractionMode = MRTransform_AskTabToExitDataExtractionMode;
exports.AskTabToExitDataExtractionMode = AskTabToExitDataExtractionMode;
exports.All = All; /* StartStreamingEventsToBackground Not a pure module */ 


/***/ }),

/***/ 82528:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function t_encode(v) {
    switch(v){
        case /* PopupMultiUrlTrigger */ 0:
            return [
                "PopupMultiUrlTrigger"
            ];
        case /* ContextMenuMultiUrlTrigger */ 1:
            return [
                "ContextMenuMultiUrlTrigger"
            ];
        case /* PopupRunHereTrigger */ 2:
            return [
                "PopupRunHereTrigger"
            ];
        case /* PageFormTrigger */ 3:
            return [
                "PageFormTrigger"
            ];
        case /* GoogleSheetTrigger */ 4:
            return [
                "GoogleSheetTrigger"
            ];
        case /* ScheduledTrigger */ 5:
            return [
                "ScheduledTrigger"
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContextMenuMultiUrlTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContextMenuMultiUrlTrigger */ 1
                    };
                }
            case "GoogleSheetTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* GoogleSheetTrigger */ 4
                    };
                }
            case "PageFormTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PageFormTrigger */ 3
                    };
                }
            case "PopupMultiUrlTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PopupMultiUrlTrigger */ 0
                    };
                }
            case "PopupRunHereTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PopupRunHereTrigger */ 2
                    };
                }
            case "ScheduledTrigger":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ScheduledTrigger */ 5
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    switch(v){
        case /* PopupMultiUrlTrigger */ 0:
            return "PopupMultiUrlTrigger";
        case /* ContextMenuMultiUrlTrigger */ 1:
            return "ContextMenuMultiUrlTrigger";
        case /* PopupRunHereTrigger */ 2:
            return "PopupRunHereTrigger";
        case /* PageFormTrigger */ 3:
            return "PageFormTrigger";
        case /* GoogleSheetTrigger */ 4:
            return "GoogleSheetTrigger";
        case /* ScheduledTrigger */ 5:
            return "ScheduledTrigger";
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify; /* No side effect */ 


/***/ }),

/***/ 95421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Modal__WebAuth$SmartcutsMacros = __webpack_require__(44833);
var RenderOnHost__Notification$SmartcutsMacros = __webpack_require__(44976);
var RenderOnHost__IframeContent$SmartcutsMacros = __webpack_require__(37936);
function t_encode(v) {
    switch(v.TAG | 0){
        case /* WebAuthModal */ 0:
            return [
                "WebAuthModal",
                Modal__WebAuth$SmartcutsMacros.Context.t_encode(v._0)
            ];
        case /* NotifyWithOutput */ 1:
            return [
                "NotifyWithOutput",
                RenderOnHost__Notification$SmartcutsMacros.t_encode(v._0)
            ];
        case /* IframeContent */ 2:
            return [
                "IframeContent",
                RenderOnHost__IframeContent$SmartcutsMacros.t_encode(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "IframeContent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = RenderOnHost__IframeContent$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* IframeContent */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NotifyWithOutput":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = RenderOnHost__Notification$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NotifyWithOutput */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "WebAuthModal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Modal__WebAuth$SmartcutsMacros.Context.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WebAuthModal */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(renderingContent) {
    switch(renderingContent.TAG | 0){
        case /* WebAuthModal */ 0:
            return "WebAuthModal(" + (Modal__WebAuth$SmartcutsMacros.Context.stringify(renderingContent._0) + ")");
        case /* NotifyWithOutput */ 1:
            return "NotifyWithOutput(" + (RenderOnHost__Notification$SmartcutsMacros.stringify(renderingContent._0) + ")");
        case /* IframeContent */ 2:
            return "IframeContent(" + (RenderOnHost__IframeContent$SmartcutsMacros.stringify(renderingContent._0) + ")");
    }
}
var Modal;
var $$Notification;
var IframeContent;
exports.Modal = Modal;
exports.$$Notification = $$Notification;
exports.IframeContent = IframeContent;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify; /* Modal__WebAuth-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 37936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var CssJs = __webpack_require__(62380);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Css_Js_Core = __webpack_require__(54446);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var PlaybackTrigger$SmartcutsMacros = __webpack_require__(82528);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var SharedModalTypes$SmartcutsMacros = __webpack_require__(3232);
var SmartcutExecution$SmartcutsMacros = __webpack_require__(32062);
var PermissionAndOrigin$SmartcutsMacros = __webpack_require__(93834);
var RenderOnHost__Geometry$SmartcutsMacros = __webpack_require__(1763);
var MultiUrlTriggering__Shared$SmartcutsMacros = __webpack_require__(8641);
function t_encode(v) {
    if (typeof v === "number") {
        if (v === /* ExplainHighlightElement */ 0) {
            return [
                "ExplainHighlightElement"
            ];
        } else {
            return [
                "MasterSecretPrompt"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* SmartcutPlaybackForm */ 0:
            return [
                "SmartcutPlaybackForm",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
            ];
        case /* UrlHighlightModal */ 1:
            return [
                "UrlHighlightModal",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0),
                SmartcutExecution$SmartcutsMacros.ExecutionSet.multiUrlTriggeringTrigger_encode(v._1),
                Decco.optionToJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.initState_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
                }, v._2)
            ];
        case /* ExplainExtensionPermissions */ 2:
            return [
                "ExplainExtensionPermissions",
                Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v._0),
                PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_encode(v._1)
            ];
        case /* ConfirmExecutionQuotaModal */ 3:
            return [
                "ConfirmExecutionQuotaModal",
                Decco.intToJson(v._0),
                PlaybackTrigger$SmartcutsMacros.t_encode(v._1)
            ];
        case /* LogInToWebsiteToContinuePlayback */ 4:
            return [
                "LogInToWebsiteToContinuePlayback",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._2)
            ];
        case /* SaveSmartcutProgressModal */ 5:
            return [
                "SaveSmartcutProgressModal",
                Decco.stringToJson(v._0),
                SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.t_encode(v._1)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ConfirmExecutionQuotaModal":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ConfirmExecutionQuotaModal */ 3,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ExplainExtensionPermissions":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ExplainExtensionPermissions */ 2,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ExplainHighlightElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExplainHighlightElement */ 0
                    };
                }
            case "LogInToWebsiteToContinuePlayback":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$7 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        if (match$7.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* LogInToWebsiteToContinuePlayback */ 4,
                                    _0: match$5._0,
                                    _1: match$6._0,
                                    _2: match$7._0
                                }
                            };
                        }
                        var e$4 = match$7._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "MasterSecretPrompt":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MasterSecretPrompt */ 1
                    };
                }
            case "SaveSmartcutProgressModal":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$9 = SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$8.TAG === /* Ok */ 0) {
                    if (match$9.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SaveSmartcutProgressModal */ 5,
                                _0: match$8._0,
                                _1: match$9._0
                            }
                        };
                    }
                    var e$7 = match$9._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "SmartcutPlaybackForm":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SmartcutPlaybackForm */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$9 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "UrlHighlightModal":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$10 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$11 = SmartcutExecution$SmartcutsMacros.ExecutionSet.multiUrlTriggeringTrigger_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$12 = Decco.optionFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.initState_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
                }, Belt_Array.getExn(jsonArr$1, 3));
                if (match$10.TAG === /* Ok */ 0) {
                    if (match$11.TAG === /* Ok */ 0) {
                        if (match$12.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* UrlHighlightModal */ 1,
                                    _0: match$10._0,
                                    _1: match$11._0,
                                    _2: match$12._0
                                }
                            };
                        }
                        var e$10 = match$12._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                            }
                        };
                    }
                    var e$11 = match$11._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$12 = match$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (typeof v === "number") {
        if (v === /* ExplainHighlightElement */ 0) {
            return "ExplainHighlightElement";
        } else {
            return "MasterSecretPrompt";
        }
    }
    switch(v.TAG | 0){
        case /* SmartcutPlaybackForm */ 0:
            return "SmartcutPlaybackForm(" + (v._0 + ")");
        case /* UrlHighlightModal */ 1:
            return "UrlHighlightModal(" + (v._0 + (", " + (SmartcutExecution$SmartcutsMacros.ExecutionSet.stringifyMultiUrlTriggeringTrigger(v._1) + (", " + ((v._2 !== undefined ? "Some(initState)" : "None") + ")")))));
        case /* ExplainExtensionPermissions */ 2:
            return "ExplainExtensionPermissions(permissions, permissionTrigger)";
        case /* ConfirmExecutionQuotaModal */ 3:
            return "ConfirmExecutionQuotaModal(" + (String(v._0) + (", " + (PlaybackTrigger$SmartcutsMacros.stringify(v._1) + ")")));
        case /* LogInToWebsiteToContinuePlayback */ 4:
            return "LogInToWebsiteToContinuePlayback(" + (v._0 + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", " + (v._2 + ")")))));
        case /* SaveSmartcutProgressModal */ 5:
            return "SaveSmartcutProgressModal(smartcutName=" + (v._0 + (", progress=" + (SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.stringify(v._1) + ")")));
    }
}
var containerId = "smartcuts-iframe";
var container = CssJs.style([
    CssJs.position("fixed"),
    CssJs.zIndex(20000)
]);
var iframe = CssJs.style([
    CssJs.position("fixed"),
    CssJs.width({
        NAME: "percent",
        VAL: 100
    }),
    CssJs.height({
        NAME: "percent",
        VAL: 100
    }),
    CssJs.maxHeight({
        NAME: "calc",
        VAL: [
            "sub",
            {
                NAME: "vh",
                VAL: 100.0
            },
            {
                NAME: "px",
                VAL: 100
            }
        ]
    })
]);
var fullHeight = CssJs.style([
    CssJs.maxHeight({
        NAME: "vh",
        VAL: 100.0
    })
]);
var smartcutPlaybackForm = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var urlHighlightModal = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxHeight({
            NAME: "vh",
            VAL: 100.0
        }),
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box({
            NAME: "px",
            VAL: 3
        }, undefined, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        }))
    ])
]);
var explainExtensionPermissions = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 350
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var loginToWebsite = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 330
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var saveSmartcutProgressModal = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 330
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var confirmExecutionQuotaModal = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 420
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var explainHighlightElement = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 480
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var masterSecretPrompt = CssJs.style([
    CssJs.selector("iframe", [
        CssJs.maxWidth({
            NAME: "px",
            VAL: 500
        }),
        CssJs.maxHeight({
            NAME: "px",
            VAL: 200
        }),
        CssJs.marginTop({
            NAME: "px",
            VAL: 20
        }),
        CssJs.marginLeft({
            NAME: "percent",
            VAL: 50.0
        }),
        CssJs.transform({
            NAME: "translateX",
            VAL: {
                NAME: "percent",
                VAL: -50.0
            }
        }),
        CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
            NAME: "px",
            VAL: 3
        }, {
            NAME: "px",
            VAL: 10
        }, undefined, undefined, {
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.15
                }
            ]
        })),
        CssJs.borderRadius({
            NAME: "px",
            VAL: 5
        })
    ])
]);
var withOverlay = CssJs.style([
    CssJs.top("zero"),
    CssJs.left("zero"),
    CssJs.width({
        NAME: "percent",
        VAL: 100.0
    }),
    CssJs.height({
        NAME: "percent",
        VAL: 100.0
    }),
    CssJs.background({
        NAME: "rgba",
        VAL: [
            0,
            0,
            0,
            {
                NAME: "num",
                VAL: 0.15
            }
        ]
    })
]);
var Style = {
    container: container,
    iframe: iframe,
    fullHeight: fullHeight,
    smartcutPlaybackForm: smartcutPlaybackForm,
    urlHighlightModal: urlHighlightModal,
    explainExtensionPermissions: explainExtensionPermissions,
    loginToWebsite: loginToWebsite,
    saveSmartcutProgressModal: saveSmartcutProgressModal,
    confirmExecutionQuotaModal: confirmExecutionQuotaModal,
    explainHighlightElement: explainHighlightElement,
    masterSecretPrompt: masterSecretPrompt,
    withOverlay: withOverlay
};
function createOrResetContainerAndIframe(param1) {
    var htmlDocument = document;
    var createIframe = function createIframe(container1) {
        var iframe$1 = htmlDocument.createElement("iframe");
        var classList = iframe$1.classList;
        classList.add(iframe);
        iframe$1.setAttribute("frameborder", "0");
        container1.appendChild(iframe$1);
        return iframe$1;
    };
    var container$1 = document.getElementById(containerId);
    var match;
    if (container$1 == null) {
        var container$2 = htmlDocument.createElement("div");
        container$2.id = containerId;
        var arg = htmlDocument.body;
        var arg$1 = arg == null ? undefined : Caml_option.some(arg);
        var prim0 = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }("Expect to get body");
        prim0.appendChild(container$2);
        match = [
            container$2,
            createIframe(container$2)
        ];
    } else {
        var iframe$11 = container$1.querySelector("iframe");
        if (iframe$11 == null) {
            match = [
                container$1,
                createIframe(container$1)
            ];
        } else {
            container$1.removeChild(iframe$11);
            match = [
                container$1,
                createIframe(container$1)
            ];
        }
    }
    var container$3 = match[0];
    container$3.className = container;
    return [
        container$3,
        match[1]
    ];
}
function render(iframeContent) {
    var match = createOrResetContainerAndIframe(undefined);
    var iframe1 = match[1];
    var container2 = match[0];
    if (typeof iframeContent === "number") {
        if (iframeContent === /* ExplainHighlightElement */ 0) {
            container2.classList.add(withOverlay, explainHighlightElement);
        } else {
            container2.classList.add(withOverlay, masterSecretPrompt);
        }
    } else {
        switch(iframeContent.TAG | 0){
            case /* SmartcutPlaybackForm */ 0:
                container2.classList.add(withOverlay, smartcutPlaybackForm);
                break;
            case /* UrlHighlightModal */ 1:
                container2.classList.add(urlHighlightModal);
                break;
            case /* ExplainExtensionPermissions */ 2:
                container2.classList.add(withOverlay, explainExtensionPermissions);
                break;
            case /* ConfirmExecutionQuotaModal */ 3:
                container2.classList.add(withOverlay, confirmExecutionQuotaModal);
                break;
            case /* LogInToWebsiteToContinuePlayback */ 4:
                container2.classList.add(withOverlay, loginToWebsite);
                break;
            case /* SaveSmartcutProgressModal */ 5:
                container2.classList.add(withOverlay, saveSmartcutProgressModal);
                break;
        }
    }
    iframe1.setAttribute("style", "display: none");
    iframe1.setAttribute("src", browser.runtime.getURL("html/iframe.html?content=" + encodeURIComponent(JSON.stringify(t_encode(iframeContent)))));
    iframe1.onload = function(param) {
        iframe1.removeAttribute("style");
    };
    return Promise.resolve(iframe1);
}
function resizeAndReposition(param) {
    var maybePosition = param.position;
    var maybeHeightUpdate = param.height;
    var maybeWidthUpdate = param.width;
    var container3 = document.querySelector("#" + containerId + " iframe");
    if (container3 == null) {
        return;
    }
    if (maybeWidthUpdate !== undefined) {
        container3.style.width = RenderOnHost__Geometry$SmartcutsMacros.Length.toCSSValue(maybeWidthUpdate);
    }
    if (maybeHeightUpdate !== undefined) {
        container3.style.height = RenderOnHost__Geometry$SmartcutsMacros.Length.toCSSValue(maybeHeightUpdate);
    }
    if (maybePosition === undefined) {
        return;
    }
    switch(maybePosition){
        case /* Left */ 0:
            container3.style.top = "0";
            container3.style.right = "";
            container3.style.left = "0";
            return;
        case /* Right */ 1:
            container3.style.top = "0";
            container3.style.left = "";
            container3.style.right = "0";
            return;
        case /* Default */ 2:
            container3.style.left = "";
            container3.style.right = "";
            return;
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.containerId = containerId;
exports.Style = Style;
exports.render = render;
exports.resizeAndReposition = resizeAndReposition; /* container Not a pure module */ 


/***/ }),

/***/ 8741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ExtErrors$SmartcutsMacros = __webpack_require__(36570);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
function findInDomAndApplySemanticError_encode(error) {
    return ExtErrors$SmartcutsMacros.t_encode(undefined, function(prim) {
        return prim;
    }, error);
}
function findInDomAndApplySemanticError_decode(json) {
    var error = ExtErrors$SmartcutsMacros.t_decode(undefined, Decco.stringFromJson, json);
    if (error.TAG !== /* Ok */ 0) {
        return {
            TAG: /* Error */ 1,
            _0: error._0
        };
    }
    var error$1 = error._0;
    if (typeof error$1 === "number") {
        switch(error$1){
            case /* CdpUnableToGetContentQuads */ 0:
            case /* CdpUnableToGetDocument */ 1:
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected");
            default:
                return {
                    TAG: /* Ok */ 0,
                    _0: error$1
                };
        }
    } else {
        switch(error$1.TAG | 0){
            case /* CdpQuerySelectorTimedOut */ 10:
            case /* ErrorWhileCdpQuerySelector */ 11:
            case /* PlaybackCaptureScreenshotError */ 12:
            case /* ContentScriptResponseError */ 13:
            case /* UnhandledContentScriptPromiseError */ 14:
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected");
            default:
                return {
                    TAG: /* Ok */ 0,
                    _0: error$1
                };
        }
    }
}
function fromInputSelectionOrCursorSemanticsError(error) {
    if (typeof error === "number") {
        return error;
    }
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
        return error;
    }
    var match = error._0;
    return {
        TAG: /* OverlayStillBlockingElementAfterMs */ 5,
        _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
        }
    };
}
function fromSelectionOrCursorSemanticsError(error) {
    if (typeof error === "number") {
        return error;
    }
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
        return error;
    }
    var match = error._0;
    return {
        TAG: /* OverlayStillBlockingElementAfterMs */ 5,
        _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
        }
    };
}
function fromStrictSelectionSemanticsError(error) {
    if (typeof error === "number") {
        return error;
    }
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
        return error;
    }
    var match = error._0;
    return {
        TAG: /* OverlayStillBlockingElementAfterMs */ 5,
        _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
        }
    };
}
function fromCursorSemanticsError(error) {
    if (typeof error === "number") {
        return error;
    }
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
        return error;
    }
    var match = error._0;
    return {
        TAG: /* OverlayStillBlockingElementAfterMs */ 5,
        _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
        }
    };
}
function fromContentEditableCursorSemanticsError(error) {
    if (typeof error === "number") {
        return error;
    }
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
        return error;
    }
    var match = error._0;
    return {
        TAG: /* OverlayStillBlockingElementAfterMs */ 5,
        _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
        }
    };
}
var StrictSelectionSemantics;
var InputCursorSemantics;
var InputSelectionSemantics;
var InputSelectionOrCursorSemantics;
var ContentEditableCursorSemantics;
var ContentEditableSelectionSemantics;
var ContentEditableSelectionOrCursorSemantics;
exports.StrictSelectionSemantics = StrictSelectionSemantics;
exports.InputCursorSemantics = InputCursorSemantics;
exports.InputSelectionSemantics = InputSelectionSemantics;
exports.InputSelectionOrCursorSemantics = InputSelectionOrCursorSemantics;
exports.ContentEditableCursorSemantics = ContentEditableCursorSemantics;
exports.ContentEditableSelectionSemantics = ContentEditableSelectionSemantics;
exports.ContentEditableSelectionOrCursorSemantics = ContentEditableSelectionOrCursorSemantics;
exports.findInDomAndApplySemanticError_encode = findInDomAndApplySemanticError_encode;
exports.findInDomAndApplySemanticError_decode = findInDomAndApplySemanticError_decode;
exports.fromInputSelectionOrCursorSemanticsError = fromInputSelectionOrCursorSemanticsError;
exports.fromSelectionOrCursorSemanticsError = fromSelectionOrCursorSemanticsError;
exports.fromStrictSelectionSemanticsError = fromStrictSelectionSemanticsError;
exports.fromCursorSemanticsError = fromCursorSemanticsError;
exports.fromContentEditableCursorSemanticsError = fromContentEditableCursorSemanticsError; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 61569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros = __webpack_require__(81588);
function semanticError_encode(v) {
    if (v.TAG === /* CouldNotFindNthParagraph */ 0) {
        return [
            "CouldNotFindNthParagraph",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "CouldNotApplyNonInputSelectionSemanticInNthParagraph",
            Decco.intToJson(v._0),
            SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_encode(v._1)
        ];
    }
}
function semanticError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotApplyNonInputSelectionSemanticInNthParagraph":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = SelectionSemantics__NonInputSelectionSemantics__Errors$SmartcutsMacros.semanticError_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CouldNotApplyNonInputSelectionSemanticInNthParagraph */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "CouldNotFindNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindNthParagraph */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode; /* SelectionSemantics__NonInputSelectionSemantics__Errors-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 39658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function semanticError_encode(v) {
    if (v.TAG === /* CouldNotFindNthWord */ 0) {
        return [
            "CouldNotFindNthWord",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "CouldNotFindOffsetInsideNthWord",
            Decco.intToJson(v._0),
            Decco.stringToJson(v._1),
            Decco.intToJson(v._2)
        ];
    }
}
function semanticError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotFindNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindNthWord */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CouldNotFindOffsetInsideNthWord":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* CouldNotFindOffsetInsideNthWord */ 1,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode; /* No side effect */ 


/***/ }),

/***/ 14868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function semanticError_encode(v) {
    switch(v.TAG | 0){
        case /* CouldNotFindNthWord */ 0:
            return [
                "CouldNotFindNthWord",
                Decco.intToJson(v._0),
                Decco.arrayToJson(function(param) {
                    return [
                        Decco.intToJson(param[0]),
                        Decco.stringToJson(param[1])
                    ];
                }, v._1)
            ];
        case /* CouldNotFindIndex */ 1:
            return [
                "CouldNotFindIndex",
                Decco.intToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* CouldNotFindPrefix */ 2:
            return [
                "CouldNotFindPrefix",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* CouldNotFindSuffix */ 3:
            return [
                "CouldNotFindSuffix",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
            ];
    }
}
function semanticError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match1 = Belt_Array.getExn(tagged, 0);
    if (typeof match1 !== "number" && match1.TAG === /* JSONString */ 0) {
        switch(match1._0){
            case "CouldNotFindIndex":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$21 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$21.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CouldNotFindIndex */ 1,
                                _0: match$11._0,
                                _1: match$21._0
                            }
                        };
                    }
                    var e = match$21._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$11 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "CouldNotFindNthWord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$31 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.arrayFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = Decco.intFromJson(v0);
                    var match$3 = Decco.stringFromJson(v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Array.getExn(jsonArr$1, 2));
                if (match$31.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CouldNotFindNthWord */ 0,
                                _0: match$31._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$31._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "CouldNotFindPrefix":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CouldNotFindPrefix */ 2,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "CouldNotFindSuffix":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CouldNotFindSuffix */ 3,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$6 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode; /* No side effect */ 


/***/ }),

/***/ 81588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Selector$SmartcutsMacros = __webpack_require__(14809);
function semanticError_encode(v) {
    switch(v.TAG | 0){
        case /* SuffixNotFound */ 0:
            return [
                "SuffixNotFound",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* NoneOfSuffixesFound */ 1:
            return [
                "NoneOfSuffixesFound",
                Decco.arrayToJson(Decco.stringToJson, v._0),
                Decco.stringToJson(v._1)
            ];
        case /* PrefixNotFound */ 2:
            return [
                "PrefixNotFound",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* StartIndexOutOfBounds */ 3:
            return [
                "StartIndexOutOfBounds",
                Decco.intToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* EndIndexOutOfBounds */ 4:
            return [
                "EndIndexOutOfBounds",
                Decco.intToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* ExpectedTextNodeButGotAnotherNodeType */ 5:
            return [
                "ExpectedTextNodeButGotAnotherNodeType",
                Selector$SmartcutsMacros.selector_encode(v._0)
            ];
    }
}
function semanticError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "EndIndexOutOfBounds":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* EndIndexOutOfBounds */ 4,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ExpectedTextNodeButGotAnotherNodeType":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "NoneOfSuffixesFound":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NoneOfSuffixesFound */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$3 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "PrefixNotFound":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* PrefixNotFound */ 2,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$5 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "StartIndexOutOfBounds":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* StartIndexOutOfBounds */ 3,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$7 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "SuffixNotFound":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SuffixNotFound */ 0,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$9 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 3232:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
function t_encode(v) {
    if (v) {
        return [
            "SavingScreenshots",
            SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode(v._0),
            Decco.intToJson(v._1)
        ];
    } else {
        return [
            "SavingSmartcutAndRecordedSmartcut"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SavingScreenshots":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: /* SavingScreenshots */ {
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SavingSmartcutAndRecordedSmartcut":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SavingSmartcutAndRecordedSmartcut */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(progress) {
    if (progress) {
        return "SavingScreenshots(" + progress._0 + ", " + progress._1 + "%)";
    } else {
        return "SavingSmartcutAndRecordedSmartcut";
    }
}
var SavingSmartcutProgress = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.SavingSmartcutProgress = SavingSmartcutProgress; /* SmartcutIds-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 23985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var GoogleApiHelpers$SmartcutsMacros = __webpack_require__(81530);
var GoogleApis__Sheets$SmartcutsMacros = __webpack_require__(45694);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var GoogleApis__Sheets__Schema$SmartcutsMacros = __webpack_require__(11815);
var GoogleApis__Sheets__Values$SmartcutsMacros = __webpack_require__(32903);
var GoogleSheetsPlaybackHelpers$SmartcutsMacros = __webpack_require__(62574);
var DataExtraction__ExportToTable$SmartcutsMacros = __webpack_require__(87148);
var GoogleApis__Sheets__BatchUpdate$SmartcutsMacros = __webpack_require__(71097);
function saveRowsToDestination_encode(v) {
    return Js_dict.fromArray([
        [
            "destination",
            Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_encode, v.destination)
        ],
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
            }, v.columns)
        ],
        [
            "maybeExtraColumns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
            }, v.maybeExtraColumns)
        ],
        [
            "rows",
            Decco.arrayToJson(function(param1) {
                return Decco.arrayToJson(function(param) {
                    return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                }, param1);
            }, v.rows)
        ]
    ]);
}
function saveRowsToDestination_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var destination = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
    if (destination.TAG === /* Ok */ 0) {
        var columns = Decco.arrayFromJson(function(param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
        if (columns.TAG === /* Ok */ 0) {
            var maybeExtraColumns = Decco.optionFromJson(function(param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
            if (maybeExtraColumns.TAG === /* Ok */ 0) {
                var rows = Decco.arrayFromJson(function(param2) {
                    return Decco.arrayFromJson(function(param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                    }, param2);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
                if (rows.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            destination: destination._0,
                            columns: columns._0,
                            maybeExtraColumns: maybeExtraColumns._0,
                            rows: rows._0
                        }
                    };
                }
                var e = rows._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".rows" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = maybeExtraColumns._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeExtraColumns" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = columns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".columns" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = destination._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".destination" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function t_encode(v) {
    return [
        "SaveRowsToDestination",
        saveRowsToDestination_encode(v._0)
    ];
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SaveRowsToDestination") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = saveRowsToDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* SaveRowsToDestination */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(finalEffect) {
    return "SaveRowsToDestination({destination, columns, rows: [" + (String(finalEffect._0.rows.length) + "]})");
}
function maxColumnLength(rows) {
    return Belt_Array.reduce(rows, 0, function(maxColumnLength1, row) {
        var columnLength = row.length;
        if (columnLength > maxColumnLength1) {
            return columnLength;
        } else {
            return maxColumnLength1;
        }
    });
}
function makeHeaders(columns, maybeExtraColumns) {
    var arg = Belt_Option.map(maybeExtraColumns, function(extraColumns) {
        return Belt_Array.map(extraColumns, function(extraColumn) {
            if (extraColumn) {
                return "Saved from web page";
            } else {
                return "Saved at date time";
            }
        });
    });
    return {
        values: Belt_Array.map(Belt_Array.concat(Belt_Array.map(columns, function(param) {
            return param.columnName;
        }), function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }([])), function(value) {
            return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(value), undefined);
        })
    };
}
function makeRowDatas(rows, currentUrl, currentDateTime, maybeExtraColumns) {
    var arg1 = Belt_Option.map(maybeExtraColumns, function(extraColumns) {
        return Belt_Array.map(extraColumns, function(extraColumn) {
            return Curry._3(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.resolveAsCellData, Curry._4(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.fromExtraColumn, extraColumn, currentUrl, Caml_option.some(currentDateTime), undefined), undefined, undefined);
        });
    });
    var extraCells = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg1);
    }([]);
    return Belt_Array.map(rows, function(row) {
        return {
            values: Belt_Array.concat(Belt_Array.map(Belt_Array.map(row, function(param) {
                var arg = Belt_Option.map(param.value, DataExtraction__ExportToTable$SmartcutsMacros.resolveCellValueAsText);
                var param$1 = "";
                return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
            }), function(value) {
                return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(value), undefined);
            }), extraCells)
        };
    });
}
function handleGoogleApiHelpersError(errorOnMethodDidThrowPromiseError, error) {
    switch(error.TAG | 0){
        case /* MethodDidThrowPromiseError */ 0:
            return {
                TAG: /* Error */ 1,
                _0: Curry._1(errorOnMethodDidThrowPromiseError, error.errorType)
            };
        case /* JsExnWhileRemoveCachedOAuthToken */ 1:
            return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* CouldNotRemoveCachedOAuthToken */ 0,
                    _0: error.jsExn
                }
            };
        case /* PromiseErrorWhileGetNewOAuthToken */ 2:
            return {
                TAG: /* Error */ 1,
                _0: /* CouldNotGetNewOAuthToken */ 0
            };
    }
}
function appendRowsToGoogleSheet(client1, maybeValueRangeWithoutEnum, spreadsheetId, sheetName, authToken, rows, currentUrl, currentDateTime) {
    var valueRangeWithoutEnum = OptionUtils$SmartcutsMacros.getExn("Expect to get spreadsheet with some sheets", maybeValueRangeWithoutEnum);
    var valueRange = GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.fromWithoutEnum(valueRangeWithoutEnum);
    var lastRowIndex1 = Belt_Array.reduceWithIndex(valueRange.values, 0, function(lastRowIndex, row, rowIndex) {
        if (row.length !== 1) {
            return rowIndex;
        }
        var match = row[0];
        if (match === "") {
            return lastRowIndex;
        } else {
            return rowIndex;
        }
    });
    var wrappedSearchMetadata = function wrappedSearchMetadata(param, param$1) {
        return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
            return GoogleApis__Sheets$SmartcutsMacros.searchDeveloperMetadata(spreadsheetId, accessToken, {
                dataFilters: Belt_Array.mapWithIndex(Caml_array.make(maxColumnLength(valueRange.values), undefined), function(colIndex, _v) {
                    var a1 = GoogleSheetsCommand$SmartcutsMacros.A1.columnForIndexStarting0(colIndex);
                    return GoogleApis__Sheets__Schema$SmartcutsMacros.DataFilter.a1Range("" + sheetName + "!" + a1 + ":" + a1);
                })
            }, client);
        }, param, param$1);
    };
    var cell = GoogleSheetsCommand$SmartcutsMacros.A1.fromRowColStarting0(lastRowIndex1 + 1 | 0, 0);
    var lastCell = GoogleSheetsCommand$SmartcutsMacros.A1.fromRowColStarting0(lastRowIndex1 + rows.length | 0, maxColumnLength(rows));
    var range = "'" + sheetName + "'!" + cell + ":" + lastCell;
    var wrappedAppend = function wrappedAppend(rowsToAppend) {
        return function(param3, param$11) {
            return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
                var arg = {
                    range: range,
                    majorDimension: /* Rows */ 0,
                    values: rowsToAppend
                };
                var arg$1 = function arg$1(param4, param$12, param$21, param$3, param$4, param$5) {
                    var func = Curry.app(GoogleApis__Sheets__Values$SmartcutsMacros.append, [
                        accessToken,
                        param4,
                        param$12,
                        param$21,
                        param$3,
                        param$4,
                        param$5,
                        range,
                        spreadsheetId
                    ]);
                    return function(param5, param$13) {
                        var func$1 = Curry._4(func, param5, param$13, "UserEntered", "InsertRows");
                        return function(param, param$1, param$2) {
                            return Curry._4(func$1, param, param$1, param$2, arg);
                        };
                    };
                };
                return Curry._4(arg$1(undefined, undefined, undefined, undefined, undefined, undefined)(undefined, undefined), undefined, undefined, undefined, client);
            }, param3, param$11);
        };
    };
    return wrappedSearchMetadata(authToken, client1).then(function(result) {
        var metadata;
        var exit = 0;
        var matchedDeveloperMetadata;
        if (result.TAG === /* Ok */ 0) {
            var match = result._0;
            if (typeof match === "number") {
                metadata = [];
            } else if (match.TAG === /* MethodDidReturnUsingOriginalToken */ 0) {
                var match$1 = match._0;
                if (match$1 !== undefined) {
                    matchedDeveloperMetadata = match$1.matchedDeveloperMetadata;
                    exit = 1;
                } else {
                    metadata = [];
                }
            } else {
                var match$2 = match.return_;
                if (match$2 !== undefined) {
                    matchedDeveloperMetadata = match$2.matchedDeveloperMetadata;
                    exit = 1;
                } else {
                    metadata = [];
                }
            }
        } else {
            metadata = [];
        }
        if (exit === 1) {
            metadata = Belt_Array.map(matchedDeveloperMetadata, function(param) {
                return param.developerMetadata;
            });
        }
        var rowsToAppend = Belt_Array.map(rows, function(cells) {
            var newRow = Caml_array.make(maxColumnLength(rows), undefined);
            Belt_Array.forEach(metadata, function(param6) {
                var metadataValue = param6.metadataValue;
                var match = Curry._1(GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRangeGet, param6.location);
                switch(param6.metadataKey){
                    case "columnId":
                        if (match === undefined) {
                            return;
                        }
                        var startIndex = match.startIndex;
                        var maybeCell = ArrayUtils$SmartcutsMacros.firstMatch(function(param) {
                            var stringId = String(param.column._0);
                            return stringId === metadataValue;
                        }, cells);
                        return Belt_Option.forEach(maybeCell, function(param) {
                            newRow[startIndex] = Belt_Option.map(param.value, DataExtraction__ExportToTable$SmartcutsMacros.resolveCellValueAsText);
                        });
                    case "extraColumn_serialized":
                        if (match === undefined) {
                            return;
                        }
                        var extraData = Curry._1(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.resolveAsText, Curry._4(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.fromExtraColumn, Belt_Result.getExn(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode(JSON.parse(metadataValue))), currentUrl, Caml_option.some(currentDateTime), undefined));
                        newRow[match.startIndex] = extraData;
                        return;
                    default:
                        return;
                }
            });
            return Belt_Array.map(newRow, function(maybeCellText) {
                return OptionUtils$SmartcutsMacros.withDefault("", maybeCellText);
            });
        });
        return wrappedAppend(rowsToAppend)(authToken, client1);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var match = result._0;
            if (typeof match === "number") {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* CouldNotGetNewOAuthToken */ 0
                });
            }
            if (match.TAG === /* MethodDidReturnUsingOriginalToken */ 0) {
                var responseBody = match._0;
                if (responseBody !== undefined) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidAppendRows */ 1,
                            _0: responseBody
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: /* EmptyResponseBodyAppendRows */ 1
                    });
                }
            }
            var responseBody$1 = match.return_;
            if (responseBody$1 !== undefined) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: {
                        TAG: /* DidAppendRows */ 1,
                        _0: responseBody$1
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* EmptyResponseBodyAppendRows */ 1
                });
            }
        } else {
            var error = result._0;
            switch(error.TAG | 0){
                case /* MethodDidThrowPromiseError */ 0:
                case /* JsExnWhileRemoveCachedOAuthToken */ 1:
                    break;
                case /* PromiseErrorWhileGetNewOAuthToken */ 2:
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: /* CouldNotGetNewOAuthToken */ 0
                    });
            }
            return Promise.resolve(handleGoogleApiHelpersError(function(errorType) {
                return {
                    TAG: /* PromiseErrorWhileAppendRows */ 3,
                    _0: errorType
                };
            }, error));
        }
    });
}
function execute(currentUrl, finalEffect) {
    var match1 = finalEffect._0;
    var rows = match1.rows;
    var maybeExtraColumns = match1.maybeExtraColumns;
    var columns = match1.columns;
    var destination = match1.destination;
    var currentDateTime = new Date();
    var spreadsheetId1;
    var worksheetName;
    if (destination.TAG === /* ExistingGoogleSheet */ 0) {
        var match$1 = destination._0;
        spreadsheetId1 = match$1.spreadsheetId;
        worksheetName = match$1.worksheetName;
    } else {
        var spreadsheetName = destination._0;
        if (spreadsheetName.TAG === /* Resolved */ 0) {
            var match$2 = spreadsheetName._0;
            spreadsheetId1 = match$2.spreadsheetId;
            worksheetName = match$2.worksheetName;
        } else {
            var spreadsheetName$1 = spreadsheetName._0;
            return GoogleSheetsPlaybackHelpers$SmartcutsMacros.getAuthTokenAndGapiClient(undefined).then(function(param7) {
                var client2 = param7[1];
                var authToken = OptionUtils$SmartcutsMacros.getExn("Expected auth token", param7[0]);
                var worksheet = GoogleApis__Sheets__Schema$SmartcutsMacros.Sheet.make(undefined, undefined, undefined, undefined, undefined, [
                    {
                        columnMetadata: undefined,
                        rowData: Belt_Array.concat([
                            makeHeaders(columns, maybeExtraColumns)
                        ], makeRowDatas(rows, currentUrl, currentDateTime, maybeExtraColumns)),
                        rowMetadata: undefined,
                        startColumn: 0,
                        startRow: 0
                    }
                ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                var wrappedCreate = function wrappedCreate(param, param$1) {
                    return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
                        return GoogleApis__Sheets$SmartcutsMacros.create(accessToken, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.Spreadsheet.make(undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.SpreadsheetProperties.make(undefined, undefined, undefined, undefined, undefined, undefined, spreadsheetName$1, undefined), [
                            worksheet
                        ], undefined, undefined, undefined), client);
                    }, param, param$1);
                };
                return wrappedCreate(authToken, client2).then(function(result) {
                    var createdSpreadsheet;
                    if (result.TAG === /* Ok */ 0) {
                        var match = result._0;
                        if (typeof match === "number") {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: /* CouldNotGetNewOAuthToken */ 0
                            });
                        }
                        if (match.TAG === /* MethodDidReturnUsingOriginalToken */ 0) {
                            var createdSpreadsheet$1 = match._0;
                            if (createdSpreadsheet$1 === undefined) {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: /* EmtpyResponseBodyCreateGoogleSheet */ 2
                                });
                            }
                            createdSpreadsheet = createdSpreadsheet$1;
                        } else {
                            var createdSpreadsheet$2 = match.return_;
                            if (createdSpreadsheet$2 === undefined) {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: /* EmtpyResponseBodyCreateGoogleSheet */ 2
                                });
                            }
                            createdSpreadsheet = createdSpreadsheet$2;
                        }
                    } else {
                        var error = result._0;
                        var exit = 0;
                        switch(error.TAG | 0){
                            case /* MethodDidThrowPromiseError */ 0:
                            case /* JsExnWhileRemoveCachedOAuthToken */ 1:
                                exit = 2;
                                break;
                            case /* PromiseErrorWhileGetNewOAuthToken */ 2:
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: /* CouldNotGetNewOAuthToken */ 0
                                });
                        }
                        if (exit === 2) {
                            return Promise.resolve(handleGoogleApiHelpersError(function(errorType) {
                                return {
                                    TAG: /* PromiseErrorWhileCreateNewGoogleSheet */ 1,
                                    _0: errorType
                                };
                            }, error));
                        }
                    }
                    var arg = Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(createdSpreadsheet.sheets, function(sheets) {
                        return Belt_Array.get(sheets, 0);
                    }), function(param) {
                        return param.properties;
                    }), function(param) {
                        return param.sheetId;
                    });
                    var sheetId = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expect to get sheetId after create spreadsheet");
                    var arg$1 = createdSpreadsheet.spreadsheetId;
                    var spreadsheetId = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    }("Expect to get spreadsheetId after create spreadsheet");
                    var arg$2 = Belt_Option.map(maybeExtraColumns, function(extraColumns) {
                        return Belt_Array.mapWithIndex(extraColumns, function(offset, extraColumn) {
                            var columnIndex = columns.length + offset | 0;
                            return {
                                metadataId: undefined,
                                metadataKey: "extraColumn_serialized",
                                metadataValue: JSON.stringify(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode(extraColumn)),
                                location: GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRange({
                                    sheetId: sheetId,
                                    dimension: "Columns",
                                    startIndex: columnIndex,
                                    endIndex: columnIndex + 1 | 0
                                }),
                                visibility: "Document"
                            };
                        });
                    });
                    var developerMetadata1 = Belt_Array.concat(Belt_Array.mapWithIndex(columns, function(columnIndex, param) {
                        return {
                            metadataId: undefined,
                            metadataKey: "columnId",
                            metadataValue: String(param.id),
                            location: GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRange({
                                sheetId: sheetId,
                                dimension: "Columns",
                                startIndex: columnIndex,
                                endIndex: columnIndex + 1 | 0
                            }),
                            visibility: "Document"
                        };
                    }), function(param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                    }([]));
                    var wrappedBatchUpdate = function wrappedBatchUpdate(param, param$1) {
                        return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
                            return GoogleApis__Sheets$SmartcutsMacros.batchUpdate(spreadsheetId, accessToken, GoogleApis__Sheets__BatchUpdate$SmartcutsMacros.RequestBody.make(Belt_Array.map(developerMetadata1, function(developerMetadata) {
                                return {
                                    createDeveloperMetadata: {
                                        developerMetadata: developerMetadata
                                    }
                                };
                            }), undefined, undefined, undefined, undefined), client);
                        }, param, param$1);
                    };
                    return wrappedBatchUpdate(authToken, client2).then(function(result2) {
                        if (result2.TAG === /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* DidCreateGoogleSheet */ 0,
                                    _0: createdSpreadsheet
                                }
                            });
                        } else {
                            return Promise.resolve(handleGoogleApiHelpersError(function(errorType) {
                                return {
                                    TAG: /* PromiseErrorWhileCreateNewGoogleSheet */ 1,
                                    _0: errorType
                                };
                            }, result2._0));
                        }
                    });
                });
            });
        }
    }
    return GoogleSheetsPlaybackHelpers$SmartcutsMacros.getAuthTokenAndGapiClient(undefined).then(function(param8) {
        var client3 = param8[1];
        var authToken = OptionUtils$SmartcutsMacros.getExn("Expected auth token", param8[0]);
        var wrappedGetValueRange = function wrappedGetValueRange(param9, param$14) {
            return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
                var arg = "'" + worksheetName + "'";
                var arg$1 = function arg$1(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7) {
                    return Curry.app(GoogleApis__Sheets__Values$SmartcutsMacros.get, [
                        accessToken,
                        param,
                        param$1,
                        param$2,
                        param$3,
                        param$4,
                        param$5,
                        param$6,
                        param$7,
                        arg,
                        spreadsheetId1
                    ]);
                };
                return Curry._4(arg$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined, undefined, undefined, client);
            }, param9, param$14);
        };
        return wrappedGetValueRange(authToken, client3).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                var maybeValueRangeWithoutEnum = result._0;
                if (typeof maybeValueRangeWithoutEnum === "number") {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: /* CouldNotGetNewOAuthToken */ 0
                    });
                } else if (maybeValueRangeWithoutEnum.TAG === /* MethodDidReturnUsingOriginalToken */ 0) {
                    return appendRowsToGoogleSheet(client3, maybeValueRangeWithoutEnum._0, spreadsheetId1, worksheetName, authToken, rows, currentUrl, currentDateTime);
                } else {
                    return appendRowsToGoogleSheet(client3, maybeValueRangeWithoutEnum.return_, spreadsheetId1, worksheetName, maybeValueRangeWithoutEnum.newToken, rows, currentUrl, currentDateTime);
                }
            }
            var error = result._0;
            switch(error.TAG | 0){
                case /* MethodDidThrowPromiseError */ 0:
                case /* JsExnWhileRemoveCachedOAuthToken */ 1:
                    break;
                case /* PromiseErrorWhileGetNewOAuthToken */ 2:
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: /* CouldNotGetNewOAuthToken */ 0
                    });
            }
            return Promise.resolve(handleGoogleApiHelpersError(function(errorType) {
                return {
                    TAG: /* PromiseErrorWhileAppendRows */ 3,
                    _0: errorType
                };
            }, error));
        });
    });
}
exports.saveRowsToDestination_encode = saveRowsToDestination_encode;
exports.saveRowsToDestination_decode = saveRowsToDestination_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.maxColumnLength = maxColumnLength;
exports.execute = execute; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 62574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Browser__Identity$SmartcutsMacros = __webpack_require__(60051);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
function getAuthTokenAndGapiClient(param) {
    return Promise.all([
        Browser__Identity$SmartcutsMacros.getAuthToken(true, false, undefined, undefined, undefined),
        GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined)
    ]);
}
exports.getAuthTokenAndGapiClient = getAuthTokenAndGapiClient; /* GoogleSheetHelpers-SmartcutsMacros Not a pure module */ 


/***/ })

}]);